webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validate_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_lang__ = __webpack_require__(75);








/* harmony default export */ __webpack_exports__["a"] = ({
  formatNumber: function formatNumber(value) {
    if (typeof value === 'undefined' || value === null) {
      return '';
    }
    var parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  getDropdownLabel: function getDropdownLabel(value, options) {
    var option = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(options, { 'value': value });
    return typeof option !== 'undefined' && 'label' in option ? option.label : value;
  },
  togglePointsLedger: function togglePointsLedger(open) {
    if (open) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').addClass('has-modal');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-points-ledger').removeClass('is-hidden');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-points-ledger').addClass('is-visible');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-points-ledger-trigger').addClass('is-active');
    } else {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').removeClass('has-modal');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-points-ledger').addClass('is-hidden');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-points-ledger').removeClass('is-visible');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-points-ledger-trigger').removeClass('is-active');
    }
  },
  shake: function shake(elem) {
    var el = elem;
    el.addClass('shake');
    el.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
      el.removeClass('shake');
    });
  },
  highlight: function highlight(id) {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).addClass('is-not-valid').removeClass('is-valid');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).focus(function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).removeClass('is-not-valid');
    });
  },
  showPassword: function showPassword(field) {
    var passwordField = field || __WEBPACK_IMPORTED_MODULE_2_jquery___default()('input[type="password"]');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(passwordField).each(function () {
      var className = this.id ? '_' + this.id : '';
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).wrap('<div class="c-password-field" />').after('<a href="#" class="c-password-field__eye js-password-toggler' + className + ' tabindex="-1""></a>').addClass('js-password-field').addClass('is-encrypted').siblings('.c-password-field__eye').addClass('t-password-eye');
    });
    var className = passwordField.attr('id') ? '_' + passwordField.attr('id') : '';
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-password-toggler' + className).click(function (e) {
      e.preventDefault();
      var $field = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).parent().find('input');
      if ($field.hasClass('is-encrypted')) {
        $field.attr('type', 'text').addClass('is-not-encrypted').removeClass('is-encrypted').siblings('.c-password-field__eye').addClass('t-password-eye--active');
      } else {
        $field.attr('type', 'password').addClass('is-encrypted').removeClass('is-not-encrypted').siblings('.c-password-field__eye').removeClass('t-password-eye--active');
      }
    });
  },
  initLoginCard: function initLoginCard(field) {
    this.showPassword(field);
  },
  isLoggedIn: function isLoggedIn() {
    return localStorage.getItem('token_' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.websiteConfig.id) !== null;
  },
  isPasswordExpired: function isPasswordExpired() {
    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.participant.is_password_expired;
  },
  requireAuth: function requireAuth(router) {
    var _this = this;

    return function (to, from, next) {
      if (_this.isLoggedIn()) {
        next();
      } else {
        router.push({ name: 'Login', params: { website: to.params.website } });
        next(false);
      }
    };
  },
  requireExpiredPassword: function requireExpiredPassword(router) {
    var _this2 = this;

    return function (to, from, next) {
      if (_this2.isLoggedIn() && _this2.isPasswordExpired()) {
        next();
      } else {
        router.push({ name: 'Dashboard' });
        next(false);
      }
    };
  },
  requireEnrollment: function requireEnrollment(router) {
    return function (to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.websiteConfig.enrollment_enabled) {
        next();
      } else {
        router.push({ name: 'NotFound', params: { website: to.params.website } });
        next(false);
      }
    };
  },
  redirectIfLoggedIn: function redirectIfLoggedIn(router) {
    var _this3 = this;

    return function (to, from, next) {
      if (_this3.isLoggedIn()) {
        router.push({ name: 'Dashboard', params: { website: to.params.website } });
        next(false);
      } else {
        next();
      }
    };
  },
  validatePassword: function validatePassword(value) {
    var exp = /^(?=.*\d)(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*_]{12,}$/g;
    var reg = new RegExp(exp);
    if (value.match(reg)) {
      return true;
    }
    return false;
  },
  validateForm: function validateForm(elem, standardFormFields, customFormFields, formValues, constraints, options) {
    var formErrors = {};
    var valid = true;
    var errors = __WEBPACK_IMPORTED_MODULE_5_validate_js___default()(formValues, constraints, options);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(standardFormFields, function (field, i) {
      if (errors && errors[field]) {
        formErrors[field] = errors[field];

        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem).find('[name="' + field + '"]').addClass('is-not-valid');
        valid = false;
      }
    });

    var validation = this.validateFields(elem, customFormFields, formValues);
    valid = validation.valid === false ? false : valid;

    var errorsMerged = {};
    if (errors) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).forEach(function (key) {
        errorsMerged[key] = [];
        errorsMerged[key].push(errors[key][0]);
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(validation.errors).forEach(function (key) {
      if (typeof errorsMerged[key] === 'undefined') {
        errorsMerged[key] = [];
      }
      errorsMerged[key].push(validation.errors[key]);
    });

    return { valid: valid, errors: errorsMerged };
  },
  handleResponseErrors: function handleResponseErrors(elem, errors) {
    var messages = {};
    for (var field in errors) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem).find('[name="' + field + '"] input').addClass('is-not-valid');
      messages[field] = errors[field];
    }
    return messages;
  },
  validateFields: function validateFields(el, formFields, formValues) {
    var _this4 = this;

    var valid = true;
    var errors = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(formFields, function (field, i) {
      var input = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(el).find('[name="' + field.name + '"] input');
      var error = _this4.validateField(field, formValues[field.name], input[0]);
      if (error !== '') {
        errors[field.name] = error;

        input.addClass('is-not-valid');
        valid = false;
      }
    });
    return { valid: valid, errors: errors };
  },
  validateField: function validateField(field, value, input) {
    var error = '';

    if (['integer', 'currency', 'decimal', 'percent', 'date'].includes(field.type)) {
      error = input === undefined ? '' : input.validationMessage;
      if (field.type === 'date' && error !== '') {
        error = __WEBPACK_IMPORTED_MODULE_6__resources_lang__["a" /* default */].t('utils.validation.date_format', { attribute: field.label, format: 'MM/DD/YYYY' });
      } else if (['integer', 'currency', 'decimal', 'percent'].includes(field.type) && (value || value === 0)) {

        var validators = {
          integer: {
            expr: /^([0]|-?[1-9][0-9]{0,9})?$/,
            messageKey: 'utils.validation.integer_invalid'
          },
          currency: {
            expr: /^([0]|-?[1-9][0-9]{0,7})(\.\d{1,2})?$/,
            messageKey: 'utils.validation.currency_invalid'
          },
          decimal: {
            expr: /^([0]|-?[1-9][0-9]{0,12})(\.\d{0,13})?$/,
            messageKey: 'utils.validation.decimal_invalid'
          },
          percent: {
            expr: /^([0]|-?[1-9][0-9]{0,13})(\.\d{0,13})?$/,
            messageKey: 'utils.validation.percent_invalid'
          }
        };

        if (!validators[field.type].expr.test(value)) {
          error = __WEBPACK_IMPORTED_MODULE_6__resources_lang__["a" /* default */].t(validators[field.type].messageKey);
        } else if (['decimal', 'percent'].includes(field.type) && value) {
          error = '';
        }
      }
    }
    if (field.required && (field.type === 'bool' || error === '') && !value) {
      error = __WEBPACK_IMPORTED_MODULE_6__resources_lang__["a" /* default */].t('utils.validation.required', { attribute: field.label });
    }

    if (field.type === 'email' && value) {
      var errors = __WEBPACK_IMPORTED_MODULE_5_validate_js___default()({ 'email': value }, {
        'email': {
          'email': {
            message: __WEBPACK_IMPORTED_MODULE_6__resources_lang__["a" /* default */].t('utils.validation.email')
          }
        }
      }, { 'fullMessages': false, 'format': 'flat' });
      if (errors) {
        error = errors[0].replace('{attribute}', field.label);
      }
    }
    return error;
  },
  addRoutes: function addRoutes(router, routes, isVanityUrl) {
    if (isVanityUrl) {
      router.addRoutes(routes);
    } else {
      router.addRoutes([{
        path: '/:website',
        component: {
          render: function render(c) {
            return c('router-view');
          }
        },
        children: routes
      }]);
    }
  },
  addImageLinksForMobile: function addImageLinksForMobile(platformImages) {
    this.addImageLinkToDocumentHead('apple-touch-icon', platformImages.apple_touch_icon, false, 'apple-icon');
    this.addImageLinkToDocumentHead('icon', platformImages.favicon_android, false, 'android-icon');
    this.addImageLinkToDocumentHead('icon', platformImages.favicon_android, '192x192', 'android-icon-192');
    this.addImageLinkToDocumentHead('icon', platformImages.favicon_android, '128x128', 'android-icon-128');
  },
  addImageLinkToDocumentHead: function addImageLinkToDocumentHead(rel, href, sizes, id) {
    var link = document.createElement('link');
    link.type = 'image/png';
    link.rel = rel;
    link.href = href;
    link.id = id;
    if (sizes) {
      link.sizes = sizes;
    }
    document.head.appendChild(link);
  },
  removePlatformSpecificHeaderElements: function removePlatformSpecificHeaderElements() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('link[rel=stylesheet][title=custom_css]').prop('disabled', true);
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#apple-icon').prop('disabled', true);
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#android-icon').prop('disabled', true);
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#android-icon-192').prop('disabled', true);
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#android-icon-128').prop('disabled', true);
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('link[rel=stylesheet][title=custom_css]').remove();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#apple-icon').remove();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#android-icon').remove();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#android-icon-192').remove();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#android-icon-128').remove();
  },
  addCustomCssFile: function addCustomCssFile(websiteConfig) {
    var href = '';
    if (websiteConfig.custom_platform_css_file) {
      href = "https://cgip-website-prod.creativegroupinc.com" + '/' + websiteConfig.custom_platform_css_file;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<link/>', { rel: 'stylesheet', title: 'custom_css', href: href }).appendTo('head');
    }
    if (websiteConfig.custom_program_css_files) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(websiteConfig.custom_program_css_files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var customProgramCssFile = _step.value;

          href = "https://cgip-website-prod.creativegroupinc.com" + '/' + customProgramCssFile;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<link/>', { rel: 'stylesheet', title: 'custom_css', href: href }).appendTo('head');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  updateWebsiteTitle: function updateWebsiteTitle(title) {
    document.title = title;
  },
  addPlatformLanguage: function addPlatformLanguage(lang) {
    if (typeof lang !== 'undefined') {
      var localeMessages = __WEBPACK_IMPORTED_MODULE_6__resources_lang__["a" /* default */].getLocaleMessage('en-US');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(lang, function (value, key) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["set"])(localeMessages, key, value);
      });
      __WEBPACK_IMPORTED_MODULE_6__resources_lang__["a" /* default */].setLocaleMessage('en-US', localeMessages);
    }
  },
  closeModals: function closeModals() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').removeClass('has-modal');
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('UPDATE_CLAIM_MODAL_SHOW', false);
  },
  getDataToBeSaved: function getDataToBeSaved(fields, model) {
    var _this5 = this;

    var data = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(fields, function (field, i) {
      data[field.name] = _this5.formatFieldValueForApi(field, model[field.name]);
    });
    return data;
  },
  formatFieldValueForApi: function formatFieldValueForApi(field, value) {
    if (typeof value === 'undefined') {
      value = null;
    }

    switch (field.type) {
      case 'date':
        if (/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(value)) {
          var dateParts = value.split('/');
          var month = dateParts[0];
          var day = dateParts[1];
          var year = dateParts[2];
          value = [year, month, day].join('-');
        }
        break;
      case 'bool':
        if (value === null) {
          value = 0;
        }
        break;
    }
    return value;
  },
  logoutFromBrowser: function logoutFromBrowser(commit, router, websiteId) {
    localStorage.removeItem('token_' + websiteId);
    localStorage.removeItem('impersonate_' + websiteId);
    commit('UPDATE_LOGIN_STATUS', false);
    commit('UPDATE_PARTICIPANT', {
      first_name: '',
      last_name: ''
    });
    window.location.href = router.resolve('login').href;
  },
  getPagination: function getPagination(current, last) {
    var pages = [];
    var first = 1;
    var distance = 2;
    if (last <= 5) {
      for (var i = 1; i <= last; i++) {
        pages.push(i);
      }
      return pages;
    }
    if (current - first <= distance) {
      for (var _i = first; _i <= first + distance; _i++) {
        pages.push(_i);
      }
    } else if (current - first > distance) {
      pages.push(first);
      pages.push('...');
    }
    if (current !== first && current !== last) {
      for (var _i2 = current - 1; _i2 <= current + 1; _i2++) {
        if (pages.indexOf(_i2) === -1) {
          pages.push(_i2);
        }
      }
    }
    if (last - current <= distance) {
      for (var _i3 = last - distance; _i3 <= last; _i3++) {
        if (pages.indexOf(_i3) === -1) {
          pages.push(_i3);
        }
      }
    } else if (last - current > distance) {
      pages.push('...');
      pages.push(last);
    }
    return pages;
  },
  getPageMap: function getPageMap(perPageCount, pages, topGroup, bottomGroup) {
    var map = [];

    var pageCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["last"])(pages);

    for (var pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
      var topGroupCount = 0;
      var bottomGroupCount = 0;
      var bottomGroupMax = 0;

      if (topGroup >= perPageCount) {
        topGroupCount = perPageCount;
        topGroup -= perPageCount;
        bottomGroupMax = 0;
      } else if (topGroup < perPageCount) {
        topGroupCount = topGroup;
        topGroup = 0;
        bottomGroupMax = perPageCount - topGroupCount;
      }

      if (bottomGroup >= bottomGroupMax) {
        bottomGroupCount = bottomGroupMax;
        bottomGroup -= bottomGroupMax;
      } else if (bottomGroup < bottomGroupMax) {
        bottomGroupCount = bottomGroup;
        bottomGroup = 0;
      }

      var page = {
        pageNumber: pageNumber,
        topGroupCount: topGroupCount,
        bottomGroupCount: bottomGroupCount
      };

      map[pageNumber] = page;

      if (pageNumber === 1) {
        map[pageNumber].topGroupStart = 0;
        map[pageNumber].bottomGroupStart = 0;
      } else {
        var previous = pageNumber - 1;
        map[pageNumber].topGroupStart = map[pageNumber].topGroupCount === 0 ? 0 : map[previous].topGroupCount + map[previous].topGroupStart;
        map[pageNumber].bottomGroupStart = map[pageNumber].bottomGroupCount === 0 ? 0 : map[previous].bottomGroupCount + map[previous].bottomGroupStart;
      }
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["omitBy"])(map, __WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"]);
  },
  getParticipantPosition: function getParticipantPosition(id, records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i][0].id === id) {
        return i;
      }
    }
    return null;
  },
  triggerFileDownload: function triggerFileDownload(data, filename, downloadType) {
    var forceDownload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var blob = new Blob([data], { type: downloadType });

    if (window.navigator && window.navigator.msSaveBlob && window.navigator.msSaveOrOpenBlob) {
      if (forceDownload) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      }
    } else {
      var _data = window.URL.createObjectURL(blob);
      var link = window.document.createElement('a');
      link.setAttribute('href', _data);
      if (forceDownload) {
        link.setAttribute('download', filename);
      } else {
        link.setAttribute('target', '_blank');
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);

        window.URL.revokeObjectURL(_data);
      }, 100);
    }
  },
  handleLink: function handleLink(e, websiteConfig, router) {
    var baseUrl = websiteConfig.vanity_url ? window.location.protocol + '//' + websiteConfig.external_url + '/' : window.location.protocol + '//' + window.location.hostname + '/' + websiteConfig.url;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["startsWith"])(e.currentTarget.href, baseUrl)) {
      e.preventDefault();
      var url = websiteConfig.vanity_url ? '/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["replace"])(e.currentTarget.href, baseUrl, '') : '/' + websiteConfig.url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["replace"])(e.currentTarget.href, baseUrl, '');
      router.push(url);
    }
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







var API = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://cgip-website-prod.creativegroupinc.com" + '/api/platform/v1/'
});

API.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.status === 401 && error.response.data === 'user.inactive') {
    __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].logoutFromBrowser(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit, __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.id);
  }
  if (error.response && error.response.status === 404 && error.response.data === 'user.no-catalog') {
    if (__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name === 'Single Reward') {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'RewardUnavailable', replace: true, params: { website: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.params.website } });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ path: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.path + '-' });
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

API.getWithOptionalAuthentication = function (url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var token = localStorage.getItem('token_' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.id);
  var authHeader = token != null ? { headers: { 'Authorization': 'Bearer ' + token } } : {};
  var params = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.merge({}, authHeader, options);
  return API.get(url, params);
};

API.getAuthenticated = function (url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var token = localStorage.getItem('token_' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.id);
  var authHeader = { headers: { 'Authorization': 'Bearer ' + token } };
  var params = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.merge({}, authHeader, options);
  return API.get(url, params);
};

API.postAuthenticated = function (url, data) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var token = localStorage.getItem('token_' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.id);
  headers.Authorization = 'Bearer ' + token;
  return API.post(url, data, { headers: headers });
};

API.putAuthenticated = function (url, data) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var token = localStorage.getItem('token_' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.id);
  headers.Authorization = 'Bearer ' + token;
  return API.put(url, data, { headers: headers });
};

API.deleteAuthenticated = function (url) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var token = localStorage.getItem('token_' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.id);
  headers.Authorization = 'Bearer ' + token;
  return API.delete(url, { headers: headers });
};

/* harmony default export */ __webpack_exports__["a"] = (API);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  "data-v-0c87f958",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  "data-v-69858478",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entities_participant__ = __webpack_require__(263);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = false === true;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  state: {
    appName: 'Platform Website',
    loggedIn: false,
    websiteConfig: {
      vanity_url: false,
      id: null,
      name: '',
      launch_date: null,
      close_date: null,
      enable_enrollment: 0,
      enrollment_start: null,
      enrollment_end: null,
      url: null,
      external_url: null
    },
    participant: __WEBPACK_IMPORTED_MODULE_5__entities_participant__["a" /* default */],
    participantSetup: __WEBPACK_IMPORTED_MODULE_5__entities_participant__["a" /* default */],
    programs: [],
    programDetails: {},
    programDashboard: {
      programs: []
    },
    cards: {},
    dashboardLayout: [],
    pageDetails: {},
    platformPointCap: {
      pointCap: 0,
      pointsSpentInPeriod: 0
    },
    points: {
      data: [],
      total: 0
    },
    categories: null,
    categoryDetails: null,
    rewards: {
      items: null,
      pagination: null
    },
    rewardDetails: null,
    rewardFilters: [],
    approverClaims: [],
    submitterClaims: [],
    reportData: {},
    chartData: {},
    claimModalData: {},
    claimModalShow: false,
    claimModalType: '',
    claimModalMessage: null,
    savedRewards: [],
    leaderboardModalData: {},
    leaderboardModalShow: false
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__,
  modules: {},
  plugins: []
}));

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  "data-v-7a152cba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLAIM_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLAIM_STATUS_TRANSLATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);



var _Object$freeze2;

var CLAIM_STATUS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  PENDING: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  UPDATE_NEEDED: 'update_needed'
});

var CLAIM_STATUS_TRANSLATION = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()((_Object$freeze2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze2, CLAIM_STATUS.PENDING, 'fields.performancerecord_approval_status.options.pending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze2, CLAIM_STATUS.APPROVED, 'fields.performancerecord_approval_status.options.approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze2, CLAIM_STATUS.DECLINED, 'fields.performancerecord_approval_status.options.declined'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Object$freeze2, CLAIM_STATUS.UPDATE_NEEDED, 'fields.performancerecord_approval_status.options.update_needed'), _Object$freeze2));

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(468);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en-US',

  messages: {
    'en-US': {
      web: {
        not_found: {
          card_header: 'Page not found!'
        }
      }
    }
  },
  silentTranslationWarn: "production" === 'testing'
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Login__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Dashboard__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFound__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_RewardUnavailable__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_RewardUnavailable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_RewardUnavailable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Settings__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Program__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Program___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Program__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_SavedRewards__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_SavedRewards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_SavedRewards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_ResetPassword__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_ForgotPassword__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_AccountSetup__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_AccountSetup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_AccountSetup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Page__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Signup__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_RewardsDashboard__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_RewardsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_RewardsDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Impersonate__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Impersonate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Impersonate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_RewardsResults__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_RewardsResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_RewardsResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_RewardsSingle__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_RewardsSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_RewardsSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_MyOrders__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_MyOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_MyOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_ProgramDashboard__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_ProgramDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_ProgramDashboard__);

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  getRoutes: function getRoutes(isVanityUrl, customRoutes, router) {
    var routes = [{
      path: '/',
      redirect: { name: 'Login' }
    }, {
      path: (isVanityUrl ? '/' : '') + 'login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_5__views_Login___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].redirectIfLoggedIn(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Dashboard___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'settings',
      name: 'Settings',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Settings___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'program/:id',
      name: 'Program',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Program___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'rewards',
      name: 'Rewards',
      component: __WEBPACK_IMPORTED_MODULE_17__views_RewardsDashboard___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'rewards/results',
      name: 'Rewards Results',
      component: __WEBPACK_IMPORTED_MODULE_19__views_RewardsResults___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'rewards/:id',
      name: 'Single Reward',
      component: __WEBPACK_IMPORTED_MODULE_20__views_RewardsSingle___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'orders',
      name: 'MyOrders',
      component: __WEBPACK_IMPORTED_MODULE_21__views_MyOrders___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'saved-rewards',
      name: 'SavedRewards',
      component: __WEBPACK_IMPORTED_MODULE_11__views_SavedRewards___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'rewards-unavailable',
      name: 'RewardUnavailable',
      component: __WEBPACK_IMPORTED_MODULE_8__views_RewardUnavailable___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'signup',
      name: 'Signup',
      component: __WEBPACK_IMPORTED_MODULE_16__views_Signup___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireEnrollment(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'reset-password/:email/:token',
      name: 'ResetPassword',
      component: __WEBPACK_IMPORTED_MODULE_12__views_ResetPassword___default.a
    }, {
      path: (isVanityUrl ? '/' : '') + 'expired-password',
      name: 'ExpiredPassword',
      component: __WEBPACK_IMPORTED_MODULE_12__views_ResetPassword___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireExpiredPassword(router)
    }, {
      path: (isVanityUrl ? '/' : '') + 'impersonate',
      name: 'Impersonate',
      component: __WEBPACK_IMPORTED_MODULE_18__views_Impersonate___default.a
    }, {
      path: (isVanityUrl ? '/' : '') + 'forgot-password',
      name: 'ForgotPassword',
      component: __WEBPACK_IMPORTED_MODULE_13__views_ForgotPassword___default.a
    }, {
      path: (isVanityUrl ? '/' : '') + 'account-setup/:token',
      name: 'AccountSetup',
      component: __WEBPACK_IMPORTED_MODULE_14__views_AccountSetup___default.a
    }, {
      path: (isVanityUrl ? '/' : '') + 'program-dashboard/:id',
      name: 'ProgramDashboard',
      component: __WEBPACK_IMPORTED_MODULE_22__views_ProgramDashboard___default.a,
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router)
    }];

    for (var i = 0; i < customRoutes.length; i++) {
      var customRoute = {
        path: (isVanityUrl ? '/' : '') + customRoutes[i].url,
        name: 'Page_' + customRoutes[i].id,
        component: __WEBPACK_IMPORTED_MODULE_15__views_Page___default.a,
        meta: {
          id: customRoutes[i].id,
          name: customRoutes[i].title
        },
        props: { id: customRoutes[i].id }
      };
      if (customRoutes[i].availability === 'logged_in') {
        customRoute.beforeEnter = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].requireAuth(router);
      }
      routes.push(customRoute);
    }

    routes.push({
      path: (isVanityUrl ? '/' : '') + '*',
      name: 'NotFound',
      component: __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default.a
    });

    return routes;
  }
});

var shouldCallApi = function shouldCallApi(to) {
  if (to.name === 'NotFound') {
    return false;
  }

  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.url === null) {
    return true;
  }

  if (typeof to.params.website !== 'undefined' && to.params.website !== __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteConfig.url) {
    return true;
  }

  return false;
};

router.beforeEach(function (to, from, next) {
  var ignoreOnExpiredPassword = ['Impersonate', 'ExpiredPassword'];

  if (!ignoreOnExpiredPassword.includes(to.name) && __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].isLoggedIn() && __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].isPasswordExpired()) {
    next({ name: 'ExpiredPassword', params: { website: to.params.website } });
    return;
  }

  if (shouldCallApi(to)) {
    __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].get('website-config?url=' + encodeURIComponent(window.location.href)).then(function (response) {
      var websiteConfig = response.data.websiteConfig;

      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('UPDATE_WEBSITE_CONFIG', websiteConfig);
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('UPDATE_LOGIN_STATUS', __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].isLoggedIn());
      __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].removePlatformSpecificHeaderElements();
      __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].updateWebsiteTitle(websiteConfig.name);

      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('WEBSITE_CONFIG_AUTH_UPDATE', router).then(function () {
        var nextObject = { path: to.path, replace: true };
        if (to.query) {
          nextObject.query = to.query;
        }
        next(nextObject);
      });
    }).catch(function (err) {
      if (err.response.status === 404) {
        var isVanityUrl = window.location.hostname !== "participant-portal.ips.creativegroupinc.com";
        router.addRoutes([{
          path: (isVanityUrl ? '/' : '') + '*',
          name: 'NotFound',
          component: __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default.a
        }]);
        next({ name: 'NotFound' });
      }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].closeModals();
    next();
  }
});

router.beforeResolve(function (to, from, next) {
  var nonLoggableUrls = ['ResetPassword', 'AccountSetup', 'Impersonate'];
  if (to.name !== null && nonLoggableUrls.indexOf(to.name) === -1 && __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].isLoggedIn()) {
    var eventData = {};
    eventData.details = to.fullPath;
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('LOG_EVENT', eventData);
  }

  var pax = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.participant;
  var rewardRoutes = ['Rewards', 'Rewards Results', 'Single Reward', 'SavedRewards'];
  if (!pax.catalog_is_enabled && to.name !== null && rewardRoutes.indexOf(to.name) !== -1) {
    if (to.name === 'Single Reward') {
      next({ name: 'RewardUnavailable', replace: true, params: { website: to.params.website } });
    } else {
      next({ path: to.path + '-', replace: true });
    }
    return;
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  "data-v-959131e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(557),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  "data-v-a73e6350",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  "data-v-708ce4be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-22762e46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  "data-v-7a093616",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_object_assign_auto__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_object_assign_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_object_assign_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_AppFooter__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_AppNavigation__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_AppNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_components_AppNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_cards_ClaimForms__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_cards_ClaimForms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_components_cards_ClaimForms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_cards_ClaimsApprover__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_cards_ClaimsApprover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_components_cards_ClaimsApprover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_cards_ClaimsSubmitter__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_cards_ClaimsSubmitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_components_cards_ClaimsSubmitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_cards_Content__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_cards_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_components_cards_Content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_cards_DynamicContent__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_cards_DynamicContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_components_cards_DynamicContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_cards_Leaderboard__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_cards_Leaderboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_components_cards_Leaderboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_cards_Quizzes__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_cards_Quizzes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_components_cards_Quizzes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_cards_Report__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_cards_Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_components_cards_Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_cards_Target__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_cards_Target___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_components_cards_Target__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_components_cards_Tier__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_components_cards_Tier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_components_cards_Tier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_components_cards_Chart__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_components_cards_Chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_components_cards_Chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_components_LoadingIcon__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_components_LoadingIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_components_LoadingIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_components_cards_MultiCard__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_components_cards_MultiCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_components_cards_MultiCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_portal_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__resources_lang__ = __webpack_require__(75);

























__WEBPACK_IMPORTED_MODULE_21_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].config.devtools = false === true;
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].config.performance = false === true;

__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('app-navigation', __WEBPACK_IMPORTED_MODULE_4__views_components_AppNavigation___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('app-footer', __WEBPACK_IMPORTED_MODULE_3__views_components_AppFooter___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('loading-icon', __WEBPACK_IMPORTED_MODULE_16__views_components_LoadingIcon___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-claim-forms', __WEBPACK_IMPORTED_MODULE_5__views_components_cards_ClaimForms___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-claims-approver', __WEBPACK_IMPORTED_MODULE_6__views_components_cards_ClaimsApprover___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-claims-submitter', __WEBPACK_IMPORTED_MODULE_7__views_components_cards_ClaimsSubmitter___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-content', __WEBPACK_IMPORTED_MODULE_8__views_components_cards_Content___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-dynamic-content', __WEBPACK_IMPORTED_MODULE_9__views_components_cards_DynamicContent___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-target', __WEBPACK_IMPORTED_MODULE_13__views_components_cards_Target___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-leaderboard', __WEBPACK_IMPORTED_MODULE_10__views_components_cards_Leaderboard___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-quizzes', __WEBPACK_IMPORTED_MODULE_11__views_components_cards_Quizzes___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-tier', __WEBPACK_IMPORTED_MODULE_14__views_components_cards_Tier___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-report', __WEBPACK_IMPORTED_MODULE_12__views_components_cards_Report___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-multi-card', __WEBPACK_IMPORTED_MODULE_17__views_components_cards_MultiCard___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue__["default"].component('card-chart', __WEBPACK_IMPORTED_MODULE_15__views_components_cards_Chart___default.a);

__WEBPACK_IMPORTED_MODULE_21_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_portal_vue___default.a);

new __WEBPACK_IMPORTED_MODULE_21_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_22__resources_lang__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PASSWORD", function() { return RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_EXPIRED_PASSWORD", function() { return RESET_EXPIRED_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEND_FORGOT_PASSWORD", function() { return SEND_FORGOT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PARTICIPANT", function() { return LOAD_PARTICIPANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_DASHBOARD", function() { return LOAD_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PROGRAMS", function() { return LOAD_PROGRAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PROGRAM", function() { return LOAD_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PROGRAM_DASHBOARD", function() { return LOAD_PROGRAM_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PAGE", function() { return LOAD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_CARD", function() { return LOAD_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_POINTS_LEDGER", function() { return LOAD_POINTS_LEDGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_REWARD_FILTERS", function() { return GET_REWARD_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CATEGORIES", function() { return GET_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_REWARDS", function() { return GET_REWARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_REWARD", function() { return GET_REWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PARTICIPANT_BY_TOKEN", function() { return LOAD_PARTICIPANT_BY_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_WEBSITE_LANG", function() { return UPDATE_WEBSITE_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEND_ACCOUNT_SETUP", function() { return SEND_ACCOUNT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_WEBSITE_CONFIG", function() { return GET_WEBSITE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WEBSITE_CONFIG_AUTH_UPDATE", function() { return WEBSITE_CONFIG_AUTH_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_APPROVER_CLAIM", function() { return LOAD_APPROVER_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESEND_ACCOUNT_SETUP_EMAIL", function() { return RESEND_ACCOUNT_SETUP_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_SUBMITTER_CLAIM", function() { return LOAD_SUBMITTER_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SUBMITTER_CLAIM", function() { return UPDATE_SUBMITTER_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WITHDRAW_CLAIM", function() { return WITHDRAW_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGN_UP", function() { return SIGN_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_SAVED_REWARDS", function() { return DELETE_SAVED_REWARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_SAVED_REWARDS", function() { return GET_SAVED_REWARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_SAVED_REWARD", function() { return ADD_SAVED_REWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOG_EVENT", function() { return LOG_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PLATFORM_POINT_CAP", function() { return LOAD_PLATFORM_POINT_CAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);





var LOGIN = function LOGIN(_ref, request) {
  var commit = _ref.commit,
      state = _ref.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].post('/oauth/token', request).then(function (resp) {
    localStorage.setItem('token_' + state.websiteConfig.id, resp.data.access_token);
    localStorage.setItem('impersonate_' + state.websiteConfig.id, false);
    commit('UPDATE_LOGIN_STATUS', true);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
      type: err.response.data.error,
      message: err.response.data.message
    });
  });
};

var RESET_PASSWORD = function RESET_PASSWORD(_ref2, request) {
  var commit = _ref2.commit;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].post('/password/reset', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var RESET_EXPIRED_PASSWORD = function RESET_EXPIRED_PASSWORD(_ref3, request) {
  var commit = _ref3.commit;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].postAuthenticated('/password/expired', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var SEND_FORGOT_PASSWORD = function SEND_FORGOT_PASSWORD(_ref4, request) {
  var commit = _ref4.commit;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].post('/password/email', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOGOUT = function LOGOUT(_ref5, router) {
  var commit = _ref5.commit,
      state = _ref5.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/logout').then(function (resp) {
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].logoutFromBrowser(commit, router, state.websiteConfig.id);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PARTICIPANT = function LOAD_PARTICIPANT(_ref6, router) {
  var commit = _ref6.commit,
      state = _ref6.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/me').then(function (resp) {
    commit('UPDATE_PARTICIPANT', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].logoutFromBrowser(commit, router, state.websiteConfig.id);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_DASHBOARD = function LOAD_DASHBOARD(_ref7) {
  var commit = _ref7.commit,
      state = _ref7.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/dashboard').then(function (resp) {
    commit('UPDATE_DASHBOARD', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PROGRAMS = function LOAD_PROGRAMS(_ref8) {
  var commit = _ref8.commit,
      state = _ref8.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/programs').then(function (resp) {
    commit('UPDATE_PROGRAMS', resp.data.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PROGRAM = function LOAD_PROGRAM(_ref9, id) {
  var commit = _ref9.commit,
      state = _ref9.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/programs/' + id).then(function (resp) {
    commit('UPDATE_PROGRAM_DETAILS', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PROGRAM_DASHBOARD = function LOAD_PROGRAM_DASHBOARD(_ref10, id) {
  var commit = _ref10.commit,
      state = _ref10.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/program-dashboard/' + id).then(function (resp) {
    commit('UPDATE_PROGRAM_DASHBOARD', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PAGE = function LOAD_PAGE(_ref11, id) {
  var commit = _ref11.commit,
      state = _ref11.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getWithOptionalAuthentication('/pages/' + id).then(function (resp) {
    commit('UPDATE_PAGE_DETAILS', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PLATFORM_POINT_CAP = function LOAD_PLATFORM_POINT_CAP(_ref12) {
  var commit = _ref12.commit,
      state = _ref12.state;

  var participantId = state.participant.id;
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getWithOptionalAuthentication('/point-cap/' + participantId).then(function (resp) {
    commit('UPDATE_PLATFORM_POINT_CAP_DETAILS', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_CARD = function LOAD_CARD(_ref13, _ref14) {
  var commit = _ref13.commit,
      state = _ref13.state;
  var id = _ref14.id,
      query = _ref14.query;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/cards/' + id + '?' + query).then(function (resp) {
    resp.data.cardLoaded = true;
    commit('UPDATE_CARD_DETAILS', resp.data);
    switch (resp.data.type) {
      case 'claims-approver':
        commit('UPDATE_APPROVER_CLAIMS', resp.data.claims);
        break;
      case 'claims-submitter':
        commit('UPDATE_SUBMITTER_CLAIMS', resp.data.claims);
        break;
      case 'leaderboard':
      case 'report':
        commit('UPDATE_REPORT_DATA', resp.data);
        break;
      case 'chart':
        commit('UPDATE_CHART_DATA', resp.data);
        break;
      default:
        break;
    }
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_POINTS_LEDGER = function LOAD_POINTS_LEDGER(_ref15, request) {
  var commit = _ref15.commit,
      state = _ref15.state;

  var query = new URLSearchParams(request);
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/points?' + query).then(function (resp) {
    commit('UPDATE_POINTS', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var GET_REWARD_FILTERS = function GET_REWARD_FILTERS(_ref16, request) {
  var commit = _ref16.commit,
      state = _ref16.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/rewards/filters', { params: request }).then(function (resp) {
    commit('UPDATE_REWARD_FILTERS', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

var GET_CATEGORIES = function GET_CATEGORIES(_ref17, request) {
  var commit = _ref17.commit,
      state = _ref17.state;

  var query = new URLSearchParams(request);
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/rewards/categories?' + query).then(function (resp) {
    commit('UPDATE_CATEGORIES', resp.data.categories);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var GET_REWARDS = function GET_REWARDS(_ref18, request) {
  var commit = _ref18.commit,
      state = _ref18.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/rewards', { params: request }).then(function (response) {
    commit('UPDATE_REWARDS', response.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

var GET_REWARD = function GET_REWARD(_ref19, id) {
  var commit = _ref19.commit,
      state = _ref19.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/rewards/' + id).then(function (resp) {
    commit('UPDATE_PRODUCT_DETAIL', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_PARTICIPANT_BY_TOKEN = function LOAD_PARTICIPANT_BY_TOKEN(_ref20, inviteToken) {
  var commit = _ref20.commit,
      state = _ref20.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/participants/invite/' + inviteToken).then(function (resp) {
    commit('UPDATE_PARTICIPANT_SETUP', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var UPDATE_WEBSITE_LANG = function UPDATE_WEBSITE_LANG(_ref21, paxId) {
  var commit = _ref21.commit,
      state = _ref21.state;

  var url = 'website-config-lang/' + state.websiteConfig.id + '?pax_id=' + paxId;
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getWithOptionalAuthentication(url).then(function (_ref22) {
    var data = _ref22.data;

    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].addPlatformLanguage(data);
    commit('UPDATE_WEBSITE_CONFIG', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.websiteConfig, {
      language: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.websiteConfig.language, data)
    }));
  });
};

var SEND_ACCOUNT_SETUP = function SEND_ACCOUNT_SETUP(_ref23, request) {
  var commit = _ref23.commit;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].post('/participants/setup', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var SIGN_UP = function SIGN_UP(_ref24, request) {
  var commit = _ref24.commit;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].post('/participants/signup', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var GET_WEBSITE_CONFIG = function GET_WEBSITE_CONFIG(_ref25, router) {
  var commit = _ref25.commit,
      state = _ref25.state;

  var browserLang = window.navigator.language;
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].get('website-config?url=' + encodeURIComponent(window.location.href) + '&lang=' + browserLang + '&prefix=signup').then(function (response) {
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].addPlatformLanguage(response.data.websiteConfig.language);
    commit('UPDATE_WEBSITE_CONFIG', response.data.websiteConfig);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

var WEBSITE_CONFIG_AUTH_UPDATE = function WEBSITE_CONFIG_AUTH_UPDATE(_ref26, router) {
  var commit = _ref26.commit,
      state = _ref26.state;

  var url = 'website-config-auth/' + state.websiteConfig.id + '?include_fields=1';
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getWithOptionalAuthentication(url).then(function (resp) {
    var websiteConfig = state.websiteConfig;

    websiteConfig.nav_footer = resp.data.websiteConfigAuth.nav_footer;
    websiteConfig.left_nav_menu = resp.data.websiteConfigAuth.left_nav_menu;
    websiteConfig.language = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, resp.data.websiteConfigAuth.language, resp.data.websiteConfigAuth.fields || {});
    websiteConfig.metadata = resp.data.websiteConfigAuth.metadata;
    websiteConfig.profile = resp.data.websiteConfigAuth.profile;
    websiteConfig.custom_platform_css_file = resp.data.websiteConfigAuth.custom_platform_css_file;
    websiteConfig.custom_program_css_files = resp.data.websiteConfigAuth.custom_program_css_files;
    websiteConfig.platform_images = resp.data.websiteConfigAuth.platform_images || websiteConfig.platform_images;

    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].removePlatformSpecificHeaderElements();
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].addImageLinksForMobile(websiteConfig.platform_images);

    if (resp.data.websiteConfigAuth.participant) {
      commit('UPDATE_PARTICIPANT', resp.data.websiteConfigAuth.participant);
    }
    commit('UPDATE_PROGRAM_IMAGES', resp.data.websiteConfigAuth.program_images);
    commit('UPDATE_WEBSITE_CONFIG', websiteConfig);

    var isVanityUrl = window.location.hostname !== "participant-portal.ips.creativegroupinc.com";
    var customRoutes = resp.data.websiteConfigAuth.pages.data;
    var routes = router.options.getRoutes(isVanityUrl, customRoutes, router);

    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].addRoutes(router, routes, isVanityUrl);
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].addPlatformLanguage(websiteConfig.language);
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].addCustomCssFile(websiteConfig);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var RESEND_ACCOUNT_SETUP_EMAIL = function RESEND_ACCOUNT_SETUP_EMAIL(_ref27, request) {
  var commit = _ref27.commit;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].post('/participants/resend', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_APPROVER_CLAIM = function LOAD_APPROVER_CLAIM(_ref28, id) {
  var commit = _ref28.commit,
      state = _ref28.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/claims/approver/' + id).then(function (resp) {
    commit('UPDATE_APPROVER_CLAIM', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOAD_SUBMITTER_CLAIM = function LOAD_SUBMITTER_CLAIM(_ref29, id) {
  var commit = _ref29.commit,
      state = _ref29.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/claims/submitter/' + id).then(function (resp) {
    commit('UPDATE_SUBMITTER_CLAIM', resp.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var UPDATE_SUBMITTER_CLAIM = function UPDATE_SUBMITTER_CLAIM(_ref30, request) {
  var commit = _ref30.commit,
      state = _ref30.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].postAuthenticated('/claim-forms/update/' + request.id, request.data).then(function (resp) {
    commit('UPDATE_SUBMITTER_CLAIM', resp.data.record);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var WITHDRAW_CLAIM = function WITHDRAW_CLAIM(_ref31, id) {
  var commit = _ref31.commit,
      state = _ref31.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].deleteAuthenticated('/claim-forms/' + id).then(function (resp) {
    commit('WITHDRAW_CLAIM', resp.data.id);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var DELETE_SAVED_REWARDS = function DELETE_SAVED_REWARDS(_ref32, id) {
  var commit = _ref32.commit,
      state = _ref32.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].deleteAuthenticated('/rewards/saved-rewards/' + id).then(function (resp) {
    commit('DELETE_SAVED_REWARD', id);
    commit('UPDATE_PRODUCT_SAVEDREWARD_ID', null);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var GET_SAVED_REWARDS = function GET_SAVED_REWARDS(_ref33) {
  var commit = _ref33.commit,
      state = _ref33.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/rewards/saved-rewards').then(function (resp) {
    commit('UPDATE_SAVED_REWARDS', resp.data.data);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var ADD_SAVED_REWARD = function ADD_SAVED_REWARD(_ref34, request) {
  var commit = _ref34.commit,
      state = _ref34.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].postAuthenticated('/rewards/saved-rewards', request).then(function (resp) {
    commit('UPDATE_SAVED_REWARD', resp.data.record);
    commit('UPDATE_PRODUCT_SAVEDREWARD_ID', resp.data.record.id);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};

var LOG_EVENT = function LOG_EVENT(_ref35, request) {
  var commit = _ref35.commit,
      state = _ref35.state;

  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].postAuthenticated('/events', request).then(function (resp) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(resp.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
};



/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var participant = {
  username: null,
  id: null,
  home_phone: null,
  business_phone: null,
  business_name: null,
  first_name: '',
  created_at: null,
  home_zip_code: null,
  home_state: null,
  home_address1: null,
  home_address2: null,
  home_city: null,
  shipping_city: null,
  mobile_phone: null,
  last_name: '',
  job_title: null,
  preferred_first_name: null,
  phone_number: null,
  other_email: null,
  platform_id: null,
  preferred_last_name: null,
  primary_email: null,
  secondary_email: null,
  shipping_first_name: null,
  shipping_last_name: null,
  shipping_address1: null,
  shipping_address2: null,
  shipping_state: null,
  shipping_zip_code: null,
  shipping_email: null,
  shipping_phone: null,
  status: null,
  updated_at: null,
  catalog_is_enabled: null
};

/* harmony default export */ __webpack_exports__["a"] = (participant);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appName", function() { return appName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedIn", function() { return loggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "websiteConfig", function() { return websiteConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dashboardLayout", function() { return dashboardLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "participant", function() { return participant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "programs", function() { return programs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "programDetails", function() { return programDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "programDashboard", function() { return programDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageDetails", function() { return pageDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "points", function() { return points; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rewardFilters", function() { return rewardFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cards", function() { return cards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categories", function() { return categories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categoryDetails", function() { return categoryDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rewards", function() { return rewards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rewardDetails", function() { return rewardDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "participantSetup", function() { return participantSetup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "approverClaims", function() { return approverClaims; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitterClaims", function() { return submitterClaims; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportData", function() { return reportData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimModalData", function() { return claimModalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimModalShow", function() { return claimModalShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimModalType", function() { return claimModalType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimModalMessage", function() { return claimModalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformImages", function() { return platformImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "programImages", function() { return programImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savedRewards", function() { return savedRewards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "leaderboardModalData", function() { return leaderboardModalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "leaderboardModalShow", function() { return leaderboardModalShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chartData", function() { return chartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformPointCap", function() { return platformPointCap; });
var appName = function appName(state) {
  return 'CGIP ' + state.appName;
};

var loggedIn = function loggedIn(state) {
  return state.loggedIn;
};

var websiteConfig = function websiteConfig(state) {
  return state.websiteConfig;
};

var programImages = function programImages(state) {
  return state.websiteConfig.program_images;
};

var platformImages = function platformImages(state) {
  return state.websiteConfig.platform_images;
};

var platformPointCap = function platformPointCap(state) {
  return state.platformPointCap;
};

var dashboardLayout = function dashboardLayout(state) {
  return state.dashboardLayout;
};

var participant = function participant(state) {
  return state.participant;
};

var programs = function programs(state) {
  return state.programs;
};

var programDetails = function programDetails(state) {
  return state.programDetails;
};

var programDashboard = function programDashboard(state) {
  return state.programDashboard;
};

var pageDetails = function pageDetails(state) {
  return state.pageDetails;
};

var points = function points(state) {
  return state.points;
};

var rewardFilters = function rewardFilters(state) {
  return state.rewardFilters;
};

var categories = function categories(state) {
  return state.categories;
};

var categoryDetails = function categoryDetails(state) {
  return state.categoryDetails;
};

var cards = function cards(state) {
  return state.cards;
};

var rewards = function rewards(state) {
  return state.rewards;
};

var rewardDetails = function rewardDetails(state) {
  return state.rewardDetails;
};

var participantSetup = function participantSetup(state) {
  return state.participantSetup;
};

var approverClaims = function approverClaims(state) {
  return state.approverClaims;
};

var submitterClaims = function submitterClaims(state) {
  return state.submitterClaims;
};

var reportData = function reportData(state) {
  return state.reportData;
};

var claimModalData = function claimModalData(state) {
  return state.claimModalData;
};

var claimModalShow = function claimModalShow(state) {
  return state.claimModalShow;
};

var claimModalType = function claimModalType(state) {
  return state.claimModalType;
};

var claimModalMessage = function claimModalMessage(state) {
  return state.claimModalMessage;
};

var savedRewards = function savedRewards(state) {
  return state.savedRewards;
};

var leaderboardModalData = function leaderboardModalData(state) {
  return state.leaderboardModalData;
};

var leaderboardModalShow = function leaderboardModalShow(state) {
  return state.leaderboardModalShow;
};

var chartData = function chartData(state) {
  return state.chartData;
};



/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_WEBSITE_CONFIG", function() { return UPDATE_WEBSITE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_LOGIN_STATUS", function() { return UPDATE_LOGIN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PARTICIPANT", function() { return UPDATE_PARTICIPANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_DASHBOARD", function() { return UPDATE_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PROGRAMS", function() { return UPDATE_PROGRAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PROGRAM_DETAILS", function() { return UPDATE_PROGRAM_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_PROGRAM_DETAILS", function() { return DELETE_PROGRAM_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PROGRAM_DASHBOARD", function() { return UPDATE_PROGRAM_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PAGE_DETAILS", function() { return UPDATE_PAGE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CARD_DETAILS", function() { return UPDATE_CARD_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_POINTS", function() { return UPDATE_POINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REWARD_FILTERS", function() { return UPDATE_REWARD_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CATEGORIES", function() { return UPDATE_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CATEGORY_DETAIL", function() { return UPDATE_CATEGORY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REWARDS", function() { return UPDATE_REWARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PRODUCT_DETAIL", function() { return UPDATE_PRODUCT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PRODUCT_SAVEDREWARD_ID", function() { return UPDATE_PRODUCT_SAVEDREWARD_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PARTICIPANT_SETUP", function() { return UPDATE_PARTICIPANT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPROVER_CLAIMS", function() { return UPDATE_APPROVER_CLAIMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPROVER_CLAIM", function() { return UPDATE_APPROVER_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SUBMITTER_CLAIMS", function() { return UPDATE_SUBMITTER_CLAIMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SUBMITTER_CLAIM", function() { return UPDATE_SUBMITTER_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REPORT_DATA", function() { return UPDATE_REPORT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CLAIM_MODAL_DATA", function() { return UPDATE_CLAIM_MODAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CLAIM_MODAL_SHOW", function() { return UPDATE_CLAIM_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CLAIM_MODAL_TYPE", function() { return UPDATE_CLAIM_MODAL_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CLAIM_MODAL_MESSAGE", function() { return UPDATE_CLAIM_MODAL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PROGRAM_IMAGES", function() { return UPDATE_PROGRAM_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WITHDRAW_CLAIM", function() { return WITHDRAW_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SAVED_REWARDS", function() { return UPDATE_SAVED_REWARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_SAVED_REWARD", function() { return DELETE_SAVED_REWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SAVED_REWARD", function() { return UPDATE_SAVED_REWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_LEADERBOARD_MODAL_DATA", function() { return UPDATE_LEADERBOARD_MODAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_LEADERBOARD_MODAL_SHOW", function() { return UPDATE_LEADERBOARD_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CHART_DATA", function() { return UPDATE_CHART_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PLATFORM_POINT_CAP_DETAILS", function() { return UPDATE_PLATFORM_POINT_CAP_DETAILS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);


var UPDATE_WEBSITE_CONFIG = function UPDATE_WEBSITE_CONFIG(state, config) {
  config.vanity_url = window.location.hostname !== "participant-portal.ips.creativegroupinc.com";
  state.websiteConfig = config;
};

var UPDATE_LOGIN_STATUS = function UPDATE_LOGIN_STATUS(state, status) {
  state.loggedIn = status;
};

var UPDATE_PARTICIPANT = function UPDATE_PARTICIPANT(state, participant) {
  state.participant = participant;
};

var UPDATE_PROGRAMS = function UPDATE_PROGRAMS(state, programs) {
  state.programs = programs;
};

var UPDATE_PROGRAM_DASHBOARD = function UPDATE_PROGRAM_DASHBOARD(state, programDashboard) {
  state.programDashboard = programDashboard;
};

var UPDATE_DASHBOARD = function UPDATE_DASHBOARD(state, dashboard) {
  state.dashboardLayout = dashboard.dashboard_layout;
};

var UPDATE_PROGRAM_DETAILS = function UPDATE_PROGRAM_DETAILS(state, program) {
  state.programDetails[program.id] = program;
};

var DELETE_PROGRAM_DETAILS = function DELETE_PROGRAM_DETAILS(state, programId) {
  state.programDetails[programId] = null;
};

var UPDATE_PAGE_DETAILS = function UPDATE_PAGE_DETAILS(state, page) {
  state.pageDetails[page.id] = page;
};

var UPDATE_PLATFORM_POINT_CAP_DETAILS = function UPDATE_PLATFORM_POINT_CAP_DETAILS(state, pointCap) {
  state.platformPointCap = pointCap;
};

var UPDATE_CARD_DETAILS = function UPDATE_CARD_DETAILS(state, card) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.cards, card.id, card);
};

var UPDATE_POINTS = function UPDATE_POINTS(state, data) {
  state.points = data.points;
  state.participant.points_balance = data.points_balance;
};

var UPDATE_REWARD_FILTERS = function UPDATE_REWARD_FILTERS(state, data) {
  state.rewardFilters = data.result;
};

var UPDATE_CATEGORIES = function UPDATE_CATEGORIES(state, categories) {
  state.categories = categories;
};

var UPDATE_CATEGORY_DETAIL = function UPDATE_CATEGORY_DETAIL(state, categoryDetails) {
  state.categoryDetails = categoryDetails.result;
};

var UPDATE_REWARDS = function UPDATE_REWARDS(state, rewards) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'rewards', {
    items: rewards.result.items,
    pagination: rewards.pagination
  });
};

var UPDATE_PRODUCT_DETAIL = function UPDATE_PRODUCT_DETAIL(state, reward) {
  state.rewardDetails = reward;
};

var UPDATE_PRODUCT_SAVEDREWARD_ID = function UPDATE_PRODUCT_SAVEDREWARD_ID(state, id) {
  state.rewardDetails.saved_reward_id = id;
};

var UPDATE_PARTICIPANT_SETUP = function UPDATE_PARTICIPANT_SETUP(state, participant) {
  state.participantSetup = participant;
};

var UPDATE_APPROVER_CLAIMS = function UPDATE_APPROVER_CLAIMS(state, response) {
  state.approverClaims = response.data;
};

var UPDATE_APPROVER_CLAIM = function UPDATE_APPROVER_CLAIM(state, claim) {
  var claimFound = false;
  for (var i = 0; i < state.approverClaims.length; i++) {
    if (state.approverClaims[i].id === claim.id) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.approverClaims, i, claim);
      claimFound = true;
    }
  }
  if (!claimFound) {
    state.approverClaims.push(claim);
  }
};

var UPDATE_SUBMITTER_CLAIMS = function UPDATE_SUBMITTER_CLAIMS(state, response) {
  state.submitterClaims = response.data;
};

var UPDATE_SUBMITTER_CLAIM = function UPDATE_SUBMITTER_CLAIM(state, claim) {
  var claimFound = false;
  for (var i = 0; i < state.submitterClaims.length; i++) {
    if (state.submitterClaims[i].id === claim.id) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.submitterClaims, i, claim);
      claimFound = true;
    }
  }
  if (!claimFound) {
    state.submitterClaims.push(claim);
  }
};

var UPDATE_REPORT_DATA = function UPDATE_REPORT_DATA(state, card) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.reportData, card.report_id, card.records);
};

var UPDATE_CHART_DATA = function UPDATE_CHART_DATA(state, card) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.chartData, card.id, card.chart);
};

var UPDATE_CLAIM_MODAL_DATA = function UPDATE_CLAIM_MODAL_DATA(state, claim) {
  state.claimModalData = claim;
};

var UPDATE_CLAIM_MODAL_SHOW = function UPDATE_CLAIM_MODAL_SHOW(state, show) {
  state.claimModalShow = show;
};

var UPDATE_CLAIM_MODAL_MESSAGE = function UPDATE_CLAIM_MODAL_MESSAGE(state, message) {
  state.claimModalMessage = message;
};

var UPDATE_CLAIM_MODAL_TYPE = function UPDATE_CLAIM_MODAL_TYPE(state, type) {
  state.claimModalType = type;
};

var WITHDRAW_CLAIM = function WITHDRAW_CLAIM(state, id) {
  for (var i = 0; i < state.submitterClaims.length; i++) {
    if (state.submitterClaims[i].id === id) {
      state.submitterClaims.splice(i, 1);
    }
  }
};

var UPDATE_PROGRAM_IMAGES = function UPDATE_PROGRAM_IMAGES(state, images) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.websiteConfig, 'program_images', images);
};

var UPDATE_SAVED_REWARDS = function UPDATE_SAVED_REWARDS(state, savedRewards) {
  state.savedRewards = savedRewards;
};

var DELETE_SAVED_REWARD = function DELETE_SAVED_REWARD(state, id) {
  for (var i = 0; i < state.savedRewards.length; i++) {
    if (state.savedRewards[i].id === id) {
      state.savedRewards.splice(i, 1);
    }
  }
};

var UPDATE_SAVED_REWARD = function UPDATE_SAVED_REWARD(state, reward) {
  var rewardFound = false;
  for (var i = 0; i < state.savedRewards.length; i++) {
    if (state.savedRewards[i].id === reward.id) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.savedRewards, i, reward);
      rewardFound = true;
    }
  }
  if (!rewardFound) {
    state.savedRewards.push(reward);
  }
};

var UPDATE_LEADERBOARD_MODAL_DATA = function UPDATE_LEADERBOARD_MODAL_DATA(state, card) {
  state.leaderboardModalData = card;
};

var UPDATE_LEADERBOARD_MODAL_SHOW = function UPDATE_LEADERBOARD_MODAL_SHOW(state, show) {
  state.leaderboardModalShow = show;
};



/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_ClaimDetailsModal__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_ClaimDetailsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_ClaimDetailsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_LeaderboardModal__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_LeaderboardModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_components_LeaderboardModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  data: function data() {
    return {
      impersonate: false
    };
  },


  components: {
    claimDetails: __WEBPACK_IMPORTED_MODULE_3__views_components_ClaimDetailsModal___default.a,
    leaderboardModal: __WEBPACK_IMPORTED_MODULE_4__views_components_LeaderboardModal___default.a,
    simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },

  mounted: function mounted() {
    var _this = this;

    window.addEventListener('storage', function (e) {
      if (e.key === 'token_' + _this.websiteConfig.id) {
        var message = e.newValue !== null ? 'You have been logged in as another user in another tab.' : 'You have been logged out.';
        var obj = {
          message: message,
          type: 'info',
          customCloseBtnText: 'Ok',
          customCloseBtnClass: 'c-button t-button-primary',
          disableOverlayClick: true,
          onOpen: function onOpen() {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').addClass('has-modal');
          },
          onClose: function onClose() {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('has-modal');
            window.location.reload();
          }
        };
        _this.$refs.simplert.openSimplert(obj);
      }
    });
  },
  updated: function updated() {
    var impersonateName = 'impersonate_' + this.websiteConfig.id;
    this.impersonate = localStorage[impersonateName] ? localStorage[impersonateName] : false;
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    appName: 'appName',
    websiteConfig: 'websiteConfig',
    loggedIn: 'loggedIn',
    claimModalShow: 'claimModalShow',
    leaderboardModalShow: 'leaderboardModalShow',
    participant: 'participant'
  }), {
    appClass: function appClass() {
      return {
        'is-logged-in': this.loggedIn,
        'not-logged-in': !this.loggedIn
      };
    }
  })

});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldFileUpload__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldFileUpload__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'account-setup',
  data: function data() {
    return {
      request: {
        primary_email: '',
        password: null,
        password_confirmation: null,
        terms_and_conditions: false,
        token: null,
        platform_id: null
      },
      errors: {
        password: null,
        password_confirmation: null,
        terms_and_conditions: null
      },
      setup: {
        text: '',
        fields: [],
        terms_link: ''
      },
      codeResponse: '',
      setupSuccess: true,
      setupSuccessMessage: '',
      processingForm: false,
      messagePasswordsMatchError: this.$t('web.account_setup.validation_same_password'),
      messagePasswordRequiredError: this.$t('web.account_setup.validation_new_password_required'),
      messagePasswordConfirmationRequiredError: this.$t('web.account_setup.validation_confirm_new_password_required'),
      messagePasswordsRequirementsError: this.$t('web.account_setup.validation_new_password_requirements'),
      messageTermsAndConditionsError: this.$t('web.account_setup.validation_terms_and_conditions'),
      dataToBeSaved: {},
      locales: []
    };
  },


  components: {
    fieldCurrency: __WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency___default.a,
    fieldVarchar: __WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar___default.a,
    fieldEmail: __WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail___default.a,
    fieldDate: __WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate___default.a,
    fieldDecimal: __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal___default.a,
    fieldInteger: __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger___default.a,
    fieldPercent: __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent___default.a,
    fieldBool: __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool___default.a,
    fieldEnum: __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum___default.a,
    fieldFileUpload: __WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldFileUpload___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    websiteConfig: 'websiteConfig',
    participantSetup: 'participantSetup'
  }), {
    showLocales: function showLocales() {
      return this.locales.length > 1;
    }
  }),

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].showPassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password'));
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].showPassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password_confirmation'));
    this.initValidation();

    var inviteToken = this.$route.params.token;
    this.request.token = inviteToken;
    this.LOAD_PARTICIPANT_BY_TOKEN(inviteToken).then(function (resp) {
      _this.request.primary_email = _this.participantSetup.primary_email;
      return _this.UPDATE_WEBSITE_LANG(_this.participantSetup.id);
    }).catch(function (error) {
      console.log('setup error', error);
      _this.setupSuccess = false;
      if (error.response.data.code) {
        _this.codeResponse = error.response.data.code;
      }
      _this.setupSuccessMessage = _this.$t(error.response.data.errors);
    });
    this.request.primary_email = 'primary_email' in this.participantSetup ? this.participantSetup.primary_email : '';

    this.setup = this.websiteConfig.setup;

    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.setup.fields, function (item) {
      _this.$set(_this.errors, item.name, null);
    });

    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.setup.fields, function (item) {
      _this.$set(_this.request, item.name, null);
    });

    this.locales = this.websiteConfig.locales;
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['SEND_ACCOUNT_SETUP', 'RESEND_ACCOUNT_SETUP_EMAIL', 'LOAD_PARTICIPANT_BY_TOKEN', 'UPDATE_WEBSITE_LANG', 'LOGIN', 'WEBSITE_CONFIG_AUTH_UPDATE']), {
    getFieldComponentType: function getFieldComponentType(field) {
      return 'field-' + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(field.type, '_', '-');
    },
    openLink: function openLink(e) {
      e.stopImmediatePropagation();
    },
    validateForm: function validateForm() {
      var standardFields = ['password', 'password_confirmation', 'terms_and_conditions'];
      var validation = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].validateForm(this.$el, standardFields, this.setup.fields, this.request, this.validationConstraints(), { fullMessages: false });
      this.errors = validation.errors;
      return validation.valid;
    },
    submit: function submit(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.validateForm()) {
        this.dataToBeSaved = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].getDataToBeSaved(this.setup.fields, this.request);
        console.log(this.dataToBeSaved);
        for (var attr in this.request) {
          if (typeof this.dataToBeSaved[attr] === 'undefined') {
            this.dataToBeSaved[attr] = this.request[attr];
          }
        }
        this.dataToBeSaved.platform_id = this.websiteConfig.id;
        this.processingForm = true;
        this.SEND_ACCOUNT_SETUP(this.dataToBeSaved).then(function (resp) {
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this2.errors, function (item) {
            _this2.$set(_this2.errors, item, null);
          });
          if (resp.data.success) {
            var request = {
              grant_type: 'password',
              username: _this2.dataToBeSaved.primary_email,
              password: _this2.dataToBeSaved.password,
              platform_id: _this2.dataToBeSaved.platform_id,
              scope: ''
            };
            _this2.LOGIN(request).then(function (resp) {
              _this2.WEBSITE_CONFIG_AUTH_UPDATE(_this2.$router).then(function () {
                _this2.$router.push({ name: 'Dashboard' });
                return;
              });
            }).catch(function () {
              _this2.$router.push({ name: 'Login' });
              return;
            });
          }
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-account-setup-validation-shake'));
          if (error.response && (error.response.status === 400 || error.response.status === 404)) {
            if (typeof error.response.data.errors === 'string') {
              _this2.setupSuccess = false;
              if (error.response.data.code) {
                _this2.codeResponse = error.response.data.code;
              }
              _this2.setupSuccessMessage = error.response.data.errors;
            } else {
              _this2.errors = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].handleResponseErrors(_this2.$el, error.response.data.errors);
            }
          }
          _this2.processingForm = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-account-setup-validation-shake'));
      }
    },
    resend: function resend(e) {
      var _this3 = this;

      e.preventDefault();
      this.RESEND_ACCOUNT_SETUP_EMAIL({ token: this.$route.params.token }).then(function (resp) {
        _this3.processingForm = false;
        if (resp.data.success) {
          _this3.setupSuccessMessage = _this3.$t('web.account_setup.resend_email_success_message');
          _this3.codeResponse = '';
        }
      }).catch(function () {
        _this3.setupSuccessMessage = _this3.$t('web.account_setup.resend_email_error');
        _this3.processingForm = false;
      });
    },
    validationConstraints: function validationConstraints() {
      return {
        password: {
          presence: { message: this.messagePasswordRequiredError }
        },
        password_confirmation: {
          presence: { message: this.messagePasswordConfirmationRequiredError },
          equality: { attribute: 'password', message: this.messagePasswordsMatchError }
        },
        terms_and_conditions: {
          inclusion: {
            within: ['true', 'checked', true],
            message: this.messageTermsAndConditionsError
          }
        }
      };
    },
    initValidation: function initValidation() {
      var _self = this;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password').on('blur', function (e) {
        if (!__WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].validatePassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val())) {
          _self.$set(_self.errors, 'password', [_self.messagePasswordsRequirementsError]);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('is-not-valid');
        }
      }).focus(function (e) {
        _self.$set(_self.errors, 'password', null);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).removeClass('is-not-valid');
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password_confirmation').on('blur', function (e) {
        e.preventDefault();
        if (!__WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].validatePassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val())) {
          _self.$set(_self.errors, 'password_confirmation', [_self.messagePasswordsRequirementsError]);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('is-not-valid');
        }
      }).focus(function () {
        _self.$set(_self.errors, 'password_confirmation', null);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).removeClass('is-not-valid');
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#terms_and_conditions').on('change', function (e) {
        e.preventDefault();
        if (_self.request.terms_and_conditions) {
          _self.$set(_self.errors, 'terms_and_conditions', null);
        } else {
          _self.$set(_self.errors, 'terms_and_conditions', [_self.messageTermsAndConditionsError]);
        }
      });
    }
  })
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      cardsLoaded: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.LOAD_PARTICIPANT(this.$router);
    var cardIds = {};
    this.LOAD_DASHBOARD().then(function () {
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this.dashboardLayout, function (card) {
        if (typeof _this.cards[card.id] === 'undefined') {
          _this.UPDATE_CARD_DETAILS({
            id: card.id,
            type: card.type,
            title: null,
            content: null
          });
        }
        cardIds[card.id] = card.id;
      });
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(cardIds, function (id) {
        _this.LOAD_CARD({ id: id }).then(function () {
          return _this.cardsLoaded.push(id);
        });
      });
    }).catch(function (err) {
      console.log(err);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOAD_PARTICIPANT', 'LOAD_DASHBOARD', 'LOAD_CARD']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['UPDATE_CARD_DETAILS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dashboardLayout', 'cards', 'platformImages']))
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validate_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-password',
  data: function data() {
    return {
      request: {
        primary_email: null,
        platform_id: null,
        scope: ''
      },
      errors: {
        primary_email: null
      },
      email_sent: false,
      error_message: '',
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].isLoggedIn()
    };
  },
  mounted: function mounted() {
    if (this.isLoggedIn) {
      this.LOAD_PARTICIPANT(this.$router);
    }
    __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].showPassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password'));
    __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].showPassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password_confirmation'));
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    appName: 'appName',
    websiteConfig: 'websiteConfig'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['SEND_FORGOT_PASSWORD', 'LOAD_PARTICIPANT']), {
    submit: function submit(e) {
      var _this = this;

      e.preventDefault();
      this.error_message = '';
      this.errors = { primary_email: null };
      var errors = this.validate();
      if (errors) {
        this.errors = errors;
        __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.c-card'));
        return;
      }
      this.request.platform_id = this.websiteConfig.id;
      this.SEND_FORGOT_PASSWORD(this.request).then(function (resp) {
        switch (resp.data) {
          case 'passwords.sent':
            _this.email_sent = true;
            break;
          case 'passwords.user':
            _this.errors.primary_email = [_this.$t('web.forgot_password.email_not_found')];
            __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].highlight('email');
            break;
        }
        return;
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.c-card'));
        return;
      });
    },
    validate: function validate() {
      var constraints = {
        primary_email: {
          email: {
            message: this.$t('utils.validation.email').replace('{attribute}', __WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.prettify('primary_email')))
          },
          presence: { message: this.$t('web.forgot_password.email_required') }
        }
      };
      return __WEBPACK_IMPORTED_MODULE_3_validate_js___default()(this.request, constraints, { fullMessages: false });
    }
  })
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      errorMessage: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    websiteConfig: 'websiteConfig'
  })),

  beforeMount: function beforeMount() {
    var _this = this;

    var token = this.$route.query.token;
    if (token !== '' && token !== null && typeof token !== 'undefined') {
      localStorage.setItem('token_' + this.websiteConfig.id, token);

      localStorage.setItem('impersonate_' + this.websiteConfig.id, true);
      this.UPDATE_LOGIN_STATUS(true);
      this.WEBSITE_CONFIG_AUTH_UPDATE(this.$router).then(function () {
        _this.$router.push({ name: 'Dashboard' });
        return;
      });
    } else {
      this.errorMessage = 'Token not valid';
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['WEBSITE_CONFIG_AUTH_UPDATE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['UPDATE_LOGIN_STATUS']))
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validate_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      request: {
        grant_type: 'password',
        username: null,
        password: null,
        platform_id: null,
        scope: ''
      },
      errors: {
        username: null,
        password: null
      },
      error_message: '',
      loggingIn: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    appName: 'appName',
    websiteConfig: 'websiteConfig',
    platformImages: 'platformImages'
  })),

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].initLoginCard(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('input[type="password"]'));
    var browserLang = window.navigator.language;
    __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].get('website-config?url=' + encodeURIComponent(window.location.href) + '&lang=' + browserLang + '&prefix=login').then(function (resp) {
      __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].addPlatformLanguage(resp.data.websiteConfig.language);
      _this.UPDATE_WEBSITE_CONFIG(resp.data.websiteConfig);
    }).catch(function (err) {
      if (err.response.status === 404) {
        _this.$router.push({ name: 'NotFound' });
      }
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['LOGIN', 'WEBSITE_CONFIG_AUTH_UPDATE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])(['UPDATE_WEBSITE_CONFIG']), {
    submit: function submit(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.loggingIn) {
        return;
      }
      this.loggingIn = true;
      this.errors = { username: null, password: null };
      this.error_message = '';
      var errors = this.validate();
      if (errors) {
        this.errors = errors;
        __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-login-card'));
        this.loggingIn = false;
        return;
      }
      this.request.platform_id = this.websiteConfig.id;
      this.LOGIN(this.request).then(function () {
        _this2.WEBSITE_CONFIG_AUTH_UPDATE(_this2.$router).then(function () {
          _this2.$router.push({ name: 'Dashboard' });
          _this2.loggingIn = false;
          return;
        });
      }).catch(function (err) {
        _this2.error_message = _this2.$t(err.message);

        switch (err.type) {
          case 'invalid_username':
            __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].highlight('username');
            break;
          case 'invalid_password':
            __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].highlight('password');
            break;
        }
        __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-login-card'));
        _this2.loggingIn = false;
        return;
      });
    },
    validate: function validate() {
      var constraints = {
        username: {
          email: {
            message: this.$t('utils.validation.email').replace('{attribute}', __WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.prettify('email')))
          },
          presence: {
            message: this.$t('utils.validation.required').replace('{attribute}', __WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.prettify('email')))
          }
        },
        password: {
          presence: {
            message: this.$t('utils.validation.required').replace('{attribute}', __WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_validate_js___default.a.prettify('password')))
          }
        }
      };

      return __WEBPACK_IMPORTED_MODULE_3_validate_js___default()(this.request, constraints, { fullMessages: false });
    }
  })
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_OrderList__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_OrderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_catalog_OrderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'my-orders',
  components: {
    'order-list': __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_OrderList___default.a
  },
  data: function data() {
    return {
      orders: {
        orders: [],
        pagination: null
      }
    };
  },
  mounted: function mounted() {
    this.LOAD_PARTICIPANT(this.$router);
    this.fetchOrders(1);
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    fetchOrders: function fetchOrders(whichPage) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getAuthenticated('/rewards/order/list/' + whichPage).then(function (resp) {
        _this.orders.orders = resp.data.orders.data;
        _this.orders.pagination = resp.data.pagination;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['LOAD_PARTICIPANT'])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])([]))
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loggedIn: __WEBPACK_IMPORTED_MODULE_0__functions__["a" /* default */].isLoggedIn(),
      validSite: this.$store.state.websiteConfig.id !== null
    };
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page',
  props: ['id'],
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].isLoggedIn()) {
      this.LOAD_PARTICIPANT(this.$router);
    }
    this.loadPageData();
  },

  watch: {
    id: function id() {
      this.loadPageData();
    }
  },
  data: function data() {
    return {
      page: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['pageDetails', 'cards']), {
    currentSpace: function currentSpace() {
      return this.page.title || '';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['LOAD_PARTICIPANT', 'LOAD_PAGE', 'LOAD_CARD']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['UPDATE_CARD_DETAILS']), {

    loadPageData: function loadPageData() {
      var _this = this;

      var pageId = this.$route.meta.id;
      this.LOAD_PAGE(pageId).then(function () {
        var cardIds = {};
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(_this.pageDetails[pageId].layout, function (card) {
          if (typeof _this.cards[card.id] === 'undefined') {
            _this.UPDATE_CARD_DETAILS({
              id: card.id,
              type: card.type,
              title: null,
              content: null
            });
          }
          cardIds[card.id] = card.id;
        });
        _this.page = _this.pageDetails[pageId];
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(cardIds, function (id) {
          _this.LOAD_CARD({ id: id });
        });
      }).catch(function (err) {
        _this.$router.push({ name: 'NotFound' });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
      this.page = this.pageDetails[pageId] ? this.pageDetails[pageId] : {};
    }
  })
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program',
  mounted: function mounted() {
    var _this = this;

    this.LOAD_PARTICIPANT(this.$router);

    var programId = this.$route.params.id;
    this.LOAD_PROGRAM(programId).then(function () {
      var cardIds = {};
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this.programDetails[programId].program_layout, function (card) {
        if (typeof _this.cards[card.id] === 'undefined') {
          _this.UPDATE_CARD_DETAILS({
            id: card.id,
            type: card.type,
            title: null,
            content: null
          });
        }
        cardIds[card.id] = card.id;
      });
      _this.program = _this.programDetails[programId];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(cardIds, function (id) {
        _this.LOAD_CARD({ id: id }).then(function () {
          return _this.cardsLoaded.push(id);
        });
      });
    }).catch(function (error) {
      if (error.response.status === 403) {
        _this.DELETE_PROGRAM_DETAILS(programId);
        _this.access_denied = true;
      }
    });
    this.program = this.programDetails[programId] ? this.programDetails[programId] : {};
  },
  data: function data() {
    return {
      program: {},
      access_denied: false,
      cardsLoaded: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['programDetails', 'cards', 'websiteConfig', 'programDashboard', 'programImages']), {
    programLogo: function programLogo() {
      return this.programImages && this.programImages[this.program.id] ? this.programImages[this.program.id].program : false;
    },
    programs: function programs() {
      return this.programDashboard.programs;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOAD_PARTICIPANT', 'LOAD_PROGRAM', 'LOAD_CARD']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['UPDATE_CARD_DETAILS', 'DELETE_PROGRAM_DETAILS']), {
    showBackButton: function showBackButton() {
      if (this.programs.length > 1 && window.history.length > 1) {
        return true;
      }
      return false;
    }
  })
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgramDashboard',

  data: function data() {
    return {
      access_denied: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['programDashboard', 'websiteConfig', 'programImages']), {
    programs: function programs() {
      return this.programDashboard.programs;
    }
  }),

  mounted: function mounted() {
    var _this = this;

    this.LOAD_PROGRAM_DASHBOARD(this.$route.params.id).then(function (data) {
      if (data.data.programs.length === 1) {
        _this.$router.push({ name: 'Program', params: { id: data.data.programs[0].id } });
      }
    }).catch(function (error) {
      if (error.response.status === 404) {
        _this.$router.push({ name: 'NotFound' });
      }

      _this.access_denied = error.response.status === 403;
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOAD_PROGRAM_DASHBOARD']))
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validate_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reset-password',
  data: function data() {
    return {
      request: {
        primary_email: null,
        password: null,
        password_confirmation: null,
        token: null,
        platform_id: null
      },
      errors: {
        password: null,
        password_confirmation: null
      },
      error_message: '',
      is_password_expired: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    appName: 'appName',
    websiteConfig: 'websiteConfig'
  })),

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].showPassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password'));
    __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].showPassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password_confirmation'));
    this.initValidation();

    this.is_password_expired = this.$route.name === 'ExpiredPassword';
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['RESET_PASSWORD', 'RESET_EXPIRED_PASSWORD', 'LOGIN', 'WEBSITE_CONFIG_AUTH_UPDATE', 'LOAD_PARTICIPANT']), {
    submit: function submit(e) {
      e.preventDefault();

      if (this.request.password !== this.request.password_confirmation) {
        this.error_message = this.$t('web.reset_password.validation_same_password');
        __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].highlight('password');
        __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].highlight('password_confirmation');
        return;
      }

      var errors = this.validate();

      if (errors) {
        this.errors = errors;
        if (this.errors.password) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password').addClass('is-not-valid');
        }
        if (this.errors.password_confirmation) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password_confirmation').addClass('is-not-valid');
        }
        __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-reset-validation-shake'));
        return;
      }

      if (this.errors.password || this.errors.password_confirmation) {
        return;
      }

      if (this.is_password_expired) {
        this.postResetExpiredPassword();
        return;
      }

      this.postResetPassword();
    },
    postResetPassword: function postResetPassword() {
      var _this = this;

      this.request.platform_id = this.websiteConfig.id;
      this.request.token = this.$route.params.token;
      this.request.primary_email = this.$route.params.email;
      var _self = this;
      this.RESET_PASSWORD(this.request).then(function (resp) {
        _self.error_message = '';
        _self.errors = { password: null, password_confirmation: null };
        switch (resp.data) {
          case 'passwords.reset':
            var request = {
              grant_type: 'password',
              username: _self.request.primary_email,
              password: _self.request.password,
              platform_id: _self.request.platform_id,
              scope: ''
            };
            _this.LOGIN(request).then(function (resp) {
              _this.WEBSITE_CONFIG_AUTH_UPDATE(_this.$router).then(function () {
                _this.$router.push({ name: 'Dashboard' });
                return;
              });
            }).catch(function () {
              _this.$router.push({ name: 'Login' });
              return;
            });
            break;
          case 'passwords.token':
            _this.error_message = _this.$t('web.reset_password.reset_link_expired');
            break;
          case 'password.inactive':
            _this.error_message = _this.$t('web.reset_password.account_inactive');
            break;
        }
      }).catch(function (error) {
        _this.showRequestError(error);
        return;
      });
    },
    postResetExpiredPassword: function postResetExpiredPassword() {
      var _this2 = this;

      this.RESET_EXPIRED_PASSWORD(this.request).then(function (resp) {
        _this2.LOAD_PARTICIPANT(_this2.$router).then(function () {
          _this2.$router.push({ name: 'Dashboard' });
        });
      }).catch(function (error) {
        _this2.showRequestError(error);
      });
    },
    showRequestError: function showRequestError(error) {
      __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-reset-validation-shake'));
      this.error_message = error.response.data.message;
    },
    validate: function validate() {
      var constraints = {
        password: {
          presence: {
            message: this.$t('utils.validation.required').replace('{attribute}', __WEBPACK_IMPORTED_MODULE_2_validate_js___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_2_validate_js___default.a.prettify('password')))
          }
        },
        password_confirmation: {
          presence: {
            message: this.$t('utils.validation.required').replace('{attribute}', __WEBPACK_IMPORTED_MODULE_2_validate_js___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_2_validate_js___default.a.prettify('password_confirmation')))
          }
        }
      };
      return __WEBPACK_IMPORTED_MODULE_2_validate_js___default()(this.request, constraints, { fullMessages: false });
    },
    initValidation: function initValidation() {
      var _self = this;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password').on('blur', function (e) {
        if (!__WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].validatePassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val())) {
          _self.errors.password = [_self.$t('web.reset_password.validation_new_password_requirements')];
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('is-not-valid');
        }
      }).focus(function (e) {
        _self.errors.password = null;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).removeClass('is-not-valid');
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password_confirmation').on('blur', function (e) {
        e.preventDefault();
        if (!__WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].validatePassword(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).val())) {
          _self.errors.password_confirmation = [_self.$t('web.reset_password.validation_new_password_requirements')];
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('is-not-valid');
        }
      }).focus(function () {
        _self.errors.password_confirmation = null;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).removeClass('is-not-valid');
      });
    }
  })
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-available'
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_catalog_CategoryList__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_catalog_CategoryList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_components_catalog_CategoryList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_catalog_SearchBar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_catalog_SearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_components_catalog_SearchBar__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsDashboard',

  components: {
    CategoryList: __WEBPACK_IMPORTED_MODULE_1__views_components_catalog_CategoryList___default.a,
    SearchBar: __WEBPACK_IMPORTED_MODULE_2__views_components_catalog_SearchBar___default.a
  },

  data: function data() {
    return { categoriesLoading: true };
  },


  computed: {
    showBackButton: function showBackButton() {
      var isRewardsList = this.$store.getters.rewards.items !== null && this.$store.getters.rewardDetails === null;
      var isReward = this.$store.getters.rewardDetails !== null;
      return window.history.length > 0 && (isRewardsList || isReward);
    }
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('GET_CATEGORIES', { parent: 0 }).then(function () {
      _this.categoriesLoading = false;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    this.$store.dispatch('LOAD_PARTICIPANT', this.$router).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_shared_Paginate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_shared_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_components_shared_Paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsList__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_catalog_RewardsNavigation__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_catalog_RewardsNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_components_catalog_RewardsNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_catalog_SearchBar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_catalog_SearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_components_catalog_SearchBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions__ = __webpack_require__(5);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsResults',

  components: {
    Paginate: __WEBPACK_IMPORTED_MODULE_2__views_components_shared_Paginate___default.a,
    RewardsList: __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsList___default.a,
    RewardsNavigation: __WEBPACK_IMPORTED_MODULE_4__views_components_catalog_RewardsNavigation___default.a,
    SearchBar: __WEBPACK_IMPORTED_MODULE_5__views_components_catalog_SearchBar___default.a
  },

  data: function data() {
    return { rewardsLoading: true };
  },


  computed: {
    pagination: function pagination() {
      if (this.$store.getters.rewards.pagination === null) {
        return {};
      }

      this.$store.getters.rewards.pagination.pages = __WEBPACK_IMPORTED_MODULE_6__functions__["a" /* default */].getPagination(this.$store.getters.rewards.pagination.current, this.$store.getters.rewards.pagination.pages);
      return this.$store.getters.rewards.pagination;
    }
  },

  watch: {
    '$route.query': function $routeQuery(newQuery) {
      this.getRewards(newQuery);
    }
  },

  methods: {
    getRewards: function getRewards(query) {
      var _this = this;

      this.rewardsLoading = true;
      this.$store.dispatch('GET_REWARDS', query).then(function () {
        _this.rewardsLoading = false;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    goToPage: function goToPage(page) {
      this.$router.push({
        name: 'Rewards Results',
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["clone"])(this.$route.query), { page: page })
      });
    }
  },

  created: function created() {
    this.$store.dispatch('LOAD_PARTICIPANT', this.$router).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
    this.getRewards(this.$route.query);
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_catalog_Reward__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_catalog_Reward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_components_catalog_Reward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsSingle',
  components: {
    'catalog-reward-detail': __WEBPACK_IMPORTED_MODULE_2__views_components_catalog_Reward___default.a,
    'search-bar': __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('GET_REWARD', this.$route.params.id).then(function () {
      if (_this.rewardDetails.supplier_items[0].availability_status.toLowerCase() !== 'available') {
        _this.$router.push({ name: 'RewardUnavailable' });
      }
    }).catch(function () {
      _this.$router.push({ name: 'RewardUnavailable' });
    });
    this.$store.dispatch('LOAD_PARTICIPANT', this.$router).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['rewards', 'rewardDetails']))
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_numeric__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'saved-rewards',
  components: {
    'vue-numeric': __WEBPACK_IMPORTED_MODULE_2_vue_numeric___default.a,
    'search-bar': __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_SearchBar___default.a
  },
  data: function data() {
    return {
      deleteProcessing: false
    };
  },
  mounted: function mounted() {
    this.LOAD_PARTICIPANT();
    this.GET_SAVED_REWARDS();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['participant', 'savedRewards'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOAD_PARTICIPANT', 'DELETE_SAVED_REWARDS', 'GET_SAVED_REWARDS']), {

    deleteItem: function deleteItem(id) {
      var _this = this;

      this.deleteProcessing = true;
      this.DELETE_SAVED_REWARDS(id).then(function (resp) {
        _this.deleteProcessing = false;
      }).catch(function () {
        _this.deleteProcessing = false;
      });
    }
  })
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_validate_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldCurrency__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldVarchar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldVarchar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldVarchar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldEmail__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldDate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldDecimal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldDecimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldDecimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldPercent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldPercent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldPercent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_components_fields_FieldInteger__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_components_fields_FieldInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_components_fields_FieldInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_components_fields_FieldBool__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_components_fields_FieldBool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_components_fields_FieldBool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_components_fields_FieldEnum__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_components_fields_FieldEnum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_components_fields_FieldEnum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_components_fields_FieldFileUpload__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_components_fields_FieldFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_components_fields_FieldFileUpload__);





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  data: function data() {
    return {
      metadata: this.$store.state.websiteConfig.metadata.Participant,
      participant: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.participant)),
      errors: {},
      customProfile: {
        name: '',
        fields: []
      },
      layout: {
        section1: {
          template: 'detail',
          fields: ['primary_email']
        },
        password_section: {
          template: 'detail',
          fields: ['old_password', 'new_password', 'confirm_new_password']
        },
        section3: {
          template: 'detail',
          fields: ['first_name', 'last_name']
        },
        section4: {
          template: 'detail',
          fields: ['preferred_first_name', 'preferred_last_name']
        },
        section6: {
          template: 'detail',
          fields: ['secondary_email', 'other_email']
        },
        section7: {
          template: 'detail',
          fields: ['mobile_phone', 'business_phone', 'home_phone']
        },
        section8: {
          template: 'detail',
          fields: ['home_address1', 'home_address2', 'home_city', 'home_state', 'home_zip_code', 'home_country']
        },
        section9: {
          template: 'detail',
          fields: ['shipping_first_name', 'shipping_last_name', 'shipping_address1', 'shipping_address2', 'shipping_city', 'shipping_state', 'shipping_zip_code', 'shipping_country', 'shipping_email', 'shipping_phone']
        }
      }
    };
  },

  components: {
    fieldCurrency: __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldCurrency___default.a,
    fieldVarchar: __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldVarchar___default.a,
    fieldEmail: __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldEmail___default.a,
    fieldDate: __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldDate___default.a,
    fieldDecimal: __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldDecimal___default.a,
    fieldInteger: __WEBPACK_IMPORTED_MODULE_15__views_components_fields_FieldInteger___default.a,
    fieldPercent: __WEBPACK_IMPORTED_MODULE_14__views_components_fields_FieldPercent___default.a,
    fieldBool: __WEBPACK_IMPORTED_MODULE_16__views_components_fields_FieldBool___default.a,
    fieldEnum: __WEBPACK_IMPORTED_MODULE_17__views_components_fields_FieldEnum___default.a,
    fieldFileUpload: __WEBPACK_IMPORTED_MODULE_18__views_components_fields_FieldFileUpload___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])({
    websiteConfig: 'websiteConfig'
  }), {
    full_name: function full_name() {
      if (!this.participant.first_name && !this.participant.last_name) {
        return this.$t('web.settings.name_not_entered');
      } else {
        return [this.participant.first_name, this.participant.last_name].filter(function (el) {
          return !!el;
        }).join(' ');
      }
    },
    preferred_full_name: function preferred_full_name() {
      if (!this.participant.preferred_first_name && !this.participant.preferred_last_name) {
        return this.$t('web.settings.preferred_name_not_entered');
      } else {
        return [this.participant.preferred_first_name, this.participant.preferred_last_name].filter(function (el) {
          return !!el;
        }).join(' ');
      }
    },
    home_address_empty: function home_address_empty() {
      if (!this.participant.home_address1 && !this.participant.home_address2 && !this.participant.home_city && !this.participant.home_state && !this.participant.home_zip_code && !this.participant.home_country) {
        return true;
      } else {
        return false;
      }
    },
    shipping_address_empty: function shipping_address_empty() {
      if (!this.participant.shipping_address1 && !this.participant.shipping_address2 && !this.participant.shipping_city && !this.participant.shipping_state && !this.participant.shipping_zip_code && !this.participant.shipping_first_name && !this.participant.shipping_last_name && !this.participant.shipping_country) {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.LOAD_PARTICIPANT(this.$router).then(function () {
      _this.reset();
    });
    this.customProfile = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.websiteConfig.profile);
    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.customProfile.fields, function (item) {
      _this.$set(_this.layout, 'custom_section_' + item.name, {
        template: 'detail',
        fields: [item.name],
        custom: true
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['LOAD_PARTICIPANT', 'LOGOUT']), {
    getDropdownLabel: function getDropdownLabel(value, options) {
      return __WEBPACK_IMPORTED_MODULE_6__functions__["a" /* default */].getDropdownLabel(value, options);
    },
    getFieldComponentType: function getFieldComponentType(field) {
      return 'field-' + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.replace(field.type, '_', '-');
    },

    edit: function edit(section) {
      this.reset();
      this.layout[section].template = 'edit';
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
        if (section === 'password_section') {
          __WEBPACK_IMPORTED_MODULE_6__functions__["a" /* default */].showPassword();
        }
      });
    },
    reset: function reset() {
      var _this2 = this;

      for (var i in this.layout) {
        this.layout[i].template = 'detail';
      }
      this.participant = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.participant));
      this.errors = {};

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.customProfile.fields, function (item) {
        _this2.$set(_this2.errors, item.name, null);
      });
    },
    save: function save(section) {
      var _this3 = this;

      var valid;
      valid = this._validateFields(section);
      if (valid) {
        var fields = {};
        for (var i in this.layout[section].fields) {
          fields[this.layout[section].fields[i]] = this.participant[this.layout[section].fields[i]];
        }
        console.log(fields);
        var formData = new FormData();
        formData.append('field_values', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(fields));
        console.log(formData);
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.layout[section].fields, function (field, i) {
          if (_this3.metadata[field] && _this3.metadata[field].type === 'file_upload') {
            console.log(_this3.metadata[field].type);
            var files = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this3.$children, function (item) {
              return item.field && item.field.name === field;
            }).$refs.dropzone.getAddedFiles();
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(files, function (file) {
              formData.append(field + '[]', file);
            });
          }
        });
        console.log(formData);
        __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].postAuthenticated('participants/profile', formData).then(function (response) {
          if (section === 'custom_section_locale' && response.data.participant.locale !== _this3.$store.state.participant.locale) {
            window.location.reload();
          } else {
            _this3.$store.commit('UPDATE_PARTICIPANT', response.data.participant);
            _this3.reset();
          }
        }).catch(function (error) {
          if (error.response && error.response.status === 400) {
            _this3.errors = error.response.data.errors;
          }
        });
      }
    },
    _validateFields: function _validateFields(section) {
      var _this4 = this;

      var constraints = {
        first_name: { presence: { message: this.$t('web.settings.first_name_required') } },
        last_name: { presence: { message: this.$t('web.settings.last_name_required') } },
        primary_email: {
          presence: { message: this.$t('web.settings.primary_email_required') },
          email: { message: this.$t('web.settings.primary_email_invalid') }
        },
        secondary_email: {
          email_or_empty: { message: this.$t('web.settings.secondary_email_invalid') }
        },
        other_email: {
          email_or_empty: { message: this.$t('web.settings.other_email_invalid') }
        },
        old_password: { presence: { message: this.$t('web.settings.old_password_required') } },
        new_password: {
          presence: { message: this.$t('web.settings.new_password_required') },
          length: {
            minimum: 12,
            tooShort: this.$t('web.settings.new_password_minimum_12_characters')
          },
          customPassword: true
        },
        confirm_new_password: {
          presence: { message: this.$t('web.settings.confirm_new_password_required') },
          equality: { attribute: 'new_password', message: this.$t('web.settings.confirm_new_password_dont_match') }
        }
      };
      var validation = {};
      for (var i in this.layout[section].fields) {
        if (typeof constraints[this.layout[section].fields[i]] !== 'undefined') {
          validation[this.layout[section].fields[i]] = constraints[this.layout[section].fields[i]];
        }
      }
      __WEBPACK_IMPORTED_MODULE_7_validate_js___default.a.validators.email_or_empty = function (value, options, key, attributes) {
        var message = options.message;

        if (__WEBPACK_IMPORTED_MODULE_7_validate_js___default.a.isEmpty(value)) {
          return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_7_validate_js___default.a.validators.email.PATTERN.exec(value)) {
          return message;
        }
      };
      var _self = this;
      __WEBPACK_IMPORTED_MODULE_7_validate_js___default.a.validators.customPassword = function (value, options, key, attributes) {
        var errors = [];
        if (typeof value !== 'undefined') {
          var expUpper = /.*[A-Z]+.*/g;
          var expNumber = /.*\d+.*/g;
          var expSpace = /.*\s+.*/g;
          var expSpecial = /.*[\W_]+.*/g;
          var regUpper = new RegExp(expUpper);
          var regNumber = new RegExp(expNumber);
          var regSpace = new RegExp(expSpace);
          var regSpecial = new RegExp(expSpecial);
          if (!value.match(regUpper)) {
            errors.push(_self.$t('web.settings.new_password_minimum_1_uppercase'));
          }
          if (!value.match(regNumber)) {
            errors.push(_self.$t('web.settings.new_password_minimum_1_number'));
          }
          if (value.match(regSpace)) {
            errors.push(_self.$t('web.settings.new_password_no_spaces'));
          }
          if (!value.match(regSpecial)) {
            errors.push(_self.$t('web.settings.new_password_minimum_1_symbol'));
          }
        }
        return errors;
      };
      var errors = __WEBPACK_IMPORTED_MODULE_7_validate_js___default()(this.participant, validation, { fullMessages: false });
      if ('custom' in this.layout[section] && this.layout[section].custom) {
        var fieldDef = null;
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.customProfile.fields, function (field) {
          if (_this4.layout[section].fields[0] === field.name) {
            fieldDef = field;
          }
        });
        var error = __WEBPACK_IMPORTED_MODULE_6__functions__["a" /* default */].validateField(fieldDef, this.participant[this.layout[section].fields[0]], __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('[name="' + this.layout[section].fields[0] + '"] input')[0]);
        if (typeof error !== 'undefined' && error !== '') {
          if (typeof errors === 'undefined') {
            errors = {};
          }
          errors[this.layout[section].fields[0]] = [error];
        }
      }
      if (typeof errors === 'undefined') {
        this.errors = {};
        return true;
      } else {
        this.errors = errors;
        return false;
      }
    },
    logout: function logout(e) {
      e.preventDefault();
      this.LOGOUT(this.$router);
    }
  })
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      successMessage: '',
      processingForm: false,
      request: {
        primary_email: null,
        first_name: null,
        last_name: null
      },
      errors: {
        primary_email: null,
        first_name: null,
        last_name: null
      },
      signup: {
        text: '',
        fields: [],
        confirmation: ''
      },
      dataToBeSaved: {},
      locales: [],
      showLocales: false
    };
  },

  components: {
    fieldCurrency: __WEBPACK_IMPORTED_MODULE_5__views_components_fields_FieldCurrency___default.a,
    fieldVarchar: __WEBPACK_IMPORTED_MODULE_6__views_components_fields_FieldVarchar___default.a,
    fieldEmail: __WEBPACK_IMPORTED_MODULE_7__views_components_fields_FieldEmail___default.a,
    fieldDate: __WEBPACK_IMPORTED_MODULE_8__views_components_fields_FieldDate___default.a,
    fieldDecimal: __WEBPACK_IMPORTED_MODULE_9__views_components_fields_FieldDecimal___default.a,
    fieldInteger: __WEBPACK_IMPORTED_MODULE_10__views_components_fields_FieldInteger___default.a,
    fieldPercent: __WEBPACK_IMPORTED_MODULE_11__views_components_fields_FieldPercent___default.a,
    fieldBool: __WEBPACK_IMPORTED_MODULE_12__views_components_fields_FieldBool___default.a,
    fieldEnum: __WEBPACK_IMPORTED_MODULE_13__views_components_fields_FieldEnum___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    websiteConfig: 'websiteConfig'
  })),
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('GET_WEBSITE_CONFIG').then(function (resp) {
      if (!resp.data.websiteConfig.enrollment_enabled) {
        _this.$router.push({ name: 'NotFound' });
      }
    }).catch(function (err) {
      if (err.response.status === 404) {
        _this.$router.push({ name: 'NotFound' });
      }
    });
    this.signup = this.websiteConfig.signup;

    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.signup.fields, function (item) {
      _this.$set(_this.errors, item.name, null);
      _this.$set(_this.request, item.name, null);
    });

    this.locales = this.websiteConfig.locales;

    if (this.locales.length > 1) {
      this.showLocales = true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['SIGN_UP']), {
    submit: function submit(e) {
      var _this2 = this;

      e.preventDefault();
      this.errors = {};
      if (this.validateForm()) {
        this.dataToBeSaved = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].getDataToBeSaved(this.signup.fields, this.request);
        for (var attr in this.request) {
          if (typeof this.dataToBeSaved[attr] === 'undefined') {
            this.dataToBeSaved[attr] = this.request[attr];
          }
        }
        this.dataToBeSaved.platform_id = this.websiteConfig.id;
        this.processingForm = true;
        this.request.platform_id = this.websiteConfig.id;
        this.SIGN_UP(this.dataToBeSaved).then(function (resp) {
          _this2.successMessage = _this2.signup.confirmation;
          _this2.processingForm = false;
        }).catch(function (err) {
          if (err.response && err.response.status === 400) {
            _this2.errors = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].handleResponseErrors(_this2.$el, err.response.data.errors);
          }
          if (err.response && err.response.status === 403) {
            _this2.websiteConfig.enrollment_enabled = false;
            _this2.$store.commit('UPDATE_WEBSITE_CONFIG', _this2.websiteConfig);
            _this2.successMessage = _this2.$t('web.signup.enrollment_unavailable');
          }
          _this2.processingForm = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].shake(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-account-setup-validation-shake'));
      }
    },
    validateForm: function validateForm() {
      var standardFields = ['primary_email', 'first_name', 'last_name'];
      var validation = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].validateForm(this.$el, standardFields, this.signup.fields, this.request, this.validationConstraints(), { fullMessages: false });
      this.errors = validation.errors;
      return validation.valid;
    },
    validationConstraints: function validationConstraints() {
      return {
        primary_email: {
          presence: { message: this.$t('web.signup.email_required') },
          email: { message: this.$t('web.signup.email_invalid') }
        },
        first_name: {
          presence: { message: this.$t('web.signup.first_name_required') }
        },
        last_name: {
          presence: { message: this.$t('web.signup.last_name_required') }
        }
      };
    },
    getFieldComponentType: function getFieldComponentType(field) {
      return 'field-' + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(field.type, '_', '-');
    }
  })
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.footer = this.websiteConfig.nav_footer;
  },
  data: function data() {
    return {
      footer: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['websiteConfig']), {
    footerClass: function footerClass() {
      return {
        'c-footer--login-page': this.$route.name === 'Login'
      };
    }
  })
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_PointsLedger__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_PointsLedger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_components_PointsLedger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppNavigation',
  props: ['currentSpace', 'hideAuxNavOnDesktop', 'backButton'],
  data: function data() {
    return {
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].isLoggedIn()
    };
  },


  components: {
    'points-ledger': __WEBPACK_IMPORTED_MODULE_2__views_components_PointsLedger___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['participant', 'websiteConfig', 'platformImages']), {
    spaceName: function spaceName() {
      return this.currentSpace ? this.currentSpace : this.$route.name;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['LOAD_POINTS_LEDGER']), {
    formatNumber: function formatNumber(value) {
      return __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].formatNumber(value);
    },
    togglePointsLedger: function togglePointsLedger(open) {
      if (open && !__WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').hasClass('has-modal')) {
        this.LOAD_POINTS_LEDGER();
        __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].togglePointsLedger(open);
      } else if (open && __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').hasClass('has-modal')) {
        __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].togglePointsLedger(false);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].togglePointsLedger(open);
      }
    },
    getRouteTo: function getRouteTo(navItem) {
      if (navItem.linkType === 'internal') {
        return { name: 'Page_' + navItem.id };
      }

      if (navItem.linkType === 'program_dashboard') {
        return { name: 'ProgramDashboard', params: { id: navItem.id } };
      }

      return { name: navItem.platform_default };
    },
    isVisible: function isVisible(navItem) {
      if (navItem.linkType === 'platform' && navItem.platform_default === 'Rewards') {
        return typeof this.participant !== 'undefined' ? this.participant.catalog_is_enabled : false;
      }

      return true;
    },
    historyBack: function historyBack() {
      this.$router.go(-1);
    }
  }),

  mounted: function mounted() {
    var activeEl = document.getElementsByClassName('t-navigation__item--active')[0];

    if (activeEl) {
      activeEl.scrollIntoView({ block: 'center' });
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_FieldCurrency__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_FieldCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_FieldCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_FieldVarchar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_FieldVarchar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fields_FieldVarchar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_FieldEmail__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_FieldEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fields_FieldEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_FieldDate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_FieldDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fields_FieldDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_FieldInteger__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_FieldInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__fields_FieldInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fields_FieldBool__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fields_FieldBool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__fields_FieldBool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fields_FieldEnum__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fields_FieldEnum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fields_FieldEnum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fields_FieldFileUpload__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fields_FieldFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__fields_FieldFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enums__ = __webpack_require__(59);





















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      errors: {},
      claimData: {},
      toastWait: 5000,
      processingForm: false,
      showNotes: false,
      CLAIM_STATUS: __WEBPACK_IMPORTED_MODULE_17__enums__["a" /* CLAIM_STATUS */],
      CLAIM_STATUS_TRANSLATION: __WEBPACK_IMPORTED_MODULE_17__enums__["b" /* CLAIM_STATUS_TRANSLATION */]
    };
  },


  components: {
    fieldCurrency: __WEBPACK_IMPORTED_MODULE_6__fields_FieldCurrency___default.a,
    fieldVarchar: __WEBPACK_IMPORTED_MODULE_7__fields_FieldVarchar___default.a,
    fieldEmail: __WEBPACK_IMPORTED_MODULE_8__fields_FieldEmail___default.a,
    fieldDate: __WEBPACK_IMPORTED_MODULE_9__fields_FieldDate___default.a,
    fieldDecimal: __WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal___default.a,
    fieldInteger: __WEBPACK_IMPORTED_MODULE_12__fields_FieldInteger___default.a,
    fieldPercent: __WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent___default.a,
    fieldBool: __WEBPACK_IMPORTED_MODULE_13__fields_FieldBool___default.a,
    fieldEnum: __WEBPACK_IMPORTED_MODULE_14__fields_FieldEnum___default.a,
    fieldFileUpload: __WEBPACK_IMPORTED_MODULE_15__fields_FieldFileUpload___default.a
  },

  mounted: function mounted() {
    if (this.type === 'submitter' && this.claim.status === __WEBPACK_IMPORTED_MODULE_17__enums__["a" /* CLAIM_STATUS */].UPDATE_NEEDED) {
      this.showNotes = true;
    }
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    claim: 'claimModalData',
    type: 'claimModalType'
  }), {

    notesMessage: function notesMessage() {
      return this.showNotes ? this.$t('web.claim_details_modal.hide_approver_notes') : this.$t('web.claim_details_modal.show_approver_notes');
    },

    formatNotes: function formatNotes() {
      var text = document.createTextNode(this.claim.approver_notes);
      var div = document.createElement('div');
      div.appendChild(text);
      return '<p class="c-modal--claim-details__notes-paragraph">' + div.innerHTML.replace(/(?:\n\s*\n)/g, '</p><p class="c-modal--claim-details__notes-paragraph">').replace(/(?:\n\r\|\n|\r)/g, '<br>') + '</p>';
    }

  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['WITHDRAW_CLAIM', 'UPDATE_SUBMITTER_CLAIM']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])(['UPDATE_CLAIM_MODAL_MESSAGE', 'UPDATE_APPROVER_CLAIMS']), {
    getFieldComponentType: function getFieldComponentType(field) {
      return 'field-' + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.replace(field.type, '_', '-');
    },
    close: function close() {
      this.showNotes = false;
      __WEBPACK_IMPORTED_MODULE_16__functions__["a" /* default */].closeModals();
      this.errors = {};
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.claim.field_defs, function (field, i) {
        var input = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('[name="' + field.name + '"] input');
        input.removeClass('is-not-valid');
      });
    },
    withdraw: function withdraw() {
      var _this = this;

      this.processingForm = true;
      this.WITHDRAW_CLAIM(this.claim.id).then(function (resp) {
        _this.closeAndShowToastMessage(_this.$t('web.claim_details_modal.claim_withdrawn'));
      }).catch(function (error) {
        if (error.response && error.response.status === 404) {
          _this.closeAndShowToastMessage(_this.$t('web.claim_details_modal.claim_withdrawal_failed'));
        }
        _this.close();
        _this.processingForm = false;
      });
    },
    update: function update() {
      var _this2 = this;

      var validation = __WEBPACK_IMPORTED_MODULE_16__functions__["a" /* default */].validateFields(this.$el, this.claim.field_defs, this.claim.field_values);
      this.errors = validation.errors;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.claim.field_defs, function (field, i) {
        var input = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this2.$el).find('[name="' + field.name + '"] input');
        if (_this2.errors[field.name]) {
          input.addClass('is-not-valid');
        } else {
          input.removeClass('is-not-valid');
        }
      });

      if (validation.valid) {
        this.processingForm = true;
        var formData = new FormData();
        var hasFiles = false;

        formData.append('fields', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_16__functions__["a" /* default */].getDataToBeSaved(this.claim.field_defs, this.claim.field_values)));
        formData.append('form_id', this.claim.form_id);
        formData.append('id', this.claim.id);

        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.claim.field_defs, function (field, i) {
          if (field.type === 'file_upload') {
            hasFiles = true;
          }
        });
        if (hasFiles) {
          __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].postAuthenticated('claim-forms/validate', formData).then(function (response) {
            _this2.sendFormData(formData);
          }).catch(this.processAPIError);
        } else {
          this.sendFormData(formData);
        }
      } else {
        this.processingForm = false;
      }
    },
    sendFormData: function sendFormData(formData) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.claim.field_defs, function (field, i) {
        if (field.type === 'file_upload') {
          var files = _this3.$children[i].$refs.dropzone.getAddedFiles();
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(files, function (file) {
            formData.append(field.name + '[]', file);
          });
        }
      });
      this.claimData.id = this.claim.id;
      this.claimData.data = formData;

      this.UPDATE_SUBMITTER_CLAIM(this.claimData).then(function (resp) {
        _this3.closeAndShowToastMessage(_this3.$t('web.claim_details_modal.submitter_updated_claim'));
      }).catch(this.processAPIError);
    },
    processAPIError: function processAPIError(error) {
      this.processingForm = false;
      if (error.response && error.response.status === 400) {
        var messages = {};
        for (var field in error.response.data.errors) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('[name="' + field + '"] input').addClass('is-not-valid');
          messages[field] = error.response.data.errors[field][0];
        }
        this.errors = messages;
      } else {
        this.closeAndShowToastMessage(this.$t('web.claim_details_modal.submitter_failed_to_update'));
      }
    },
    cancel: function cancel() {
      this.close();
    },
    approverUpdate: function approverUpdate(status) {
      var _this4 = this;

      this.processingForm = true;
      var formData = {};
      formData.approval_status = status;
      formData.approver_notes = this.claim.approver_notes;
      __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].putAuthenticated('claims/approver/' + this.claim.id, formData).then(function (response) {
        _this4.UPDATE_APPROVER_CLAIMS(response.data);
        _this4.closeAndShowToastMessage(_this4.$t('web.claim_details_modal.approver_updated_claim'));
      }).catch(function () {
        _this4.closeAndShowToastMessage(_this4.$t('web.claim_details_modal.approver_failed_to_update'));
      });
    },
    closeAndShowToastMessage: function closeAndShowToastMessage(message) {
      var _this5 = this;

      this.processingForm = false;
      this.UPDATE_CLAIM_MODAL_MESSAGE(message);
      setTimeout(function () {
        _this5.UPDATE_CLAIM_MODAL_MESSAGE(null);
      }, this.toastWait);
      this.close();
    },
    claimStatusClass: function claimStatusClass(claim) {
      return {
        't-alert-success': claim.status === __WEBPACK_IMPORTED_MODULE_17__enums__["a" /* CLAIM_STATUS */].APPROVED,
        't-alert-danger': claim.status === __WEBPACK_IMPORTED_MODULE_17__enums__["a" /* CLAIM_STATUS */].UPDATE_NEEDED,
        't-alert-warning': claim.status === __WEBPACK_IMPORTED_MODULE_17__enums__["a" /* CLAIM_STATUS */].PENDING,
        't-alert-info': claim.status === __WEBPACK_IMPORTED_MODULE_17__enums__["a" /* CLAIM_STATUS */].DECLINED
      };
    },
    toggleNotes: function toggleNotes() {
      this.showNotes = !this.showNotes;
    }
  })
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_shared_Paginate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_shared_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_components_shared_Paginate__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeaderboardModal',
  components: {
    Paginate: __WEBPACK_IMPORTED_MODULE_6__views_components_shared_Paginate___default.a
  },
  data: function data() {
    return {
      leaderboardReportData: [],
      currentPage: 1,
      perPage: 100
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    reportData: 'reportData',
    participant: 'participant',
    leaderboardModalData: 'leaderboardModalData'
  }), {
    totalRecords: function totalRecords() {
      return this.leaderboardModalData.recordsTotal;
    },
    pagination: function pagination() {
      var totalPages = Math.ceil(this.leaderboardModalData.recordsTotal / this.perPage);
      var pages = __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].getPagination(this.currentPage, totalPages);

      var pagination = {
        current: this.currentPage,
        per_page_count: this.perPage,
        count: this.leaderboardModalData.recordsTotal,
        pages: pages
      };

      pagination.previous = this.currentPage === 1 ? null : this.currentPage - 1;
      pagination.next = this.currentPage === __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(pagination.pages) ? null : this.currentPage + 1;

      return pagination;
    }
  }),
  mounted: function mounted() {
    this.leaderboardReportData = this.reportData[this.leaderboardModalData.report_id];
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      var participantPosition = __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].getParticipantPosition(this.participant.id, this.leaderboardReportData);

      var index = window.innerWidth > 720 ? 1 : 2;
      var record = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('#leaderboard-table__body')[0].children[participantPosition - index];
      if (record !== null && typeof record !== 'undefined') {
        record.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    },
    isPersonalPosition: function isPersonalPosition(record) {
      for (var i = 0; i < record.length; i++) {
        if (typeof record[i].id !== 'undefined' && record[i].id === this.participant.id) {
          return true;
        }
      }
      return false;
    },
    formatNumber: function formatNumber(value) {
      return __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].formatNumber(value);
    },
    getRank: function getRank(value) {
      value = value + (this.currentPage * this.perPage - this.perPage);

      return this.formatNumber(value);
    },
    formatFieldValue: function formatFieldValue(value, index) {
      var type = this.leaderboardModalData.fields[index] && this.leaderboardModalData.fields[index].type;
      var numberTypes = ['integer', 'currency', 'decimal', 'percent'];
      if (numberTypes.indexOf(type) !== -1) {
        return this.formatNumber(value);
      }
      return value;
    },
    goToPage: function goToPage(page) {
      var _this = this;

      this.currentPage = page;
      var start = page * this.perPage - this.perPage;

      __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].getAuthenticated('/cards/' + this.leaderboardModalData.id + '?' + ('start=' + start + '&legth=' + this.perPage)).then(function (resp) {
        _this.leaderboardReportData = resp.data.records;
        _this.initialize();
      }).catch(function (err) {
        console.log(err);
      });
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body').removeClass('has-modal');
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_SHOW', false);
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_DATA', null);
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_PointsRecord__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_PointsRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_components_PointsRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_shared_Paginate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_components_shared_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_components_shared_Paginate__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'point-record': __WEBPACK_IMPORTED_MODULE_4__views_components_PointsRecord___default.a,
    'paginate': __WEBPACK_IMPORTED_MODULE_5__views_components_shared_Paginate___default.a
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['points', 'participant']), {
    pagination: function pagination() {
      var totalPages = Math.ceil(this.points.total / this.perPage);
      var pages = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].getPagination(this.currentPage, totalPages);

      var pagination = {
        current: this.currentPage,
        per_page_count: this.perPage,
        count: this.points.total,
        pages: pages
      };

      pagination.previous = this.currentPage === 1 ? null : this.currentPage - 1;
      pagination.next = this.currentPage === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["last"])(pagination.pages) ? null : this.currentPage + 1;

      return pagination;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOAD_POINTS_LEDGER']), {
    formatNumber: function formatNumber(value) {
      return __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].formatNumber(value);
    },
    goToPage: function goToPage(page) {
      __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].togglePointsLedger(false);
      this.$router.push({ name: page });
    },
    togglePointsLedger: function togglePointsLedger(open) {
      this.currentPage = 1;
      __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].togglePointsLedger(open);
      this.closePointsRecordsNotes();
    },
    closePointsRecordsNotes: function closePointsRecordsNotes() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["each"])(this.$children, function (child) {
        child.$data.showNotes = false;
      });
    },
    paginatePoints: function paginatePoints(page) {
      this.currentPage = page;

      this.LOAD_POINTS_LEDGER({ page: page });
    }
  })
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PointsRecord',
  props: ['pointsRecord'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['points', 'participant'])),
  data: function data() {
    return {
      showNotes: false
    };
  },

  methods: {
    formatNumber: function formatNumber(value) {
      return __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].formatNumber(value);
    },
    goToPage: function goToPage(page) {
      __WEBPACK_IMPORTED_MODULE_2__functions__["a" /* default */].togglePointsLedger(false);
      this.$router.push({ name: page });
    },
    toggleNotes: function toggleNotes() {
      this.showNotes = !this.showNotes;
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChartCard',
  props: ['card'],
  data: function data() {
    return {
      chart: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    chartData: 'chartData',
    websiteConfig: 'websiteConfig'
  }), {
    colors: function colors() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isArray"])(this.websiteConfig.colors)) {
        return this.websiteConfig.colors;
      }
      return ['#74b9ff', '#ff7675', '#55efc4', '#a29bfe', '#81ecec', '#fab1a0', '#ffeaa7', '#fd79a8', '#b2bec3', '#0984e3', '#d63031', '#00b894', '#6c5ce7', '#00cec9', '#e17055', '#fdcb6e', '#e84393', '#636e72'];
    },
    dataAvailable: function dataAvailable() {
      return typeof this.chartData[this.card.id] !== 'undefined' && this.chartData[this.card.id] !== null && typeof this.chartData[this.card.id]['labels'] !== 'undefined' && this.chartData[this.card.id]['labels'].length !== 0;
    },
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    getChartType: function getChartType() {
      if (typeof this.chartData[this.card.id] === 'undefined') {
        return null;
      }
      switch (this.chartData[this.card.id].type) {
        case 'BarChart':
          return 'bar';
        case 'LineChart':
          return 'line';
        case 'PieChart':
          return 'pie';
        case 'DonutChart':
          return 'doughnut';
      }
    }
  }),
  mounted: function mounted() {
    this.renderChart();
  },
  updated: function updated() {
    this.renderChart();
  },

  methods: {
    renderChart: function renderChart() {
      var _this = this;

      var elem = this.$refs.canvas;
      var chartType = this.getChartType;
      if (typeof elem !== 'undefined' && typeof this.chartData[this.card.id] !== 'undefined' && chartType !== null) {
        var ctx = elem.getContext('2d');
        var data = {};
        var options = {};
        switch (chartType) {
          case 'line':
            data = {
              datasets: [{
                fill: false,
                label: this.chartData[this.card.id]['label'][0],
                borderWidth: 2,
                backgroundColor: this.colors[0],
                borderColor: this.colors[0]
              }]
            };
            options = {
              elements: {
                line: {
                  tension: 0
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    autoSkip: false }
                }]
              }
            };
            break;
          case 'pie':
          case 'doughnut':
            data = {
              datasets: [{
                label: this.chartData[this.card.id]['label'][0],
                borderWidth: 1,
                backgroundColor: function () {
                  var bgcolors = [];
                  for (var i = 0; i < _this.chartData[_this.card.id]['data'].length; i++) {
                    bgcolors.push(_this.colors[i % _this.colors.length]);
                  }
                  return bgcolors;
                }()
              }]
            };
            break;
          case 'bar':
            data = {
              datasets: [{
                label: this.chartData[this.card.id]['label'][0],
                borderWidth: 1,
                backgroundColor: this.colors[0]
              }]
            };
            options = {
              scales: {
                xAxes: [{
                  ticks: {
                    autoSkip: false }
                }]
              }
            };
            break;
        }
        this.createChart(ctx, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["merge"])(this.getBasicDataObject(), data), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["merge"])(this.getBasicOptionsObject(), options));
      }
    },
    createChart: function createChart(ctx, data, options) {
      this.chart = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
        type: this.getChartType,
        data: data,
        options: options
      });
    },
    getBasicDataObject: function getBasicDataObject() {
      return {
        labels: this.chartData[this.card.id]['labels'],
        datasets: [{
          data: this.chartData[this.card.id]['data']
        }]
      };
    },
    getBasicOptionsObject: function getBasicOptionsObject() {
      return {
        responsive: true,
        legend: {
          display: false
        }
      };
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_FormList__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_FormList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__forms_FormList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_FormDetail__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_FormDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__forms_FormDetail__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    formList: __WEBPACK_IMPORTED_MODULE_2__forms_FormList___default.a,
    formDetail: __WEBPACK_IMPORTED_MODULE_3__forms_FormDetail___default.a
  },

  props: ['card'],
  data: function data() {
    return {
      openedForm: null,
      submittedForm: null,
      toastWait: 12000
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['cards']), {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    formDetails: function formDetails() {
      return this.cards[this.card.id].forms.data;
    }
  }),

  mounted: function mounted() {
    var _this = this;

    this.$on('open-form', function (formIndex) {
      _this.openedForm = formIndex;
      _this.submittedForm = null;
    });

    this.$on('submitted-form', function () {
      _this.submittedForm = _this.openedForm;
      _this.openedForm = null;
      setTimeout(function () {
        _this.submittedForm = null;
      }, _this.toastWait);
    });

    this.$on('cancelled-form', function () {
      _this.submittedForm = null;
      _this.openedForm = null;
    });
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_Paginate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_Paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(59);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['card', 'loaded'],
  components: {
    paginate: __WEBPACK_IMPORTED_MODULE_6__shared_Paginate___default.a
  },
  data: function data() {
    return {
      pageNumber: 1,
      CLAIM_STATUS: __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */],
      CLAIM_STATUS_TRANSLATION: __WEBPACK_IMPORTED_MODULE_7__enums__["b" /* CLAIM_STATUS_TRANSLATION */]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['LOAD_APPROVER_CLAIM']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['UPDATE_CLAIM_MODAL_DATA', 'UPDATE_CLAIM_MODAL_SHOW', 'UPDATE_CLAIM_MODAL_TYPE']), {
    showClaim: function showClaim(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').addClass('has-modal');
      this.UPDATE_CLAIM_MODAL_DATA(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.approverClaims, { 'id': id }));
      this.UPDATE_CLAIM_MODAL_SHOW(true);
      this.UPDATE_CLAIM_MODAL_TYPE('approver');
      this.LOAD_APPROVER_CLAIM(id).then(function () {
        _this.UPDATE_CLAIM_MODAL_DATA(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.approverClaims, { 'id': id }));
      });
    },
    claimStatusClass: function claimStatusClass(claim) {
      console.log(claim.status);
      return {
        't-alert-success': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].APPROVED,
        't-alert-danger': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].UPDATE_NEEDED,
        't-alert-warning': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].PENDING,
        't-alert-info': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].DECLINED
      };
    },
    setPage: function setPage(pageNumber) {
      this.pageNumber = pageNumber;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['approverClaims', 'claimModalMessage', 'claimModalType']), {
    pageMap: function pageMap() {
      return __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].getPageMap(this.pagination.per_page_count, this.pagination.pages, this.totalPending, this.totalNotPending);
    },
    pagination: function pagination() {
      var pagination = {
        current: this.pageNumber,
        per_page_count: 10,
        count: this.totalPending + this.totalNotPending
      };
      pagination.pages = __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].getPagination(this.pageNumber, Math.ceil(pagination.count / pagination.per_page_count));
      pagination.previous = this.pageNumber === 1 ? null : this.pageNumber - 1;
      pagination.next = this.pageNumber === __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(pagination.pages) ? null : this.pageNumber + 1;
      return pagination;
    },
    pending: function pending() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(this.approverClaims, function (claim) {
        return claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].PENDING;
      });
    },
    pendingForThisPage: function pendingForThisPage() {
      var page = this.pageMap[this.pageNumber];
      var slice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(this.pending), page.topGroupStart, page.topGroupCount + page.topGroupStart);
      return slice;
    },
    totalPending: function totalPending() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.pending).length;
    },
    notPending: function notPending() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(this.approverClaims, function (claim) {
        return claim.status !== __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].PENDING;
      });
    },
    notPendingForThisPage: function notPendingForThisPage() {
      var page = this.pageMap[this.pageNumber];
      var slice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(this.notPending), page.bottomGroupStart, page.bottomGroupCount + page.bottomGroupStart);
      return slice;
    },
    totalNotPending: function totalNotPending() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.notPending).length;
    }
  })
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_Paginate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_Paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(59);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['card'],
  components: {
    paginate: __WEBPACK_IMPORTED_MODULE_6__shared_Paginate___default.a
  },
  data: function data() {
    return {
      pageNumber: 1,
      CLAIM_STATUS_TRANSLATION: __WEBPACK_IMPORTED_MODULE_7__enums__["b" /* CLAIM_STATUS_TRANSLATION */]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['LOAD_SUBMITTER_CLAIM']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['UPDATE_CLAIM_MODAL_DATA', 'UPDATE_CLAIM_MODAL_SHOW', 'UPDATE_CLAIM_MODAL_TYPE']), {
    showClaim: function showClaim(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').addClass('has-modal');
      this.UPDATE_CLAIM_MODAL_DATA(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.submitterClaims, { 'id': id }));
      this.UPDATE_CLAIM_MODAL_SHOW(true);
      this.UPDATE_CLAIM_MODAL_TYPE('submitter');
      this.LOAD_SUBMITTER_CLAIM(id).then(function () {
        _this.UPDATE_CLAIM_MODAL_DATA(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.submitterClaims, { 'id': id }));
      });
    },
    claimStatusClass: function claimStatusClass(claim) {
      return {
        't-alert-success': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].APPROVED,
        't-alert-danger': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].UPDATE_NEEDED,
        't-alert-warning': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].PENDING,
        't-alert-info': claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].DECLINED
      };
    },
    setPage: function setPage(pageNumber) {
      this.pageNumber = pageNumber;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['submitterClaims', 'claimModalMessage', 'claimModalType']), {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    pageMap: function pageMap() {
      return __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].getPageMap(this.pagination.per_page_count, this.pagination.pages, this.totalUpdateNeeded, this.totalNotUpdateNeeded);
    },
    pagination: function pagination() {
      var pagination = {
        current: this.pageNumber,
        per_page_count: 10,
        count: this.totalUpdateNeeded + this.totalNotUpdateNeeded
      };
      pagination.pages = __WEBPACK_IMPORTED_MODULE_5__functions__["a" /* default */].getPagination(this.pageNumber, Math.ceil(pagination.count / pagination.per_page_count));
      pagination.previous = this.pageNumber === 1 ? null : this.pageNumber - 1;
      pagination.next = this.pageNumber === __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(pagination.pages) ? null : this.pageNumber + 1;
      return pagination;
    },
    updateNeeded: function updateNeeded() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(this.submitterClaims, function (claim) {
        return claim.status === __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].UPDATE_NEEDED;
      });
    },
    updateNeededForThisPage: function updateNeededForThisPage() {
      var page = this.pageMap[this.pageNumber];
      var slice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(this.updateNeeded), page.topGroupStart, page.topGroupCount + page.topGroupStart);
      return slice;
    },
    totalUpdateNeeded: function totalUpdateNeeded() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.updateNeeded).length;
    },
    notUpdateNeeded: function notUpdateNeeded() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(this.submitterClaims, function (claim) {
        return claim.status !== __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* CLAIM_STATUS */].UPDATE_NEEDED;
      });
    },
    notUpdateNeededForThisPage: function notUpdateNeededForThisPage() {
      var page = this.pageMap[this.pageNumber];
      var slice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(this.notUpdateNeeded), page.bottomGroupStart, page.bottomGroupCount + page.bottomGroupStart);
      return slice;
    },
    totalNotUpdateNeeded: function totalNotUpdateNeeded() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.notUpdateNeeded).length;
    }
  })
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentCard',
  props: ['card'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['websiteConfig']), {
    loading: function loading() {
      return !this.card.cardLoaded;
    }
  }),
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).find('div.c-card__body a').off('click');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).find('div.c-card__body a').on('click', this.handleLink);
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).find('div.c-card__body a').off('click');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).find('div.c-card__body a').on('click', this.handleLink);
  },

  methods: {
    handleLink: function handleLink(e) {
      __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].handleLink(e, this.websiteConfig, this.$router);
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Content__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DynamicContent',

  extends: __WEBPACK_IMPORTED_MODULE_0__Content___default.a
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeaderboardCard',
  props: ['card'],
  data: function data() {
    return {
      participantPosition: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    websiteConfig: 'websiteConfig',
    reportData: 'reportData',
    participant: 'participant'
  }), {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    title: function title() {
      return this.card.title ? this.card.title : 'Leaderboard';
    },
    dataNotAvailable: function dataNotAvailable() {
      return typeof this.reportData[this.card.report_id] === 'undefined' || this.reportData[this.card.report_id] === null || this.reportData[this.card.report_id].length === 0;
    },
    columnsLength: function columnsLength() {
      if (typeof this.card.headers !== 'undefined') {
        return this.card.headers.length;
      }
      return 0;
    },
    leaderboards: function leaderboards() {
      this.participantPosition = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].getParticipantPosition(this.participant.id, this.reportData[this.card.report_id]);
      var records = [];
      var first = 0;
      var distance = 2;

      if (this.participantPosition <= distance || this.participantPosition === null) {
        for (var i = first; i <= distance; i++) {
          records.push(i);
        }
        return records;
      } else {
        for (var _i = first; _i <= distance; _i++) {
          records.push(_i);
        }
      }

      if (this.participantPosition >= records.length + distance) {
        records.push('...');
      }

      for (var _i2 = this.participantPosition - 1; _i2 <= this.participantPosition + 1; _i2++) {
        if (records.indexOf(_i2) === -1 && typeof this.reportData[this.card.report_id][_i2] !== 'undefined') {
          records.push(_i2);
        }
      }
      return records;
    },
    rankDigits: function rankDigits() {
      var paxPosition = this.participantPosition + 1;
      var rankPool = this.reportData[this.card.report_id].length;
      var numberOfDigits = paxPosition.toString().length + rankPool.toString().length;
      if (numberOfDigits >= 2 && numberOfDigits <= 12) {
        return 'has-' + numberOfDigits + '-digits';
      }
      return 'is-very-long';
    }
  }),
  methods: {
    openLeaderboardModal: function openLeaderboardModal() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').addClass('has-modal');
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_SHOW', true);
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_DATA', this.card);
    },
    myPosition: function myPosition(leaderboardPosition) {
      var column = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return this.participantPosition === leaderboardPosition && column === 1;
    },
    formatNumber: function formatNumber(value) {
      return __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].formatNumber(value);
    },
    formatFieldValue: function formatFieldValue(value, index) {
      var type = this.card.fields[index] && this.card.fields[index].type;
      var numberTypes = ['integer', 'currency', 'decimal', 'percent'];
      if (numberTypes.indexOf(type) !== -1) {
        return this.formatNumber(value);
      }
      return value;
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MultiCard',

  props: ['card'],

  data: function data() {
    return {
      baseUrl: '',
      currentCardIndex: 0,
      showDropdown: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    cards: 'cards'
  }), {
    currentCard: function currentCard() {
      if (this.cards[this.card.card_layout[this.currentCardIndex].id]) {
        return this.cards[this.card.card_layout[this.currentCardIndex].id];
      }
      return {};
    },
    loading: function loading() {
      if (this.card.cardLoaded && typeof this.card.card_layout !== 'undefined') {
        return !(typeof this.cards[this.card.card_layout[this.currentCardIndex].id] !== 'undefined' && this.cards[this.card.card_layout[this.currentCardIndex].id].cardLoaded);
      }
      return !this.card.cardLoaded;
    },
    hasMultipleCards: function hasMultipleCards() {
      if (typeof this.card.card_layout !== 'undefined') {
        return this.card.card_layout.length > 1;
      }
      return false;
    }
  }),

  methods: {
    loadCards: function loadCards() {
      var _this = this;

      if (typeof this.card.card_layout !== 'undefined') {
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.card.card_layout, function (card, i) {
          if (typeof _this.cards[card.id] === 'undefined' && !card.loading) {
            _this.$store.dispatch('LOAD_CARD', { id: card.id });

            _this.card.card_layout[i].loading = true;
          }
        });
      }
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(index) {
      this.toggleDropdown();
      this.currentCardIndex = index;
    }
  },

  updated: function updated() {
    this.loadCards();
  },
  mounted: function mounted() {
    this.loadCards();
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeform_embed__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeform_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__typeform_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuizzesCard',

  props: {
    card: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      quizzes: [],
      visibleModal: ''
    };
  },


  computed: {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    quizzesTaken: function quizzesTaken() {
      return this.quizzes.filter(function (quiz) {
        return quiz.taken;
      });
    },
    quizzesUntaken: function quizzesUntaken() {
      return this.quizzes.filter(function (quiz) {
        return !quiz.taken;
      });
    }
  },

  methods: {
    hideModal: function hideModal() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').removeClass('has-modal');
      this.visibleModal = '';
    },
    loadQuiz: function loadQuiz(quizCode) {
      var _this = this;

      if (typeof this.$refs[quizCode + '-quiz'] === 'undefined') {
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__typeform_embed__["makeWidget"])(this.$refs[quizCode + '-quiz'][0], quizCode, {
        onSubmit: function onSubmit() {
          _this.markQuizTaken(quizCode);
        }
      });

      this.$set(this.quizzes.find(function (quiz) {
        return quiz.code === quizCode;
      }), 'alreadyShown', true);
    },
    markQuizTaken: function markQuizTaken(quizCode) {
      this.$set(this.quizzes.find(function (quiz) {
        return quiz.code === quizCode;
      }), 'taken', true);
    },
    modalIsVisible: function modalIsVisible(quizCode) {
      return this.visibleModal === quizCode;
    },
    showModal: function showModal(quizCode) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').addClass('has-modal');
      this.visibleModal = quizCode;
      this.$nextTick(function () {
        _this2.loadQuiz(quizCode);
      });
    }
  },

  watch: {
    'card.quizzes': function cardQuizzes(newQuizzes) {
      this.quizzes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(newQuizzes);
    }
  },

  created: function created() {
    this.quizzes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.card, 'quizzes', []);
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_datatables_net__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_plugins_sorting_datetime_moment__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_plugins_sorting_datetime_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_datatables_net_plugins_sorting_datetime_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_json2csv__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_json2csv__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['card'],
  data: function data() {
    return {
      dtable: null,
      rows: [],
      groupRows: [],
      params: null,
      columnDefs: [],
      downloading: false,
      interval: null,
      loadingMessage: 'utils.datatables.processing'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    reportData: 'reportData',
    websiteConfig: 'websiteConfig'
  }), {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    dataAvailable: function dataAvailable() {
      return !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.report_id) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.reportData[this.card.report_id]));
    },
    datatablesLanguage: function datatablesLanguage() {
      return {
        'emptyTable': this.$t('utils.datatables.empty_table'),
        'info': this.$t('utils.datatables.records_info'),
        'infoEmpty': this.$t('utils.datatables.showing_zero_records'),
        'infoFiltered': this.$t('utils.datatables.info_filtered'),
        'infoPostFix': this.$t('utils.datatables.append_to_info'),
        'thousands': this.$t('utils.datatables.info_thousands_separator'),
        'lengthMenu': this.$t('utils.datatables.records_per_page'),
        'loadingRecords': this.$t('utils.datatables.loading'),
        'processing': this.$t('utils.datatables.processing'),
        'search': this.$t('utils.datatables.search'),
        'zeroRecords': this.$t('utils.datatables.no_records_found'),
        'paginate': {
          'first': this.$t('utils.datatables.page_first'),
          'last': this.$t('utils.datatables.page_last'),
          'next': this.$t('utils.datatables.page_next'),
          'previous': this.$t('utils.datatables.page_previous')
        },
        'aria': {
          'sortAscending': this.$t('utils.datatables.sort_ascending'),
          'sortDescending': this.$t('utils.datatables.sort_descending')
        }
      };
    },
    hasGroupFields: function hasGroupFields() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(this.reportData[this.card.report_id], function (item) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(item[0].group);
      }).length > 0;
    }
  }),
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.fn.dataTable.moment('MMM DD, YYYY');
    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.fn.dataTable.moment('MMM DD, YYYY hh:mm a');
    this.renderDataTable();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['LOAD_CARD']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['UPDATE_REPORT_DATA']), {
    getGroupRows: function getGroupRows(startGroup, endGroup) {
      var rows = [];
      var foundLevels = {};

      var startIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.rows, function (item) {
        return item[0].groupIndex === startGroup;
      })[0].originalIndex;
      var endIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.rows, function (item) {
        return item[0].groupIndex === endGroup;
      });
      endIndex = endIndex ? endIndex[0].originalIndex : 0;

      for (var i = startIndex; i >= endIndex; i--) {
        var groupRow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.groupRows, function (item) {
          return item[0].originalIndex === i;
        });
        if (groupRow && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(foundLevels[groupRow[0].level])) {
          rows.unshift(groupRow);
          foundLevels[groupRow[0].level] = true;
        }
      }
      return rows;
    },
    renderDataTable: function renderDataTable() {
      if (!this.dataAvailable) {
        return;
      }

      if (this.dtable) {
        this.dtable.destroy();
      }

      this.initializeData();

      var self = this;
      var token = localStorage.getItem('token_' + this.websiteConfig.id);
      var dataTableSettings = {
        language: this.datatablesLanguage,
        dom: 'lfr<"dataTables_top_pagination"p>tip',
        columnDefs: this.columnDefs,
        searching: false,
        processing: true,
        serverSide: true,
        aaSorting: [],
        ajax: {
          type: 'GET',
          url: "https://cgip-website-prod.creativegroupinc.com" + '/api/platform/v1/cards/' + this.card.id,
          headers: { 'Authorization': 'Bearer ' + token },
          dataFilter: function dataFilter(data) {
            var json = JSON.parse(data);

            self.UPDATE_REPORT_DATA(json);
            self.initializeData();

            json.recordsTotal = json.recordsTotal;
            json.recordsFiltered = json.recordsFiltered;
            json.data = self.rows;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json);
          }
        },
        drawCallback: function drawCallback(settings) {
          if (self.groupRows.length > 0) {
            var shownGroups = [];
            var api = this.api();
            var rowsTR = api.rows({ page: 'current' }).nodes();
            var rowsData = api.rows({ page: 'current' }).data();

            for (var displayIndex = 0; displayIndex < rowsData.length; displayIndex++) {
              var groupRows = [];
              if (displayIndex === 0) {
                groupRows = self.getGroupRows(rowsData[displayIndex][0].groupIndex, 0);
                shownGroups.push(rowsData[displayIndex][0].groupIndex);
              } else {
                if (shownGroups.indexOf(rowsData[displayIndex][0].groupIndex) === -1) {
                  groupRows = self.getGroupRows(rowsData[displayIndex][0].groupIndex, rowsData[displayIndex][0].groupIndex - 1);
                  shownGroups.push(rowsData[displayIndex][0].groupIndex);
                }
              }
              if (groupRows.length) {
                for (var i = 0; i < groupRows.length; i++) {
                  var level = groupRows[i][0].level;
                  var html = '<tr class="row-group row-group-' + level + '"><td colspan="' + (rowsData[displayIndex].length - 1) + '">' + groupRows[i][1] + '</td></tr>';
                  __WEBPACK_IMPORTED_MODULE_4_jquery___default()(rowsTR).eq(displayIndex).before(html);
                }
              }
            }
          }
        },
        scrollX: true
      };
      if (this.hasGroupFields) {
        dataTableSettings.orderFixed = [0, 'asc'];
      }
      this.dtable = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.dtable).DataTable(dataTableSettings);

      this.dtable.on('xhr', function () {
        self.params = self.dtable.ajax.params();
      });
    },
    initializeData: function initializeData() {
      var _this = this;

      this.columnDefs = [{
        name: 'ids',
        orderable: false,
        searchable: false,
        visible: false,
        targets: 0
      }];

      var maxGroupLevel = 0;
      var groupIndex = 1;

      if (this.hasGroupFields) {
        this.columnDefs[0]['render'] = {
          _: 'groupIndex',
          sort: 'groupIndex'
        };
        maxGroupLevel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["maxBy"])(this.reportData[this.card.report_id], function (item) {
          return item[0].level;
        })[0].level;
      }

      var rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(this.reportData[this.card.report_id], function (item, index) {
        var newItem = item;
        newItem[0].originalIndex = index;
        if (_this.hasGroupFields) {
          newItem[0].groupIndex = newItem[0].level ? groupIndex : groupIndex - 1;
          if (newItem[0].level === maxGroupLevel) {
            groupIndex++;
          }
        }
        return newItem;
      });

      var groupFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["uniq"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(rows, function (item) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(item[0].group);
      }), function (item) {
        return item[0].group;
      }));

      for (var i = 0; i < this.card.headers.length; i++) {
        this.columnDefs.push({
          title: this.card.headers[i],
          targets: i + 1,
          orderable: groupFields.indexOf(this.card.fields[i + 1].name) === -1
        });
      }

      this.rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(rows, function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(item[0].group);
      });
      this.groupRows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(rows, function (item) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(item[0].group);
      });
    },
    downloadReport: function downloadReport() {
      var _this2 = this;

      var exportParams = this.params;
      exportParams['export'] = true;

      this.downloading = true;
      this.interval = setInterval(this.updateLoadingMessage, 10000);

      this.$store.dispatch('LOAD_CARD', { id: this.card.id, query: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.param(exportParams) }).then(function () {
        var filename = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["kebabCase"])(_this2.card.title) + '--' + new Date().toISOString().slice(0, 10) + '.csv';
        var csv = _this2.convertToCSV(_this2.card.headers, _this2.reportData[_this2.card.report_id]);
        __WEBPACK_IMPORTED_MODULE_8__functions__["a" /* default */].triggerFileDownload(csv, filename, 'text/csv;charset=utf-8;', true);
        _this2.downloading = false;
        clearInterval(_this2.interval);
      }).catch(function (error) {
        console.log(error);
        _this2.downloading = false;
        clearInterval(_this2.interval);
      });
    },
    convertToCSV: function convertToCSV(headerRow, records) {
      var rows = [headerRow].concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(records, function (item) {
        return item.slice(1);
      }));
      var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(headerRow, __WEBPACK_IMPORTED_MODULE_3_lodash__["kebabCase"]);

      var csv = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(rows, function (row) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["zipObject"])(keys, row);
      });
      return __WEBPACK_IMPORTED_MODULE_9_json2csv___default.a.parse(csv, { fields: keys, header: false });
    },
    updateLoadingMessage: function updateLoadingMessage() {
      this.loadingMessage = this.loadingMessage === 'utils.datatables.processing' ? 'utils.datatables.please_wait' : 'utils.datatables.processing';
    }
  }),
  watch: {
    dataAvailable: function dataAvailable() {
      var _this3 = this;

      if (this.dataAvailable) {
        this.$nextTick(function () {
          _this3.renderDataTable();
        });
      }
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_numeric__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['card'],
  components: {
    'vue-numeric': __WEBPACK_IMPORTED_MODULE_1_vue_numeric___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    websiteConfig: 'websiteConfig'
  }), {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    title: function title() {
      return this.card.title ? this.card.title : this.$t('web.card_target.default_title');
    },
    targetAmount: function targetAmount() {
      return this.card.target ? this.card.target : 0;
    },
    progressAmount: function progressAmount() {
      return this.card.progress ? this.card.progress : 0;
    },
    percentage: function percentage() {
      if (this.targetAmount !== 0) {
        return Math.floor(this.progressAmount / this.targetAmount * 100);
      } else {
        return 0;
      }
    },
    isCurrency: function isCurrency() {
      return this.websiteConfig.metadata.Participant[this.card.target_mapping].type === 'currency';
    },
    animateGauge: function animateGauge() {
      if (this.percentage <= 100) {
        return 'gauge-percent-' + this.percentage;
      } else if (this.percentage > 100) {
        return 'gauge-percent-' + 100;
      }
    }
  })
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['card'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['websiteConfig']), {
    loading: function loading() {
      return !this.card.cardLoaded;
    },
    progressValues: function progressValues() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.level)) {
        return null;
      }
      if (this.card.level.display === 'percentage') {
        return this.card.level.percentage;
      }
      return __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].formatNumber(this.card.level.formatted_progress) + ' / ' + __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].formatNumber(this.card.level.formatted_goal);
    },
    levelColor: function levelColor() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.level) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.level.color) ? { color: this.card.level.color } : {};
    },
    progressBarStyle: function progressBarStyle() {
      var style = {};
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.level)) {
        style.width = this.card.level.percentage;
      }
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.level) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.level.color)) {
        style.background = this.card.level.color;
      }
      return style;
    }
  }),
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('a.js-handle-link').off('click');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('a.js-handle-link').on('click', this.handleLink);
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('a.js-handle-link').off('click');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('a.js-handle-link').on('click', this.handleLink);
  },

  methods: {
    handleLink: function handleLink(e) {
      __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].handleLink(e, this.websiteConfig, this.$router);
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CatalogOrderCard',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusColor: function statusColor(status) {
      status = status ? status.toLowerCase() : '';
      switch (status) {
        case 'pending':
          status = 't-alert-warning';
          break;
        case 'processing':
          status = 't-alert-warning';
          break;
        case 'partial':
          status = 't-alert-danger';
          break;
        case 'rejected':
          status = 't-alert-danger';
          break;
        case 'failed':
          status = 't-alert-danger';
          break;
        case 'stopped':
          status = 't-alert-danger';
          break;
        case 'cancelled':
        case 'canceled':
          status = 't-alert-plain';
          break;
        case 'sent':
          status = 't-alert-info';
          break;
        case 'delivered':
          status = 't-alert-success';
          break;
        case 'returned':
          status = 't-alert-success';
          break;
        default:
          status = 't-alert-plain';
          break;
      }
      return status;
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryListTile__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryListTile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CategoryListTile__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CategoryList',

  components: { CategoryListTile: __WEBPACK_IMPORTED_MODULE_0__CategoryListTile___default.a }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CategoryListTile',

  props: {
    category: {
      type: Object,
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['participant']), {
    name: function name() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"])(this.category) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"])(this.category.name) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(this.category, 'name.' + this.participant.catalog_locale, '') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(this.category, 'name', null);
    },
    thumb: function thumb() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(this.category, 'images.' + this.participant.catalog_locale + '.0.sizes.350x350') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(this.category, 'image.url') || '/img/thm350.png';
    }
  })
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['orderConfirmationMessage']
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['orderErrorMessage']
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_components_shared_Paginate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_components_shared_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_components_shared_Paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CatalogOrderCard_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CatalogOrderCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CatalogOrderCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RewardOpsOrderCard_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RewardOpsOrderCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RewardOpsOrderCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['orders', 'fetchOrderCallback'],
  components: {
    'pagination': __WEBPACK_IMPORTED_MODULE_0__views_components_shared_Paginate___default.a,
    'cat-order-card': __WEBPACK_IMPORTED_MODULE_1__CatalogOrderCard_vue___default.a,
    'ro-order-card': __WEBPACK_IMPORTED_MODULE_2__RewardOpsOrderCard_vue___default.a
  },
  computed: {
    getPagination: function getPagination() {
      if (this.orders.pagination === null) {
        return this.orders.pagination;
      }
      this.orders.pagination.pages = __WEBPACK_IMPORTED_MODULE_3__functions__["a" /* default */].getPagination(this.orders.pagination.current, this.orders.pagination.pages);
      return this.orders.pagination;
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validate_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_numeric__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions__ = __webpack_require__(5);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      confirming: false,
      editingAddress: false,
      shippingIncomplete: true,
      metadata: this.$store.state.websiteConfig.metadata.Participant,
      participant: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.participant)),
      addressFields: ['shipping_first_name', 'shipping_last_name', 'shipping_address1', 'shipping_address2', 'shipping_city', 'shipping_state', 'shipping_city', 'shipping_zip_code', 'shipping_country', 'shipping_email', 'shipping_phone'],
      errors: {},
      price: 0,
      quantity: 1,
      hasRange: false,
      minPrice: 0,
      maxPrice: 0,
      minDefDollarPrice: 0,
      maxDefDollarPrice: 0,
      dollarPriceInserted: 0
    };
  },
  mounted: function mounted() {
    this.shippingIncomplete = !this._validateFields();
    this.errors = {};

    this.price = this.currencyCode ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(this.rewardDetails, 'supplier_items[0].prices.sale_price.' + this.currencyCode) : this.rewardDetails['supplier_items'][0]['prices']['sale_price'][0];

    this.hasRange = this.rewardDetails['supplier_items'][0]['prices']['has_range'];
    if (this.hasRange) {
      this.minPrice = this.rewardDetails['supplier_items'][0]['prices']['sale_price_range']['min'];
      this.maxPrice = this.rewardDetails['supplier_items'][0]['prices']['sale_price_range']['max'];
      this.minDefDollarPrice = parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['min']);
      this.maxDefDollarPrice = parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['max']);

      this.dollarPriceInserted = parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['min']);
    }
  },

  components: {
    'vue-numeric': __WEBPACK_IMPORTED_MODULE_5_vue_numeric___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['rewardDetails']), {
    currencyCode: function currencyCode() {
      return this.participant.points_currency_code;
    },
    rewardSpecs: function rewardSpecs() {
      return this.rewardDetails !== null ? JSON.parse(this.rewardDetails.specifications) : null;
    },
    addressEmpty: function addressEmpty() {
      return !(this.participant.shipping_address1 || this.participant.shipping_address2 || this.participant.shipping_city || this.participant.shipping_state || this.participant.shipping_zip_code || this.participant.shipping_country);
    },
    pointsBalance: function pointsBalance() {
      return this.participant.points_balance - this.totalPrice;
    },
    totalPrice: function totalPrice() {
      return this.individualPrice * this.quantity;
    },
    individualPrice: function individualPrice() {
      if (this.hasRange) {
        var dollarPrice = this.dollarPriceInserted + this.dollarPriceInserted * this.rewardDetails['supplier_items'][0]['markup'] / 100;

        return dollarPrice / this.rewardDetails['supplier_items'][0]['point_conversion_rate'];
      }

      return this.price;
    },
    notEnoughPoints: function notEnoughPoints() {
      return this.totalPrice > this.participant.points_balance;
    },
    showGiftCardMessage: function showGiftCardMessage() {
      return this.rewardDetails.item_type.type.toLowerCase().includes('gift card');
    },
    priceOutOfRange: function priceOutOfRange() {
      return this.hasRange && (this.dollarPriceInserted < this.minDefDollarPrice || this.dollarPriceInserted > this.maxDefDollarPrice);
    }
  }),
  methods: {
    getDropdownLabel: function getDropdownLabel(value, options) {
      return __WEBPACK_IMPORTED_MODULE_7__functions__["a" /* default */].getDropdownLabel(value, options);
    },
    reset: function reset() {
      this.editingAddress = false;
      this.participant = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.participant));
      this.errors = {};
    },
    save: function save() {
      var valid;
      var self = this;
      valid = this._validateFields();
      if (valid) {
        var fields = {};
        for (var i in this.addressFields) {
          fields[this.addressFields[i]] = this.participant[this.addressFields[i]];
        }
        var formData = new FormData();
        formData.append('field_values', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(fields));
        __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].postAuthenticated('participants/profile', formData).then(function (response) {
          self.$store.commit('UPDATE_PARTICIPANT', response.data.participant);
          self.reset();
          self.editingAddress = false;
          self.shippingIncomplete = false;
        }).catch(function (error) {
          if (error.response && error.response.status === 400) {
            self.errors = error.response.data.errors;
          }
        });
      }
    },
    _validateFields: function _validateFields() {
      var constraints = {
        shipping_first_name: { presence: { message: this.$t('web.catalog_order_modal.shipping_first_name_required') } },
        shipping_last_name: { presence: { message: this.$t('web.catalog_order_modal.shipping_last_name_required') } },
        shipping_phone: { presence: { message: this.$t('web.catalog_order_modal.shipping_phone_required') } },
        shipping_address1: { presence: { message: this.$t('web.catalog_order_modal.shipping_address1_required') } },
        shipping_city: { presence: { message: this.$t('web.catalog_order_modal.shipping_city_required') } },
        shipping_state: { presence: { message: this.$t('web.catalog_order_modal.shipping_state_required') } },
        shipping_zip_code: { presence: { message: this.$t('web.catalog_order_modal.shipping_zip_required') } },
        shipping_country: { presence: { message: this.$t('web.catalog_order_modal.shipping_country_required') } },
        shipping_email: {
          presence: { message: this.$t('web.catalog_order_modal.shipping_email_required') },
          email: { message: this.$t('web.catalog_order_modal.shipping_email_invalid') }
        }
      };
      var validation = {};
      for (var i in this.addressFields) {
        if (typeof constraints[this.addressFields[i]] !== 'undefined') {
          validation[this.addressFields[i]] = constraints[this.addressFields[i]];
        }
      }
      var errors = __WEBPACK_IMPORTED_MODULE_3_validate_js___default()(this.participant, validation, { fullMessages: false });
      if (typeof errors === 'undefined') {
        this.errors = {};
        return true;
      } else {
        this.errors = errors;
        return false;
      }
    },
    confirm: function confirm() {
      this.confirming = true;
      this.$emit('confirm', { quantity: this.quantity, dollar_price: this.dollarPriceInserted, point_price: this.individualPrice });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_numeric__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_catalog_OrderModal__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_catalog_OrderModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_components_catalog_OrderModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_catalog_OrderConfirmation__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_catalog_OrderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_components_catalog_OrderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_catalog_OrderError__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_components_catalog_OrderError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_components_catalog_OrderError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(2);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'order-modal': __WEBPACK_IMPORTED_MODULE_7__views_components_catalog_OrderModal___default.a,
    'order-confirmation': __WEBPACK_IMPORTED_MODULE_8__views_components_catalog_OrderConfirmation___default.a,
    'order-error': __WEBPACK_IMPORTED_MODULE_9__views_components_catalog_OrderError___default.a,
    'vue-numeric': __WEBPACK_IMPORTED_MODULE_4_vue_numeric___default.a
  },
  props: ['order'],
  data: function data() {
    return {
      orderProcessing: false,
      orderErrorMessage: '',
      orderDetails: null,
      showOrderErrorModal: false,
      showOrderModal: false,
      showOrderConfirmationModal: false,
      showTermsConditions: false,
      deleteProcessing: false,
      orderQuantity: 1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapMutations */])(['UPDATE_PRODUCT_DETAIL']), {
    formatRewardDetails: function formatRewardDetails(rewardDetails) {
      if (typeof rewardDetails !== 'undefined' && rewardDetails !== null) {
        return '<p class="c-card__p">' + rewardDetails.replace(/(?:\r\n|\r|\n)/g, '</p><p class="c-card__p">') + '</p>';
      }
      return '';
    },
    deleteItem: function deleteItem() {
      var _this = this;

      if (this.rewardDetails.saved_reward_id) {
        this.deleteProcessing = true;
        this.$store.dispatch('DELETE_SAVED_REWARDS', this.rewardDetails.saved_reward_id).then(function (resp) {
          _this.deleteProcessing = false;
        }).catch(function () {
          _this.deleteProcessing = false;
        });
      }
    },
    closeOrderErrorModal: function closeOrderErrorModal() {
      this.showOrderErrorModal = false;
      this.orderErrorMessage = '';
      this.orderProcessing = false;
    },
    closeOrderModal: function closeOrderModal() {
      this.showOrderModal = false;
      this.orderProcessing = false;
    },
    closeOrderConfirmationModal: function closeOrderConfirmationModal() {
      this.showOrderConfirmationModal = false;
      this.orderProcessing = false;
    },
    orderItem: function orderItem() {
      var _this2 = this;

      this.$store.dispatch('GET_REWARD', this.$route.params.id).then(function () {
        if (_this2.rewardDetails.supplier_items[0].availability_status.toLowerCase() !== 'available') {
          _this2.$router.push({ name: 'RewardUnavailable' });
        } else {
          _this2.orderProcessing = true;

          if (!_this2.participantHasEnoughPoints) {
            _this2.orderErrorMessage = _this2.getInsufficientPointsMessage;
            _this2.showOrderErrorModal = true;
          }

          if (_this2.participantSpentPointsOverProgramLimit) {
            _this2.orderErrorMessage = _this2.getSpentPointsOverProgramLimitItemMessage;
            _this2.showOrderErrorModal = true;
            return false;
          }

          if (_this2.participantHasEnoughPoints) {
            _this2.showOrderModal = true;
          }
        }
      }).catch(function (error) {
        if (error.response.data.result) {
          _this2.orderErrorMessage = error.response.data.result.error;
          _this2.showOrderErrorModal = true;
        }
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    saveForLater: function saveForLater() {
      var _this3 = this;

      this.$store.dispatch('GET_REWARD', this.$route.params.id).then(function () {
        if (_this3.rewardDetails.supplier_items[0].availability_status.toLowerCase() !== 'available') {
          _this3.$router.push({ name: 'RewardUnavailable' });
        } else {
          _this3.orderProcessing = true;
          var request = {};
          request.ro_id = _this3.rewardDetails.id;
          request.name = _this3.rewardDetails.name;
          request.image = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this3.getImageJson(_this3.rewardDetails.images[0]));
          request.price = _this3.hasRange ? _this3.minSalePrice : _this3.salePrice;
          _this3.$store.dispatch('ADD_SAVED_REWARD', request).then(function () {
            _this3.orderProcessing = false;
          }).catch(function () {
            _this3.orderProcessing = false;
          });
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getImageJson: function getImageJson(images) {
      var imageJson = {};
      if (images !== null && typeof images !== 'undefined') {
        if ('url' in images) {
          imageJson.original = images.url;
        }
        if ('sizes' in images) {
          var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(images.sizes);
          __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(keys, function (key) {
            imageJson[key] = images.sizes[key];
          });
        }
      }
      return imageJson;
    },
    confirmOrder: function confirmOrder(data) {
      var _this4 = this;

      var query = new URLSearchParams(data);
      this.orderQuantity = data.quantity;

      if (this.isProgramTotalLimitExeeded(data)) {
        this.orderErrorMessage = this.getSpentPointsOverProgramLimitMessage;
        this.showOrderErrorModal = true;
        this.closeOrderModal();
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].getAuthenticated('/rewards/order/' + this.rewardDetails.id + '?' + query).then(function (resp) {
        _this4.closeOrderModal();
        _this4.orderDetails = resp.data.result.order;

        _this4.$store.dispatch('LOAD_PARTICIPANT', _this4.$router);
        _this4.orderConfirmationMessage = _this4.getOrderConfirmationMessage;
        _this4.showOrderConfirmationModal = true;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (err) {
        _this4.closeOrderModal();
        if (err.response.data.result) {
          _this4.orderErrorMessage = err.response.data.result.error;
          _this4.showOrderErrorModal = true;
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    isProgramTotalLimitExeeded: function isProgramTotalLimitExeeded(orderData) {
      return this.hasRange ? parseFloat(orderData.point_price) * this.orderQuantity + this.platformPointCap.points_spent_period > this.platformPointCap.point_cap : parseFloat(this.salePrice) * this.orderQuantity + this.platformPointCap.points_spent_period > this.platformPointCap.point_cap;
    },
    toggleTermsConditions: function toggleTermsConditions() {
      this.showTermsConditions = !this.showTermsConditions;
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('LOAD_PARTICIPANT', this.$router);
    this.$store.commit('UPDATE_PRODUCT_DETAIL', null);
    this.$store.dispatch('LOAD_PLATFORM_POINT_CAP', this.$router);
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])(['participant', 'rewardDetails', 'platformPointCap']), {
    isSavedReward: function isSavedReward() {
      if (!this.rewardDetails || typeof this.rewardDetails.id === 'undefined') {
        return false;
      }
      return this.rewardDetails.saved_reward_id !== null;
    },
    currencyCode: function currencyCode() {
      if ('points_currency_code' in this.participant) {
        return this.participant.points_currency_code;
      }
      return '';
    },
    rewardSpecs: function rewardSpecs() {
      return this.rewardDetails !== null ? JSON.parse(this.rewardDetails.specifications) : null;
    },
    participantHasEnoughPoints: function participantHasEnoughPoints() {
      if (this.currencyCode === '') {
        return false;
      }
      return this.participant.points_balance >= parseFloat(this.salePrice);
    },
    getInsufficientPointsMessage: function getInsufficientPointsMessage() {
      var x = this.salePrice - this.participant.points_balance;
      return this.$t('web.catalog_reward.insufficient_points_message', { points: x });
    },
    participantSpentPointsOverProgramLimit: function participantSpentPointsOverProgramLimit() {
      return this.hasRange ? parseFloat(this.minSalePrice) + this.platformPointCap.points_spent_period > this.platformPointCap.point_cap : parseFloat(this.salePrice) + this.platformPointCap.points_spent_period > this.platformPointCap.point_cap;
    },
    participantSpentPointsOverProgramTotalLimit: function participantSpentPointsOverProgramTotalLimit() {
      return parseFloat(this.salePrice) * this.orderQuantity + this.platformPointCap.points_spent_period > this.platformPointCap.point_cap;
    },
    getSpentPointsOverProgramLimitItemMessage: function getSpentPointsOverProgramLimitItemMessage() {
      return this.$t('web.catalog_reward.points_spent_over_program_limit_item_msg');
    },
    getSpentPointsOverProgramLimitMessage: function getSpentPointsOverProgramLimitMessage() {
      var remainingPoints = this.platformPointCap.point_cap - this.platformPointCap.points_spent_period;
      var maxQuantity = Math.floor(remainingPoints / parseFloat(this.salePrice));
      return this.$t('web.catalog_reward.points_spent_over_program_limit_msg', { quantity: maxQuantity });
    },
    getOrderConfirmationMessage: function getOrderConfirmationMessage() {
      return this.$t('web.catalog_reward.order_confirmation', { reward_name: this.rewardDetails.name, order_id: this.orderDetails.program_order_id });
    },
    salePrice: function salePrice() {
      return this.rewardDetails.supplier_items[0].prices.sale_price[this.currencyCode] || this.rewardDetails.supplier_items[0].prices.sale_price[0];
    },
    rewardProperties: function rewardProperties() {
      return this.rewardDetails.properties ? this.rewardDetails.properties.filter(function (e) {
        return e.value || e.value === 0;
      }) : [];
    },
    rewardVariantProperties: function rewardVariantProperties() {
      return this.rewardDetails.variant_properties ? this.rewardDetails.variant_properties.filter(function (e) {
        return e.value || e.value === 0;
      }) : [];
    },
    hasRange: function hasRange() {
      return this.rewardDetails.supplier_items[0].prices.has_range;
    },
    minSalePrice: function minSalePrice() {
      return this.hasRange ? this.rewardDetails['supplier_items'][0]['prices']['sale_price_range']['min'] : 0;
    },
    minDefDollarPrice: function minDefDollarPrice() {
      return this.hasRange ? parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['min']) : 0;
    },
    maxDefDollarPrice: function maxDefDollarPrice() {
      return this.hasRange ? parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['max']) : 0;
    }
  })
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardOpsOrderCard',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusColor: function statusColor(status) {
      status = status ? status.toLowerCase() : '';
      switch (status) {
        case 'pending':
          status = 't-alert-warning';
          break;
        case 'processing':
          status = 't-alert-warning';
          break;
        case 'partial':
          status = 't-alert-danger';
          break;
        case 'rejected':
          status = 't-alert-danger';
          break;
        case 'failed':
          status = 't-alert-danger';
          break;
        case 'stopped':
          status = 't-alert-danger';
          break;
        case 'cancelled':
          status = 't-alert-plain';
          break;
        case 'sent':
          status = 't-alert-info';
          break;
        case 'delivered':
          status = 't-alert-success';
          break;
        case 'returned':
          status = 't-alert-success';
          break;
        default:
          status = 't-alert-plain';
          break;
      }
      return status;
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_components_catalog_RewardsFilters__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_components_catalog_RewardsFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_components_catalog_RewardsFilters__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsFilterModal',

  components: { RewardsFilters: __WEBPACK_IMPORTED_MODULE_0__views_components_catalog_RewardsFilters___default.a },

  methods: {
    applyFilters: function applyFilters() {
      this.close();
      this.$refs.rewardsFilters.applyFilters();
    },
    clearFilters: function clearFilters() {
      this.$refs.rewardsFilters.clearFilters();
    },
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








var initFilters = {
  category: null,
  price_min: null,
  price_max: null,
  sort: ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsFilters',

  data: function data() {
    return {
      categoriesLoading: true,
      filters: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["clone"])(initFilters),
      filtersLoading: false,
      showCategorySwitcher: false,
      sortOptions: [{
        name: this.$t('web.catalog_rewards_filters.sort_default'),
        value: ''
      }, {
        name: this.$t('web.catalog_rewards_filters.sort_points_desc'),
        value: 'member_sale_price,descending'
      }, {
        name: this.$t('web.catalog_rewards_filters.sort_points_asc'),
        value: 'member_sale_price,ascending'
      }, {
        name: this.$t('web.catalog_rewards_filters.sort_name_asc'),
        value: 'name,ascending'
      }, {
        name: this.$t('web.catalog_rewards_filters.sort_name_desc'),
        value: 'name,descending'
      }, {
        name: this.$t('web.catalog_rewards_filters.sort_age_asc'),
        value: 'created_date,descending'
      }, {
        name: this.$t('web.catalog_rewards_filters.sort_age_desc'),
        value: 'created_date,ascending'
      }]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['participant']), {
    filledFilters: function filledFilters() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["omitBy"])(this.filters, function (value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isArray"])(value) ? !value.length : !value;
      });
    },
    showRewardFilters: function showRewardFilters() {
      return Boolean(!this.showCategorySwitcher && this.selectedCategory);
    },
    selectedCategory: function selectedCategory() {
      var _this = this;

      return this.filters.category ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.$store.getters.categories, function (category) {
        return category.code.toString() === _this.filters.category.toString();
      }) : undefined;
    },
    selectedCategoryName: function selectedCategoryName() {
      return this.getCategoryName(this.selectedCategory) || this.$t('web.catalog_rewards_filters.no_category');
    }
  }),

  methods: {
    getFilterName: function getFilterName(filter) {
      if (filter.hasOwnProperty('property_key')) {
        return this.$t('web.catalog_rewards_filters.' + filter.property_key + '_label');
      }

      return this.$t('web.catalog_rewards_filters.brands_label');
    },
    getFiltersKeyFor: function getFiltersKeyFor(filter) {
      return filter.type === 'Label::Brand' ? 'brands' : (filter.property_key || filter.property_name).toLowerCase();
    },
    getOptionNameFor: function getOptionNameFor(option) {
      return option.name || option.value;
    },
    getOptionValueFor: function getOptionValueFor(option) {
      return option.id || option.value;
    },
    getCategoryName: function getCategoryName(category) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isObject"])(category) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isObject"])(category.name) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(category, 'name.' + this.participant.catalog_locale, '') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(category, 'name', null);
    },
    toggleCategorySwitcher: function toggleCategorySwitcher() {
      this.showCategorySwitcher = !this.showCategorySwitcher;
    },
    clearFilters: function clearFilters() {
      this.filters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["clone"])(initFilters);
    },
    applyFilters: function applyFilters() {
      this.$router.push({
        name: this.$route.name,
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["mapValues"])(this.$route.query.search ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["merge"])(this.filledFilters, { search: this.$route.query.search }) : this.filledFilters, function (value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isArray"])(value) ? value.join(',') : value;
        })
      });
    },
    selectCategory: function selectCategory(category) {
      this.clearFilters();
      this.getRewardCategoryFilters();
      this.toggleCategorySwitcher();

      this.filters.category = category.code;
    },
    getRewardCategoryFilters: function getRewardCategoryFilters() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.filtersLoading = true;
        _this2.$store.dispatch('GET_REWARD_FILTERS', { category: _this2.filters.category }).then(function () {
          _this2.filtersLoading = false;
        }).catch(function (error) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
      });
    },
    setKeysForFilters: function setKeysForFilters() {
      var _this3 = this;

      this.$store.getters.rewardFilters.forEach(function (rewardFilter) {
        var filterName = rewardFilter.type === 'Label::Brand' ? 'brands' : (rewardFilter.property_key || rewardFilter.property_name).toLowerCase();

        _this3.$set(_this3.filters, filterName, _this3.keysForFiltersSetPreviously || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(_this3.$route.query, filterName, []).length ? [] : _this3.$route.query[filterName].split(','));
      });

      this.keysForFiltersSetPreviously = true;
    }
  },

  watch: {
    '$store.getters.rewardFilters': function $storeGettersRewardFilters() {
      this.setKeysForFilters();
    },
    '$route.query.search': function $routeQuerySearch() {
      this.clearFilters();
      this.setKeysForFilters();
      this.filters.category = this.$route.query.category || null;
    },
    '$route.query.category': function $routeQueryCategory() {
      this.filters.category = this.$route.query.category || null;
    }
  },

  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(initFilters).forEach(function (filter) {
      _this4.filters[filter] = _this4.$route.query[filter] || _this4.filters[filter];
    });

    if (this.filters.category) {
      this.getRewardCategoryFilters();
    }

    this.$store.dispatch('GET_CATEGORIES').then(function () {
      _this4.categoriesLoading = false;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_numeric__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsList',
  components: {
    'vue-numeric': __WEBPACK_IMPORTED_MODULE_1_vue_numeric___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['rewards', 'participant']), {
    currencyCode: function currencyCode() {
      return this.participant.points_currency_code || 0;
    }
  }),
  methods: {
    getImgUrl: function getImgUrl(reward) {
      if (reward.images) {
        return reward.images[0].sizes['350x350'];
      } else if (reward.image) {
        return reward.image.url;
      }

      return '';
    },
    getRouterLink: function getRouterLink(reward) {
      if (reward.hasOwnProperty('id')) {
        return { name: 'Single Reward', params: { id: reward.id } };
      }

      return { name: 'Rewards Results', query: { category: reward.code } };
    },
    getRewardPrice: function getRewardPrice(reward) {
      if (this.rewardHasRange(reward)) {
        return reward.supplier_items[0].prices.sale_price_range.min;
      }

      return reward.supplier_items[0].prices.sale_price[this.currencyCode];
    },
    rewardHasRange: function rewardHasRange(reward) {
      return reward.supplier_items[0].prices.sale_price[this.currencyCode] === 0 && reward.supplier_items[0].prices.sale_price_range && reward.supplier_items[0].prices.sale_price_range.min;
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsFilterModal__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsFilterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsFilterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardsNavigation',

  components: { RewardsFilterModal: __WEBPACK_IMPORTED_MODULE_3__views_components_catalog_RewardsFilterModal___default.a },

  data: function data() {
    return {
      showFilterModal: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['participant']), {
    filtersApplied: function filtersApplied() {
      var appliedFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.$route.query);
      delete appliedFilters.page;
      delete appliedFilters.search;

      return Boolean(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(appliedFilters).length);
    },
    heading: function heading() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.$store.getters, 'categories', []), function (category) {
        return category.code === _this.$route.query.category;
      }), 'name.' + this.participant.catalog_locale, this.$t('web.catalog_rewards_navigation.no_category_title'));
    }
  }),

  methods: {
    toggleFilterModal: function toggleFilterModal() {
      document.querySelector('body').classList.toggle('has-modal');
      this.showFilterModal = !this.showFilterModal;
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchBar',

  data: function data() {
    return {
      queryInputFocused: false,
      query: this.$route.query.search
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['participant']), {
    appliedCategoryName: function appliedCategoryName() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.$store.getters, 'categories', []), function (category) {
        return category.code === _this.$route.query.category;
      }), 'name.' + this.participant.catalog_locale);
    },
    contexts: function contexts() {
      return this.$route.query.category ? [{
        label: this.$t('web.catalog_search_bar.search_all_categories')
      }, {
        label: this.$t('web.catalog_search_bar.search_current_category', { current_category: this.appliedCategoryName }),
        otherParams: { category: this.$route.query.category }
      }] : [];
    },
    isSavedRewardsPage: function isSavedRewardsPage() {
      return this.$route.name === 'SavedRewards';
    },
    showContextsDropdown: function showContextsDropdown() {
      return this.contexts.length && this.query && this.queryInputFocused;
    }
  }),

  methods: {
    toggleQueryInputFocused: function toggleQueryInputFocused() {
      var _this2 = this;

      setTimeout(function () {
        _this2.queryInputFocused = !_this2.queryInputFocused;
      }, 100);
    },
    queryRewards: function queryRewards($event, otherParams) {
      var query = this.query ? { search: this.query } : {};

      this.$router.push({
        name: 'Rewards Results',
        query: (typeof otherParams === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(otherParams)) === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(query, otherParams) : query
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  methods: {
    update: function update(target) {
      var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).prop('checked') ? 1 : 0;
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],

  computed: {
    formatUSD: function formatUSD() {
      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(this.value);
    }
  },

  methods: {
    update: function update(target) {
      var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target)[0].value;
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  data: function data() {
    return {
      fieldValue: ''
    };
  },

  watch: {
    value: function value() {
      this.calculateValue();
    }
  },
  mounted: function mounted() {
    this.calculateValue();
  },

  methods: {
    calculateValue: function calculateValue() {
      if (this.template !== 'edit') {
        return;
      }
      var fieldType = this.$refs.input.type;

      if (/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(this.value) && typeof fieldType !== 'undefined' && fieldType === 'date') {
        var dateParts = this.value.split('/');
        var month = dateParts[0];
        var day = dateParts[1];
        var year = dateParts[2];
        this.fieldValue = [year, month, day].join('-');
      } else {
        this.fieldValue = this.value;
      }
    },
    update: function update(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  data: function data() {
    return {
      maxLength: 14
    };
  },
  methods: {
    update: function update(target) {
      var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target)[0].value;
      var formattedValue = value.trim();

      this.maxLength = formattedValue.indexOf('.') !== -1 ? 15 : 14;
      if (formattedValue.indexOf('-') !== -1) {
        this.maxLength = this.maxLength + 1;
      }
      if (formattedValue.length > this.maxLength) {
        formattedValue = formattedValue.slice(0, this.maxLength);
      }
      if (formattedValue !== value) {
        this.$refs.input.value = formattedValue;
      }
      this.$emit('input', formattedValue);
    },
    formattedNumber: function formattedNumber(value) {
      if (typeof value !== 'undefined' && value !== null) {
        var numberArray = value.toString().split('.');
        var integerPart = __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].formatNumber(numberArray[0]);
        numberArray[0] = integerPart;
        return numberArray.join('.');
      }
      return '';
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  computed: {
    maxlength: function maxlength() {
      return this.field.maxlength ? this.field.maxlength : 255;
    }
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  computed: {
    displayValue: function displayValue() {
      return __WEBPACK_IMPORTED_MODULE_0__functions__["a" /* default */].getDropdownLabel(this.value, this.field.options);
    }
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      dropzoneOptions: {
        url: 'ignore-me',
        autoProcessQueue: false,
        autoQueue: false,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: 'contain',
        clickable: true,
        addRemoveLinks: true,
        dictDefaultMessage: this.$t('web.field_file_upload.dropzone_message'),
        dictRemoveFile: this.$t('web.field_file_upload.dropzone_remove_file'),
        maxFiles: 20
      },

      existingFiles: this.value
    };
  },
  updated: function updated() {
    this.addExistingFiles();
  },


  methods: {
    showFile: function showFile(file, download) {
      var url = 'files/' + file.id;
      __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].getAuthenticated(url, { responseType: 'blob' }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].triggerFileDownload(res.data, file.filename, res.data.type, download);
      });
    },
    fileAdded: function fileAdded(file) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(file.previewElement).find('.dz-progress').hide();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(file.previewElement).find('.dz-size').hide();
      this.update();
    },
    fileRemoved: function fileRemoved(file) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.existingFiles, function (existingFile, i) {
        if (typeof existingFile !== 'undefined' && existingFile.id === file.id) {
          _this.existingFiles.splice(i, 1);
        }
      });
      this.update();
    },
    addExistingFiles: function addExistingFiles() {
      var _this2 = this;

      this.existingFiles = this.value;
      if (this.template === 'edit') {
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.existingFiles, function (file, i) {
          var mockFile = { id: file.id, name: file.filename, size: 1 };
          _this2.$refs.dropzone.manuallyAddFile(mockFile, '/img/thm350.png');
        });
        this.update();
      }
    },
    update: function update() {
      var files = this.$refs.dropzone.getAddedFiles();
      var value = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(files, function (file) {
        value.push(file.name);
      });
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.existingFiles, function (file, i) {
        value.push({ id: file.id, name: file.filename });
      });
      if (value.length === 0) {
        value = null;
      }
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  methods: {
    update: function update(target) {
      var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target)[0].value;
      this.$emit('input', value);
    },
    formattedNumber: function formattedNumber(value) {
      return __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].formatNumber(value);
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],

  methods: {
    update: function update(target) {
      var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target)[0].value;
      var formattedValue = value.trim();

      var maxLength = formattedValue.indexOf('.') !== -1 ? 15 : 14;
      if (formattedValue.indexOf('-') !== -1) {
        maxLength = maxLength + 1;
      }
      if (formattedValue.length > maxLength) {
        formattedValue = formattedValue.slice(0, maxLength);
      }
      if (formattedValue !== value) {
        this.$refs.input.value = formattedValue;
      }
      this.$emit('input', formattedValue);
    },
    formattedNumber: function formattedNumber(value) {
      if (typeof value !== 'undefined' && value !== null) {
        var numberArray = value.toString().split('.');
        var integerPart = __WEBPACK_IMPORTED_MODULE_1__functions__["a" /* default */].formatNumber(numberArray[0]);
        numberArray[0] = integerPart;
        return numberArray.join('.') + '%';
      }
      return '';
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'value', 'labelClass', 'template'],
  computed: {
    maxlength: function maxlength() {
      return this.field.maxlength ? this.field.maxlength : 255;
    }
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldCurrency__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fields_FieldCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_FieldVarchar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_FieldVarchar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_FieldVarchar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_FieldEmail__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_FieldEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fields_FieldEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_FieldDate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_FieldDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fields_FieldDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_FieldInteger__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_FieldInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fields_FieldInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_FieldBool__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_FieldBool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__fields_FieldBool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fields_FieldEnum__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fields_FieldEnum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__fields_FieldEnum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fields_FieldFileUpload__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fields_FieldFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fields_FieldFileUpload__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['forms', 'formIndex'],

  data: function data() {
    return {
      model: {},
      errors: {},
      submitError: false,
      processingForm: false,
      dataToBeSaved: {}
    };
  },


  components: {
    fieldCurrency: __WEBPACK_IMPORTED_MODULE_5__fields_FieldCurrency___default.a,
    fieldVarchar: __WEBPACK_IMPORTED_MODULE_6__fields_FieldVarchar___default.a,
    fieldEmail: __WEBPACK_IMPORTED_MODULE_7__fields_FieldEmail___default.a,
    fieldDate: __WEBPACK_IMPORTED_MODULE_8__fields_FieldDate___default.a,
    fieldDecimal: __WEBPACK_IMPORTED_MODULE_10__fields_FieldDecimal___default.a,
    fieldInteger: __WEBPACK_IMPORTED_MODULE_9__fields_FieldInteger___default.a,
    fieldPercent: __WEBPACK_IMPORTED_MODULE_11__fields_FieldPercent___default.a,
    fieldBool: __WEBPACK_IMPORTED_MODULE_12__fields_FieldBool___default.a,
    fieldEnum: __WEBPACK_IMPORTED_MODULE_13__fields_FieldEnum___default.a,
    fieldFileUpload: __WEBPACK_IMPORTED_MODULE_14__fields_FieldFileUpload___default.a
  },

  mounted: function mounted() {
    this.model = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.forms[this.formIndex].field_values);
  },


  methods: {
    getFieldComponentType: function getFieldComponentType(field) {
      return 'field-' + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(field.type, '_', '-');
    },
    validateForm: function validateForm() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.forms[this.formIndex].fields, function (item) {
        _this.$set(_this.errors, item.name, null);
      });
      var valid = true;
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.forms[this.formIndex].fields, function (field, i) {
        var error = __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].validateField(field, _this.model[field.name], __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$children[i].$refs.input)[0]);
        if (error !== '') {
          _this.errors[field.name] = [error];
          valid = false;
        }
      });
      return valid;
    },
    cancel: function cancel() {
      this.$parent.$emit('cancelled-form');
    },
    submit: function submit() {
      var _this2 = this;

      if (this.validateForm()) {
        this.processingForm = true;
        var formData = new FormData();
        var hasFiles = false;
        this.dataToBeSaved = __WEBPACK_IMPORTED_MODULE_4__functions__["a" /* default */].getDataToBeSaved(this.forms[this.formIndex].fields, this.model);
        formData.append('fields', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.dataToBeSaved));
        formData.append('form_id', this.forms[this.formIndex].id);
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.forms[this.formIndex].fields, function (field, i) {
          if (field.type === 'file_upload') {
            hasFiles = true;
          }
        });
        if (hasFiles) {
          __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].postAuthenticated('claim-forms/validate', formData).then(function (response) {
            _this2.sendFormData(formData);
          }).catch(this.processAPIError);
        } else {
          this.sendFormData(formData);
        }
      }
    },
    sendFormData: function sendFormData(formData) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.forms[this.formIndex].fields, function (field, i) {
        if (field.type === 'file_upload') {
          var files = _this3.$children[i].$refs.dropzone.getAddedFiles();
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(files, function (file) {
            formData.append(field.name + '[]', file);
          });
        }
      });

      this.submitError = false;

      __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].postAuthenticated('claim-forms', formData).then(function (response) {
        _this3.$parent.$emit('submitted-form');
      }).catch(this.processAPIError);
    },
    processAPIError: function processAPIError(error) {
      this.processingForm = false;

      if (error.response && error.response.status === 400) {
        for (var field in error.response.data.errors) {
          this.errors[field] = error.response.data.errors[field];
        }
      } else {
        this.submitError = true;
      }
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['forms', 'submittedForm'],
  methods: {
    openForm: function openForm(formIndex) {
      this.$parent.$emit('open-form', formIndex);
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pagination: {
      type: Object,
      required: true
    },
    pagingCallback: {
      type: Function,
      required: true
    }
  }
});

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 103,
	"./af.js": 103,
	"./ar": 110,
	"./ar-dz": 104,
	"./ar-dz.js": 104,
	"./ar-kw": 105,
	"./ar-kw.js": 105,
	"./ar-ly": 106,
	"./ar-ly.js": 106,
	"./ar-ma": 107,
	"./ar-ma.js": 107,
	"./ar-sa": 108,
	"./ar-sa.js": 108,
	"./ar-tn": 109,
	"./ar-tn.js": 109,
	"./ar.js": 110,
	"./az": 111,
	"./az.js": 111,
	"./be": 112,
	"./be.js": 112,
	"./bg": 113,
	"./bg.js": 113,
	"./bm": 114,
	"./bm.js": 114,
	"./bn": 115,
	"./bn.js": 115,
	"./bo": 116,
	"./bo.js": 116,
	"./br": 117,
	"./br.js": 117,
	"./bs": 118,
	"./bs.js": 118,
	"./ca": 119,
	"./ca.js": 119,
	"./cs": 120,
	"./cs.js": 120,
	"./cv": 121,
	"./cv.js": 121,
	"./cy": 122,
	"./cy.js": 122,
	"./da": 123,
	"./da.js": 123,
	"./de": 126,
	"./de-at": 124,
	"./de-at.js": 124,
	"./de-ch": 125,
	"./de-ch.js": 125,
	"./de.js": 126,
	"./dv": 127,
	"./dv.js": 127,
	"./el": 128,
	"./el.js": 128,
	"./en-au": 129,
	"./en-au.js": 129,
	"./en-ca": 130,
	"./en-ca.js": 130,
	"./en-gb": 131,
	"./en-gb.js": 131,
	"./en-ie": 132,
	"./en-ie.js": 132,
	"./en-nz": 133,
	"./en-nz.js": 133,
	"./eo": 134,
	"./eo.js": 134,
	"./es": 137,
	"./es-do": 135,
	"./es-do.js": 135,
	"./es-us": 136,
	"./es-us.js": 136,
	"./es.js": 137,
	"./et": 138,
	"./et.js": 138,
	"./eu": 139,
	"./eu.js": 139,
	"./fa": 140,
	"./fa.js": 140,
	"./fi": 141,
	"./fi.js": 141,
	"./fo": 142,
	"./fo.js": 142,
	"./fr": 145,
	"./fr-ca": 143,
	"./fr-ca.js": 143,
	"./fr-ch": 144,
	"./fr-ch.js": 144,
	"./fr.js": 145,
	"./fy": 146,
	"./fy.js": 146,
	"./gd": 147,
	"./gd.js": 147,
	"./gl": 148,
	"./gl.js": 148,
	"./gom-latn": 149,
	"./gom-latn.js": 149,
	"./gu": 150,
	"./gu.js": 150,
	"./he": 151,
	"./he.js": 151,
	"./hi": 152,
	"./hi.js": 152,
	"./hr": 153,
	"./hr.js": 153,
	"./hu": 154,
	"./hu.js": 154,
	"./hy-am": 155,
	"./hy-am.js": 155,
	"./id": 156,
	"./id.js": 156,
	"./is": 157,
	"./is.js": 157,
	"./it": 158,
	"./it.js": 158,
	"./ja": 159,
	"./ja.js": 159,
	"./jv": 160,
	"./jv.js": 160,
	"./ka": 161,
	"./ka.js": 161,
	"./kk": 162,
	"./kk.js": 162,
	"./km": 163,
	"./km.js": 163,
	"./kn": 164,
	"./kn.js": 164,
	"./ko": 165,
	"./ko.js": 165,
	"./ky": 166,
	"./ky.js": 166,
	"./lb": 167,
	"./lb.js": 167,
	"./lo": 168,
	"./lo.js": 168,
	"./lt": 169,
	"./lt.js": 169,
	"./lv": 170,
	"./lv.js": 170,
	"./me": 171,
	"./me.js": 171,
	"./mi": 172,
	"./mi.js": 172,
	"./mk": 173,
	"./mk.js": 173,
	"./ml": 174,
	"./ml.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 177,
	"./ms-my": 176,
	"./ms-my.js": 176,
	"./ms.js": 177,
	"./mt": 178,
	"./mt.js": 178,
	"./my": 179,
	"./my.js": 179,
	"./nb": 180,
	"./nb.js": 180,
	"./ne": 181,
	"./ne.js": 181,
	"./nl": 183,
	"./nl-be": 182,
	"./nl-be.js": 182,
	"./nl.js": 183,
	"./nn": 184,
	"./nn.js": 184,
	"./pa-in": 185,
	"./pa-in.js": 185,
	"./pl": 186,
	"./pl.js": 186,
	"./pt": 188,
	"./pt-br": 187,
	"./pt-br.js": 187,
	"./pt.js": 188,
	"./ro": 189,
	"./ro.js": 189,
	"./ru": 190,
	"./ru.js": 190,
	"./sd": 191,
	"./sd.js": 191,
	"./se": 192,
	"./se.js": 192,
	"./si": 193,
	"./si.js": 193,
	"./sk": 194,
	"./sk.js": 194,
	"./sl": 195,
	"./sl.js": 195,
	"./sq": 196,
	"./sq.js": 196,
	"./sr": 198,
	"./sr-cyrl": 197,
	"./sr-cyrl.js": 197,
	"./sr.js": 198,
	"./ss": 199,
	"./ss.js": 199,
	"./sv": 200,
	"./sv.js": 200,
	"./sw": 201,
	"./sw.js": 201,
	"./ta": 202,
	"./ta.js": 202,
	"./te": 203,
	"./te.js": 203,
	"./tet": 204,
	"./tet.js": 204,
	"./th": 205,
	"./th.js": 205,
	"./tl-ph": 206,
	"./tl-ph.js": 206,
	"./tlh": 207,
	"./tlh.js": 207,
	"./tr": 208,
	"./tr.js": 208,
	"./tzl": 209,
	"./tzl.js": 209,
	"./tzm": 211,
	"./tzm-latn": 210,
	"./tzm-latn.js": 210,
	"./tzm.js": 211,
	"./uk": 212,
	"./uk.js": 212,
	"./ur": 213,
	"./ur.js": 213,
	"./uz": 215,
	"./uz-latn": 214,
	"./uz-latn.js": 214,
	"./uz.js": 215,
	"./vi": 216,
	"./vi.js": 216,
	"./x-pseudo": 217,
	"./x-pseudo.js": 217,
	"./yo": 218,
	"./yo.js": 218,
	"./zh-cn": 219,
	"./zh-cn.js": 219,
	"./zh-hk": 220,
	"./zh-hk.js": 220,
	"./zh-tw": 221,
	"./zh-tw.js": 221
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;

/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  "data-v-b017b480",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(441)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  "data-v-303d4958",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-5d63aab9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  "data-v-41fe41a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  "data-v-22e510a1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  "data-v-2c284342",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  "data-v-2f73fd78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-4e73a7e1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  "data-v-6be77d4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  "data-v-11e04fda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(461)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-f42d2144",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  "data-v-c95b2df6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(458)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-ac751826",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  "data-v-00114274",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  "data-v-7c82f819",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  "data-v-566da34e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(442)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  "data-v-3562ac04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  "data-v-395032fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "c-card--orders__single__order-number card-subcontainer"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_number', {
    order_number: _vm.order.short_order_id
  })))]), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__single__datagroup order-info-group"
  }, [_c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.date')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.points')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v("\n        " + _vm._s(_vm.order.order_total) + "\n      ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.quantity')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.item_quantity))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_status')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.statusColor(_vm.order.order_status)
  }, [_vm._v(_vm._s(_vm.order.order_status))])])])]), _vm._v(" "), _vm._l((_vm.order.line_items), function(lineItem) {
    return _c('div', {
      key: lineItem.id,
      staticClass: "card-subcontainer"
    }, [_c('p', {
      staticClass: "c-card--orders__single__item"
    }, [_c('router-link', {
      staticClass: "t-link",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: lineItem.item.id
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(lineItem.item.name) + "\n      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "c-card--orders__single__datagroup"
    }, [_c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.line_item')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v(_vm._s(lineItem.line_item_number))])]), _vm._v(" "), _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.points')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_c('i', {
      staticClass: "fa fa-star t-points-icon"
    }), _vm._v("\n          " + _vm._s(lineItem.line_item_points_amount_charged) + "\n        ")])]), _vm._v(" "), _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.updated')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v(_vm._s(lineItem.updated_at))])]), _vm._v(" "), _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_c('span', {
      staticClass: "c-status",
      class: _vm.statusColor(lineItem.line_item_order_status)
    }, [_vm._v(_vm._s(lineItem.line_item_order_status))])])])]), _vm._v(" "), _c('div', {
      staticClass: "c-card--orders__single__datagroup"
    }, [(!lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.shipping_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_c('span', {
      staticClass: "c-status",
      class: _vm.statusColor(lineItem.line_item_shipping_status)
    }, [_vm._v(_vm._s(lineItem.line_item_shipping_status))])])]) : _vm._e(), _vm._v(" "), (!lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [(lineItem.item.item_type.redemption_flow.toLowerCase() === 'digital confirmation') ? _c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.travel_certificate')))]) : _c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v("\n          " + _vm._s(lineItem.carrier_tracking) + "\n          "), (!lineItem.carrier_tracking) ? _c('span', {
      staticClass: "c-card--orders__single__data__value__empty"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking_unavailable')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.email_delivery_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v("\n          " + _vm._s(lineItem.email_status) + "\n        ")])]) : _vm._e(), _vm._v(" "), (lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.email_engagement_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v("\n          " + _vm._s(lineItem.email_engagement_event) + "\n          "), (!lineItem.email_engagement_event) ? _c('span', {
      staticClass: "c-card--orders__single__data__value__empty"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking_unavailable')))]) : _vm._e()])]) : _vm._e()])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-forgot-password"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.reset_password.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-forgot-password__main"
  }, [_c('section', {
    staticClass: "c-card js-reset-validation-shake"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.reset_password.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [(_vm.error_message) ? _c('div', {
    staticClass: "c-form-validation t-alert-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.error_message) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.is_password_expired && !_vm.error_message) ? _c('div', {
    staticClass: "c-form-validation t-alert-info"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.reset_password.expired_password')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_label')))]), _vm._v(" "), _c('ul', {
    staticClass: "u-tiny-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_12_characters')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_number')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_symbol')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_uppercase')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password),
      expression: "request.password"
    }],
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.password) ? _c('div', {
    staticClass: "c-validation t-alert-danger",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errors.password[0]) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.reset_password.confirm_new_password_label')) + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password_confirmation),
      expression: "request.password_confirmation"
    }],
    attrs: {
      "id": "password_confirmation",
      "type": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.password_confirmation) ? _c('div', {
    staticClass: "c-validation t-alert-danger",
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errors.password_confirmation[0]) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [(!_vm.is_password_expired) ? _c('router-link', {
    staticClass: "c-card__footer__text-link u-tiny-note u-float-left t-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.reset_password.login_link')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "c-button u-float-right t-button-primary",
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.is_password_expired ? _vm.$t('web.settings.save_button') : _vm.$t('web.reset_password.save_and_login')) + "\n          ")])], 1)])])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-searchbar"
  }, [_c('div', {
    staticClass: "c-searchbar__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "c-searchbar__search__query-input",
    attrs: {
      "type": "text",
      "name": "rewards_query_input",
      "placeholder": _vm.$t('web.catalog_search_bar.search_placeholder')
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryRewards($event)
      },
      "focus": _vm.toggleQueryInputFocused,
      "blur": _vm.toggleQueryInputFocused,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContextsDropdown),
      expression: "showContextsDropdown"
    }],
    staticClass: "c-searchbar__search__dropdown"
  }, _vm._l((_vm.contexts), function(context) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(_vm.query + ' <i>' + context.label + '</i>')
      },
      on: {
        "click": function($event) {
          return _vm.queryRewards($event, context.otherParams)
        }
      }
    })
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "c-searchbar__search__button t-button-plain-color",
    on: {
      "click": _vm.queryRewards
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-searchbar__saved-for-later",
    class: [_vm.isSavedRewardsPage ? 'u-disable-hover-cursor t-button-primary' : 't-button-plain-color'],
    attrs: {
      "to": {
        name: 'SavedRewards'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination.pages !== null) ? _c('nav', {
    staticClass: "c-pagination t-pagination"
  }, [_c('button', {
    staticClass: "c-pagination__button c-pagination__button--previous t-pagination__button",
    attrs: {
      "disabled": _vm.pagination.previous === null
    },
    on: {
      "click": function($event) {
        return _vm.pagingCallback(_vm.pagination.previous)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-pagination__numbers"
  }, _vm._l((_vm.pagination.pages), function(page) {
    return (page != '...') ? _c('a', {
      staticClass: "c-pagination__numbers__number t-pagination__number",
      class: {
        'is-active': page === _vm.pagination.current
      },
      on: {
        "click": function($event) {
          return _vm.pagingCallback(page)
        }
      }
    }, [_c('span', {
      staticClass: "c-pagination__numbers__number__box t-pagination__number__box"
    }, [_vm._v(_vm._s(page))])]) : _c('span', {
      staticClass: "c-pagination__numbers__filler"
    }, [_vm._v(_vm._s(page))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "c-pagination__button c-pagination__button--next t-pagination__button",
    attrs: {
      "disabled": _vm.pagination.next === null
    },
    on: {
      "click": function($event) {
        return _vm.pagingCallback(_vm.pagination.next)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-card--claim-forms__body"
  }, [(_vm.submitError) ? _c('div', {
    staticClass: "c-validation t-alert-danger u-margin-bottom-10"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('web.card_claims_submitter.submit_error')))])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('h3', {
    staticClass: "u-h1 u-no-top-margin"
  }, [_vm._v(_vm._s(_vm.forms[_vm.formIndex].name))]), _vm._v(" "), (_vm.forms[_vm.formIndex].description) ? _c('p', [_vm._v(_vm._s(_vm.forms[_vm.formIndex].description))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.forms[_vm.formIndex].fields), function(field) {
    return _c('fieldset', {
      staticClass: "o-fieldset c-card--claim-forms__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "template": 'edit'
      },
      model: {
        value: (_vm.model[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.model, field.name, $$v)
        },
        expression: "model[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', [_c('div', {
        staticClass: "c-validation t-alert-danger"
      }, [_vm._v(_vm._s(error))])])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "c-card--claim-forms__footer"
  }, [_c('button', {
    ref: "cancelButton",
    staticClass: "c-button t-button-plain qa-cancel",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.form_detail.cancel_button')) + "\n    ")]), _vm._v(" "), _c('button', {
    ref: "submitButton",
    staticClass: "c-button\n                   c-card--claim-forms__footer__button\n                   t-button-primary\n                   qa-submit-this-claim",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.form_detail.submit_button')) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-settings"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.settings.nav_space'),
      "hideAuxNavOnDesktop": true
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-settings__main"
  }, [_c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left__title"
  }, [_vm._v(_vm._s(_vm.full_name))])]), _vm._v(" "), _c('div', {
    staticClass: "c-page-header__right"
  }, [_c('a', {
    staticClass: "c-button t-button-primary qa-logout",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.settings.logout')) + "\n        ")])])]), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--setting"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.card_account_info_header')))])]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.primary_email_label')))]), _vm._v(" "), (_vm.layout.section1.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('p', {
    staticClass: "c-card--setting__content u-word-wrap"
  }, [_vm._v(_vm._s(_vm.participant.primary_email))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.primary_email_hint')))]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-username",
    on: {
      "click": function($event) {
        return _vm.edit('section1')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section1.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('label', {
    staticClass: "u-hidden-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.settings.primary_email_label')) + _vm._s(_vm.metadata.primary_email.required ? '*' : '') + "\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.primary_email),
      expression: "participant.primary_email"
    }],
    staticClass: "qa-settings-username-input",
    attrs: {
      "type": "email",
      "name": "username",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "primary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.settings.primary_email_hint')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.errors.primary_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation qa-validation"
    }, [_vm._v("\n              " + _vm._s(error) + "\n            ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-cancel-username",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": function($event) {
        return _vm.save('section1')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])], 2) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.password_label')))]), _vm._v(" "), (_vm.layout.password_section.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('p', {
    staticClass: "c-card--setting__content"
  }, [_vm._v("************")]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-password",
    on: {
      "click": function($event) {
        return _vm.edit('password_section')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.password_section.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('ul', {
    staticClass: "u-tiny-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('web.settings.new_password_minimum_12_characters_note')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.settings.new_password_minimum_1_number_note')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_symbol')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.settings.new_password_minimum_1_uppercase_note')))])]), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "old_password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.settings.old_password_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.old_password),
      expression: "participant.old_password"
    }],
    staticClass: "qa-settings-old-password-input",
    attrs: {
      "type": "password",
      "name": "old_password",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "old_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.old_password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "new_password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.settings.new_password_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.new_password),
      expression: "participant.new_password"
    }],
    staticClass: "qa-settings-new-password-input",
    attrs: {
      "type": "password",
      "name": "new_password",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.new_password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "confirm_new_password"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.confirm_new_password_label')) + "*\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.confirm_new_password),
      expression: "participant.confirm_new_password"
    }],
    staticClass: "qa-settings-confirm-password-input",
    attrs: {
      "type": "password",
      "name": "confirm_new_password",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.confirm_new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "confirm_new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.confirm_new_password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-cancel-password",
    attrs: {
      "tabindex": "5"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.save('password_section')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.name_label')))]), _vm._v(" "), (_vm.layout.section3.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('label', {
    staticClass: "u-sub-label u-hidden-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.name_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (_vm.full_name === _vm.$t('web.settings.name_not_entered'))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.full_name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-name",
    on: {
      "click": function($event) {
        return _vm.edit('section3')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section3.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.first_name_label')) + _vm._s(_vm.metadata.first_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.first_name),
      expression: "participant.first_name"
    }],
    staticClass: "qa-settings-first-name-input",
    attrs: {
      "type": "text",
      "name": "first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.last_name_label')) + _vm._s(_vm.metadata.last_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.last_name),
      expression: "participant.last_name"
    }],
    staticClass: "qa-settings-last-name-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.save('section3')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.preferred_name_label')))]), _vm._v(" "), (_vm.layout.section4.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (_vm.preferred_full_name === _vm.$t('web.settings.preferred_name_not_entered'))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.preferred_full_name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-preferredname",
    on: {
      "click": function($event) {
        return _vm.edit('section4')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section4.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "preferred_first_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.preferred_first_name_label')) + _vm._s(_vm.metadata.preferred_first_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.preferred_first_name),
      expression: "participant.preferred_first_name"
    }],
    staticClass: "qa-settings-preferred-first-name-input",
    attrs: {
      "type": "text",
      "name": "preferred_first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.preferred_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "preferred_first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.preferred_first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "preferred_last_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.preferred_last_name_label')) + _vm._s(_vm.metadata.preferred_last_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.preferred_last_name),
      expression: "participant.preferred_last_name"
    }],
    staticClass: "qa-settings-preferred-last-name-input",
    attrs: {
      "type": "text",
      "name": "preferred_last_name",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.preferred_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "preferred_last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.preferred_last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.save('section4')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.customProfile.fields.length > 0) ? _c('section', {
    staticClass: "c-card c-card--setting"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.customProfile.name))])]), _vm._v(" "), _vm._l((_vm.customProfile.fields), function(field) {
    return _c('section', {
      staticClass: "c-card--setting__section"
    }, [(_vm.layout['custom_section_' + field.name]) ? _c('h3', {
      staticClass: "c-card--setting__view-label u-label"
    }, [_vm._v("\n          " + _vm._s(field.label) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.layout['custom_section_' + field.name] &&
      _vm.layout['custom_section_' + field.name].template == 'detail') ? _c('div', {
      staticClass: "c-card--setting__view-fields",
      attrs: {
        "name": field.name
      }
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "labelClass": "u-hidden-label",
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "template": _vm.layout['custom_section_' + field.name].template
      },
      model: {
        value: (_vm.participant[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.participant, field.name, $$v)
        },
        expression: "participant[field.name]"
      }
    }), _vm._v(" "), (!field.readonly) ? _c('div', {
      staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
    }, [_c('button', {
      staticClass: "c-button t-button-plain",
      class: 'qa-' + field.name + '__edit',
      on: {
        "click": function($event) {
          return _vm.edit('custom_section_' + field.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.layout['custom_section_' + field.name] &&
      _vm.layout['custom_section_' + field.name].template == 'edit' &&
      !field.readonly) ? _c('div', {
      staticClass: "c-card--setting__edit-fields"
    }, [_c('fieldset', {
      staticClass: "o-fieldset c-card--submit-claim__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "labelClass": "u-hidden-label",
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "template": _vm.layout['custom_section_' + field.name].template
      },
      model: {
        value: (_vm.participant[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.participant, field.name, $$v)
        },
        expression: "participant[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', [_c('div', {
        staticClass: "c-validation t-alert-danger qa-validation"
      }, [_vm._v(_vm._s(error))])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
    }, [_c('button', {
      staticClass: "c-button t-button-plain",
      class: 'qa-cancel',
      attrs: {
        "tabindex": "3"
      },
      on: {
        "click": function($event) {
          return _vm.reset()
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "c-button t-button-primary qa-save",
      class: 'qa-save',
      attrs: {
        "tabindex": "2"
      },
      on: {
        "click": function($event) {
          return _vm.save('custom_section_' + field.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--setting"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.card_contact_info_header')))])]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.email_addresses_label')))]), _vm._v(" "), (_vm.layout.section6.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.secondary_email_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph u-word-wrap",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.secondary_email)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.secondary_email ? _vm.participant.secondary_email : _vm.$t('web.settings.secondary_email_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.other_email_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph u-word-wrap",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.other_email)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.other_email ? _vm.participant.other_email : _vm.$t('web.settings.other_email_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-email-addresses",
    on: {
      "click": function($event) {
        return _vm.edit('section6')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section6.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__section-fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "secondary_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.secondary_email_label')) + _vm._s(_vm.metadata.secondary_email.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.secondary_email),
      expression: "participant.secondary_email"
    }],
    staticClass: "qa-settings-secondary-email-input",
    attrs: {
      "type": "email",
      "name": "secondary_email",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.secondary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "secondary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.secondary_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__section-fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "other_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.other_email_label')) + _vm._s(_vm.metadata.other_email.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.other_email),
      expression: "participant.other_email"
    }],
    staticClass: "qa-settings-other-email-input",
    attrs: {
      "type": "email",
      "name": "other_email",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.other_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "other_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.other_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.save('section6')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section c-card--setting__section--phones"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.phone_numbers_label')))]), _vm._v(" "), (_vm.layout.section7.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.mobile_phone_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.mobile_phone)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.mobile_phone ? _vm.participant.mobile_phone : _vm.$t('web.settings.mobile_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.business_phone_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.business_phone)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.business_phone ? _vm.participant.business_phone : _vm.$t('web.settings.business_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.home_phone_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.home_phone)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.home_phone ? _vm.participant.home_phone : _vm.$t('web.settings.home_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-phone-numbers",
    on: {
      "click": function($event) {
        return _vm.edit('section7')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section7.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "mobile_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.mobile_phone_label')) + _vm._s(_vm.metadata.mobile_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.mobile_phone),
      expression: "participant.mobile_phone"
    }],
    staticClass: "qa-settings-mobile-phone-input",
    attrs: {
      "type": "text",
      "name": "mobile_phone",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.mobile_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "mobile_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.mobile_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "business_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.business_phone_label')) + _vm._s(_vm.metadata.business_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.business_phone),
      expression: "participant.business_phone"
    }],
    staticClass: "qa-settings-business-phone-input",
    attrs: {
      "type": "text",
      "name": "business_phone",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.business_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "business_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.business_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_phone_label')) + _vm._s(_vm.metadata.home_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_phone),
      expression: "participant.home_phone"
    }],
    staticClass: "qa-settings-home-phone-input",
    attrs: {
      "type": "text",
      "name": "home_phone",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.home_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "5"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.save('section7')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.home_address_label')))]), _vm._v(" "), (_vm.layout.section8.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [(_vm.home_address_empty) ? _c('address', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_address_not_entered')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.home_address_empty) ? _c('address', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.home_address1) + " "), (_vm.participant.home_address1) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.home_address2) + " "), (_vm.participant.home_address2) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.home_city ? (_vm.participant.home_city + ', ') : '') + "\n              " + _vm._s(_vm.participant.home_state ? (_vm.participant.home_state + ' ') : '') + "\n              " + _vm._s(_vm.participant.home_zip_code) + " "), (_vm.participant.home_country) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getDropdownLabel(_vm.participant.home_country, _vm.metadata.home_country.options)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-legal-address",
    on: {
      "click": function($event) {
        return _vm.edit('section8')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section8.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.home_address_hint')))]), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__fieldset--address"
  }, [_c('label', {
    staticClass: "u-sub-label u-word-wrap",
    attrs: {
      "for": "home_address1"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_address1_label')) + _vm._s(_vm.metadata.home_address1.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_address1),
      expression: "participant.home_address1"
    }],
    staticClass: "qa-settings-street-line-1-input",
    attrs: {
      "type": "text",
      "name": "home_address2",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.home_address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_address1), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_address2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_address2_label')) + _vm._s(_vm.metadata.home_address2.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_address2),
      expression: "participant.home_address2"
    }],
    staticClass: "qa-settings-street-line-2-input",
    attrs: {
      "type": "text",
      "name": "home_address2",
      "placeholder": _vm.$t('web.settings.home_address2_placeholder'),
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.home_address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_address2), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset--address__city-state-zip-country"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_city"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_city_label')) + _vm._s(_vm.metadata.home_city.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_city),
      expression: "participant.home_city"
    }],
    staticClass: "qa-settings-city-input",
    attrs: {
      "type": "text",
      "name": "home_city",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.home_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_city", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_city), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_state"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_state_label')) + _vm._s(_vm.metadata.home_state.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_state),
      expression: "participant.home_state"
    }],
    staticClass: "qa-settings-state-input",
    attrs: {
      "name": "home_state",
      "tabindex": "4"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "home_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.home_state.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.home_state), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "legal-zip"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_zip_code_label')) + _vm._s(_vm.metadata.home_zip_code.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_zip_code),
      expression: "participant.home_zip_code"
    }],
    staticClass: "qa-settings-zip-input",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "home_zip_code",
      "tabindex": "5"
    },
    domProps: {
      "value": (_vm.participant.home_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_zip_code), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_country"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_country_label')) + _vm._s(_vm.metadata.home_country.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_country),
      expression: "participant.home_country"
    }],
    staticClass: "qa-settings-country-input",
    attrs: {
      "name": "home_country",
      "tabindex": "6"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "home_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.home_country.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.home_country), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "8"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "7"
    },
    on: {
      "click": function($event) {
        return _vm.save('section8')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_information_label')))]), _vm._v(" "), (_vm.layout.section9.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_address_label')))]), _vm._v(" "), (_vm.shipping_address_empty) ? _c('address', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address_not_entered')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.shipping_address_empty) ? _c('address', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.shipping_first_name) + " "), (_vm.participant.shipping_first_name) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_last_name) + " "), (_vm.participant.shipping_last_name) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_address1) + " "), (_vm.participant.shipping_address1) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_address2) + " "), (_vm.participant.shipping_address2) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_city ? (_vm.participant.shipping_city + ', ') : '') + "\n              " + _vm._s(_vm.participant.shipping_state ? (_vm.participant.shipping_state + ' ') : '') + "\n              " + _vm._s(_vm.participant.shipping_zip_code) + " "), (_vm.participant.shipping_country) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getDropdownLabel(_vm.participant.shipping_country, _vm.metadata.shipping_country.options)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_email_label')))]), _vm._v(" "), (_vm.participant.shipping_email) ? _c('span', {
    staticClass: "u-paragraph u-word-wrap"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.shipping_email) + "\n            ")]) : _c('span', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_email_not_entered')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_phone_label')))]), _vm._v(" "), (_vm.participant.shipping_phone) ? _c('span', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.shipping_phone) + "\n            ")]) : _c('span', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-shipping-info",
    on: {
      "click": function($event) {
        return _vm.edit('section9')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section9.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__fieldset--address"
  }, [_c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address_hint')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_first_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_first_name_label')) + _vm._s(_vm.metadata.shipping_first_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_first_name),
      expression: "participant.shipping_first_name"
    }],
    staticClass: "qa-settings-shipping-name-input",
    attrs: {
      "type": "text",
      "name": "shipping_first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_last_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_last_name_label')) + _vm._s(_vm.metadata.shipping_last_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_last_name),
      expression: "participant.shipping_last_name"
    }],
    staticClass: "qa-settings-shipping-name-input",
    attrs: {
      "type": "text",
      "name": "shipping_last_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_address1"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address1_label')) + _vm._s(_vm.metadata.shipping_address1.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address1),
      expression: "participant.shipping_address1"
    }],
    staticClass: "qa-settings-shipping-street-line-1-input",
    attrs: {
      "type": "text",
      "name": "shipping_address1",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.shipping_address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address1), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_address2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address2_label')) + _vm._s(_vm.metadata.shipping_address2.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address2),
      expression: "participant.shipping_address2"
    }],
    staticClass: "qa-settings-shipping-street-line-2-input",
    attrs: {
      "type": "text",
      "name": "shipping_address2",
      "placeholder": _vm.$t('web.settings.shipping_address2_placeholder'),
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.shipping_address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address2), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset--address__city-state-zip"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_city"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_city_label')) + _vm._s(_vm.metadata.shipping_city.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_city),
      expression: "participant.shipping_city"
    }],
    staticClass: "qa-settings-shipping-city-input",
    attrs: {
      "type": "text",
      "name": "shipping_city",
      "tabindex": "4"
    },
    domProps: {
      "value": (_vm.participant.shipping_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_city", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_city), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_state"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_state_label')) + _vm._s(_vm.metadata.shipping_state.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_state),
      expression: "participant.shipping_state"
    }],
    staticClass: "qa-settings-shipping-state-input",
    attrs: {
      "name": "shipping_state",
      "tabindex": "5"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_state.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_state), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_zip_code"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_zip_code_label')) + _vm._s(_vm.metadata.shipping_zip_code.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_zip_code),
      expression: "participant.shipping_zip_code"
    }],
    staticClass: "qa-settings-shipping-zip-input",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "shipping_zip_code",
      "tabindex": "6"
    },
    domProps: {
      "value": (_vm.participant.shipping_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_zip_code), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_country"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_country_label')) + _vm._s(_vm.metadata.shipping_country.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_country),
      expression: "participant.shipping_country"
    }],
    staticClass: "qa-settings-country-input",
    attrs: {
      "name": "shipping_country",
      "tabindex": "7"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_country.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_country), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_email_label')) + _vm._s(_vm.metadata.shipping_email.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_email),
      expression: "participant.shipping_email"
    }],
    staticClass: "qa-settings-shipping-email-input",
    attrs: {
      "type": "text",
      "name": "shipping_email",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.participant.shipping_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_phone_label')) + _vm._s(_vm.metadata.shipping_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_phone),
      expression: "participant.shipping_phone"
    }],
    staticClass: "qa-settings-shipping-phone-input",
    attrs: {
      "type": "text",
      "name": "shipping_phone",
      "tabindex": "9"
    },
    domProps: {
      "value": (_vm.participant.shipping_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "11"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "10"
    },
    on: {
      "click": function($event) {
        return _vm.save('section9')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()])])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--leaderboard"
  }, [_c('div', {
    staticClass: "c-modal__box c-modal--leaderboard__box"
  }, [_c('div', {
    staticClass: "c-modal__box__header t-modal-header"
  }, [_c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text qa-leaderboard-modal-title"
  }, [_vm._v("\n        " + _vm._s(_vm.leaderboardModalData.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__header__close"
  }, [_c('button', {
    staticClass: "c-modal__box__header__close__button t-modal-header__close",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__content"
  }, [_c('table', {
    staticClass: "c-modal--leaderboard__table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.leaderboardModalData.headers), function(field) {
    return _c('th', [_vm._v("\n              " + _vm._s(field) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "leaderboard-table__body"
    }
  }, _vm._l((_vm.leaderboardReportData), function(record, index) {
    return _c('tr', [_c('td', {
      staticClass: "c-modal--leaderboard__rank t-leaderboard-rank",
      class: _vm.isPersonalPosition(record) ? 'qa-leaderboard-my-row-rank' : ''
    }, [_vm._v("\n              " + _vm._s(_vm.getRank(index + 1)) + "\n            ")]), _vm._v(" "), _vm._l((record), function(field, fieldIndex) {
      return (typeof field.id === 'undefined') ? _c('td', {
        class: _vm.isPersonalPosition(record) && fieldIndex === 1 ?
          'qa-leaderboard-my-row-name' : ''
      }, [_vm._v("\n              " + _vm._s(_vm.formatFieldValue(field, fieldIndex))), (_vm.isPersonalPosition(record) && fieldIndex === 1) ? _c('span', {
        staticClass: "fa fa-check-circle\n                               c-modal--leaderboard__table__icon__row__me\n                               t-leaderboard-rank\n                               qa-leaderboard-modal-my-row-icon",
        attrs: {
          "id": "personal-position",
          "aria-hidden": "false"
        }
      }, [_c('i', {
        staticClass: "u-hide"
      }, [_vm._v(_vm._s(_vm.$t('web.leaderboard_modal.hidden_you_indicator')))])]) : _vm._e()]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.goToPage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    class: 'c-card c-card-chart c-card-chart-' + _vm.getChartType
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card__title t-headline qa-chart-title-header"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "c-card__body qa-chart-description-header"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.card.description) + "\n\t\t")]), _vm._v(" "), (_vm.dataAvailable) ? _c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('canvas', {
    ref: "canvas"
  })]) : _c('h2', {
    staticClass: "c-card__body qa-description-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.card_chart.data_not_available')) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "maxlength": _vm.maxlength,
      "type": "email"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "maxlength": _vm.maxlength,
      "type": "email",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.appClass,
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.path
  }), _vm._v(" "), (_vm.claimModalShow) ? _c('claim-details') : _vm._e(), _vm._v(" "), (_vm.leaderboardModalShow) ? _c('leaderboard-modal') : _vm._e(), _vm._v(" "), (_vm.impersonate === "true") ? _c('div', {
    staticClass: "c-impersonate"
  }, [_c('h2', {
    staticClass: "c-impersonate__title"
  }, [_vm._v("User session")]), _vm._v(" "), _c('p', {
    staticClass: "c-impersonate__username u-force-wrap"
  }, [_vm._v("\n      " + _vm._s(_vm.participant.primary_email) + "\n      "), _c('span', {
    staticClass: "c-impersonate__username__name"
  }, [_vm._v("\n        (" + _vm._s(_vm.participant.first_name) + " " + _vm._s(_vm.participant.last_name) + ")\n      ")])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": false,
      "useIcon": false
    }
  }), _vm._v(" "), _c('portal-target', {
    attrs: {
      "name": "modal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card c-card--claims-list"
  }) : _c('section', {
    staticClass: "c-card c-card--claims-list"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('i', {
    staticClass: "c-card__header__icon fa fa-inbox t-headline"
  })]), _vm._v(" "), (_vm.submitterClaims.length == 0) ? [_c('div', {
    staticClass: "c-card__body t-text-color"
  }, [_c('div', {
    staticClass: "c-card--claims-list__empty"
  }, [_c('p', {
    staticClass: "c-card--claims-list__empty__text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_submitter.no_claims_submitted')) + "\n        ")])])])] : _vm._e(), _vm._v(" "), (_vm.submitterClaims.length > 0) ? [_c('div', {
    staticClass: "c-card__body"
  }, [_c('transition', {
    attrs: {
      "name": "fade-and-slide"
    }
  }, [(_vm.claimModalMessage !== null && _vm.claimModalType == 'submitter') ? _c('div', {
    ref: "claimToast",
    staticClass: "c-toast t-toast-success"
  }, [_c('p', {
    staticClass: "c-toast__text"
  }, [_vm._v(_vm._s(_vm.claimModalMessage))])]) : _vm._e()]), _vm._v(" "), _c('section', [(_vm.updateNeededForThisPage.length > 0) ? _c('h2', {
    staticClass: "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_submitter.update_needed_section')) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.updateNeededForThisPage), function(claim) {
    return _c('div', {
      staticClass: "c-card--claims-list__claim",
      on: {
        "click": function($event) {
          return _vm.showClaim(claim.id)
        }
      }
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info"
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info__details"
    }, [_c('span', {
      staticClass: "c-card--claims-list__claim__info__details__date"
    }, [_vm._v(_vm._s(claim.created_at))]), _vm._v(" "), _c('span', {
      staticClass: "c-card--claims-list__claim__info__details__form"
    }, [_vm._v(" " + _vm._s(claim.form_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "c-approvals__claim__status"
    }, [_c('button', {
      staticClass: "c-status",
      class: _vm.claimStatusClass(claim)
    }, [_vm._v(_vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[claim.status])))])])])
  })], 2), _vm._v(" "), _c('section', [((_vm.notUpdateNeededForThisPage.length > 0) && (_vm.updateNeededForThisPage.length > 0)) ? _c('h2', {
    staticClass: "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_submitter.other_claims_section')) + "\n        ")]) : _c('div', {
    staticClass: "u-margin-top-15"
  }), _vm._v(" "), _vm._l((_vm.notUpdateNeededForThisPage), function(claim) {
    return _c('div', {
      staticClass: "c-card--claims-list__claim",
      on: {
        "click": function($event) {
          return _vm.showClaim(claim.id)
        }
      }
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info"
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info__details"
    }, [_c('span', {
      staticClass: "c-card--claims-list__claim__info__details__date"
    }, [_vm._v(_vm._s(claim.created_at))]), _vm._v(" "), _c('span', {
      staticClass: "c-card--claims-list__claim__info__details__form"
    }, [_vm._v(" " + _vm._s(claim.form_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "c-approvals__claim__status"
    }, [_c('button', {
      staticClass: "c-status",
      class: _vm.claimStatusClass(claim)
    }, [_vm._v(_vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[claim.status])))])])])
  })], 2)], 1)] : _vm._e(), _vm._v(" "), _c('paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.setPage
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-my-orders"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.my_orders.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-my-orders__main"
  }, [_c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left__title"
  }, [_vm._v(_vm._s(_vm.$t('web.my_orders.page_header')))])])]), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--orders"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.my_orders.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__body"
  }, [(_vm.orders.orders.length > 0) ? _c('order-list', {
    attrs: {
      "orders": _vm.orders,
      "fetchOrderCallback": _vm.fetchOrders
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left-title"
  }, [_vm._v(_vm._s(_vm.heading))])]), _vm._v(" "), _c('div', {
    staticClass: "c-page-header__right"
  }, [_c('div', {
    staticClass: "c-rewards-navigation"
  }, [_c('button', {
    staticClass: "c-button qa-filter-modal-button",
    class: {
      't-button-secondary': _vm.filtersApplied, 't-button-transparent': !_vm.filtersApplied
    },
    on: {
      "click": _vm.toggleFilterModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_navigation.filters_button')) + " "), _c('i', {
    staticClass: "fa fa-sliders c-button__icon"
  })])])])]), _vm._v(" "), _c('rewards-filter-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilterModal),
      expression: "showFilterModal"
    }],
    on: {
      "close": _vm.toggleFilterModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('web.not_found.card_header')))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(!_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.not_found.login_link')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.not_found.dashboard_link')) + "\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--reward-order t-modal is-visible"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--reward-order__box"
  }, [(_vm.orderErrorMessage !== null && typeof _vm.orderErrorMessage === 'object') ? _c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('h1', {
    staticClass: "c-modal--reward-order__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_error.error_title', {
    error_code: _vm.orderErrorMessage.code
  })))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__error-message u-paragraph u-center-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('web.catalog_order_error.error_message', {
    reason: _vm.$t(_vm.orderErrorMessage.reason),
    detail: _vm.$t(_vm.orderErrorMessage.detail.order)
  })))])])]) : _c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('h1', {
    staticClass: "c-modal--reward-order__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_error.error_title_no_code')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__error-message u-paragraph u-center-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__actions"
  }, [_c('button', {
    staticClass: "c-button\n               c-modal--reward-order__actions__button\n               c-modal--reward-order__actions__button--full-width\n               t-button-plain",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_error.back_button')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.card.content)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-program is-logged-in",
    class: ('t-program-page-' + _vm.program.id)
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$tc('web.program.nav_space', _vm.programs.length),
      "hideAuxNavOnDesktop": _vm.programs.length <= 1,
      "backButton": _vm.showBackButton()
    }
  }), _vm._v(" "), (!_vm.access_denied) ? _c('main', {
    staticClass: "o-program__main"
  }, [_c('section', {
    staticClass: "c-card c-card--program-header t-program-header qa-program-header"
  }, [_c('div', {
    staticClass: "c-card--program-header__visual"
  }, [(_vm.programLogo !== false) ? _c('img', {
    attrs: {
      "src": _vm.programLogo,
      "alt": _vm.$t('web.program.alt_text_logo'),
      "srcset": _vm.programImages[_vm.program.id].program + ' 430w, ' +
        _vm.programImages[_vm.program.id].program_860 + ' 860w'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card--program-header__info t-program__info"
  }, [_c('h1', {
    staticClass: "c-card--program-header__info__title t-program__info__title"
  }, [_vm._v(_vm._s(_vm.program.name))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--program-header__info__desc t-program__info__desc"
  }, [_vm._v(_vm._s(_vm.program.description))])])]), _vm._v(" "), _vm._l((_vm.program.program_layout), function(card) {
    return [(typeof _vm.cards[card.id] !== 'undefined') ? _c('card-' + _vm.cards[card.id].type, {
      key: card.id,
      tag: "component",
      attrs: {
        "card": _vm.cards[card.id],
        "loaded": _vm.cardsLoaded.includes(card.id)
      }
    }) : _vm._e()]
  })], 2) : _c('main', {
    staticClass: "o-program__main"
  }, [_c('h1', {
    staticClass: "c-card--program-header__info__title t-program__info__title"
  }, [_vm._v(_vm._s(_vm.$t('web.program.no_access')))])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-dashboard"
  }, [_c('app-navigation', {
    attrs: {
      "hideAuxNavOnDesktop": true,
      "currentSpace": _vm.$t('web.dashboard.nav_space')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-dashboard-branding"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.platformImages.dashboard_branding_desktop + ', ' +
        _vm.platformImages.dashboard_branding_desktop_2x + ' 2x',
      "media": "(min-width: 960px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.platformImages.dashboard_branding_tablet + ', ' +
        _vm.platformImages.dashboard_branding_tablet_2x + ' 2x',
      "media": "(min-width: 720px)"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.platformImages.dashboard_branding_mobile,
      "srcset": _vm.platformImages.dashboard_branding_mobile + ', ' +
        _vm.platformImages.dashboard_branding_mobile_2x + ' 2x',
      "alt": _vm.$t('web.dashboard.alt_text_banner_image')
    }
  })])]), _vm._v(" "), _c('main', {
    staticClass: "o-dashboard__main"
  }, [_vm._l((_vm.dashboardLayout), function(card) {
    return [(typeof _vm.cards[card.id] !== 'undefined') ? _c('card-' + _vm.cards[card.id].type, {
      key: card.id,
      tag: "component",
      attrs: {
        "card": _vm.cards[card.id],
        "loaded": _vm.cardsLoaded.includes(card.id)
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rewardDetails !== null) ? _c('div', [_c('div', {
    staticClass: "reward-name-container"
  }, [_c('h1', {
    staticClass: "u-h1"
  }, [_vm._v(_vm._s(_vm.rewardDetails.name))]), _vm._v(" "), (_vm.hasRange) ? _c('h1', {
    staticClass: "u-h1"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" " + _vm._s(_vm.$t('web.catalog_rewards_filters.filter_from_points')) + " " + _vm._s(_vm.minDefDollarPrice) + " " + _vm._s(_vm.$t('web.catalog_rewards_filters.filter_to_points')) + " " + _vm._s(_vm.maxDefDollarPrice) + " " + _vm._s(_vm.rewardDetails['supplier_items'][0]['currency']))]) : _vm._e()]), _vm._v(" "), (_vm.rewardDetails.images && _vm.rewardDetails.images.length > 0) ? _c('section', {
    staticClass: "c-card c-card--reward-images"
  }, _vm._l((_vm.rewardDetails.images), function(image) {
    return _c('div', {
      staticClass: "c-card--reward-images__slider"
    }, [_c('img', {
      attrs: {
        "src": image.sizes['350x350'],
        "alt": image.description
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--reward-cost"
  }, [_c('div', {
    staticClass: "c-card__body c-card--reward-cost__body"
  }, [_c('div', {
    staticClass: "c-card--reward-cost__points-cost"
  }, [_c('h2', {
    staticClass: "c-card--reward-cost__points-cost__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.points_title')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--reward-cost__points-cost__data qa-points-cost"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" "), (_vm.hasRange) ? _c('span', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.filter_from_points')))]) : _vm._e(), _vm._v(" "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true,
      "value": _vm.hasRange ? _vm.minSalePrice : _vm.salePrice
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-card--reward-cost__points-balance"
  }, [_c('h2', {
    staticClass: "c-card--reward-cost__points-balance__title"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.current_points')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--reward-cost__points-balancedata"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true
    },
    model: {
      value: (_vm.participant.points_balance),
      callback: function($$v) {
        _vm.$set(_vm.participant, "points_balance", $$v)
      },
      expression: "participant.points_balance"
    }
  })], 1)]), _vm._v(" "), (!_vm.participantHasEnoughPoints) ? _c('p', {
    staticClass: "u-paragraph u-center-text qa-insufficient-points"
  }, [_vm._v("\n          " + _vm._s(_vm.getInsufficientPointsMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isSavedReward) ? _c('button', {
    staticClass: "c-button\n                        c-button--full-width\n                        u-margin-bottom-10\n                        t-button-plain\n                        qa-save-for-later-button",
    on: {
      "click": function($event) {
        return _vm.saveForLater()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.save_for_later_button')) + "\n        ")]) : _c('div', {
    staticClass: "c-reward-saved-for-later-button"
  }, [_c('h3', {
    staticClass: "c-reward-saved-for-later-button__title"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.saved_for_later')))]), _vm._v(" "), _c('div', {
    staticClass: "c-reward-saved-for-later-button__links"
  }, [_c('router-link', {
    staticClass: "c-reward-saved-for-later-button__links__link\n                       t-link\n                       qa-view-all-saved",
    attrs: {
      "to": {
        name: 'SavedRewards'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.saved_rewards_link')))]), _vm._v(" "), _c('a', {
    staticClass: "c-reward-saved-for-later-button__links__link\n                        t-link\n                        qa-remove-saved",
    class: {
      'remove-disabled': _vm.deleteProcessing
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.remove_link')))])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--full-width t-button-primary",
    attrs: {
      "disabled": !_vm.participantHasEnoughPoints || _vm.orderProcessing || (!_vm.salePrice > 0 && _vm.minSalePrice <= 0)
    },
    on: {
      "click": function($event) {
        return _vm.orderItem()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_reward.redeem_button')) + "\n        ")])])]), _vm._v(" "), (_vm.rewardDetails.description !== null) ? _c('section', {
    staticClass: "c-card u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.description_title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body",
    domProps: {
      "innerHTML": _vm._s(_vm.formatRewardDetails(_vm.rewardDetails.description))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.rewardDetails.notes !== null) ? _c('section', {
    staticClass: "c-card u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.notes_title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body",
    domProps: {
      "innerHTML": _vm._s(_vm.formatRewardDetails(_vm.rewardDetails.notes))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.orderDetails === null && (_vm.rewardProperties.length > 0 || _vm.rewardVariantProperties.length > 0)) ? _c('section', {
    staticClass: "c-card c-card--reward-properties u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.properties_title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body c-card--reward-properties__body"
  }, [_vm._l((_vm.rewardVariantProperties), function(variantProperty) {
    return (_vm.rewardVariantProperties.length > 0) ? _c('dl', {
      staticClass: "c-card--reward-properties__dl"
    }, [_c('dt', [_vm._v(_vm._s(variantProperty.name))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(variantProperty.value))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.rewardProperties), function(property) {
    return (_vm.rewardProperties.length > 0) ? _c('dl', {
      staticClass: "c-card--reward-properties__dl"
    }, [_c('dt', [_vm._v(_vm._s(property.name))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(property.value))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.rewardDetails.terms_and_conditions) ? _c('section', {
    staticClass: "c-card u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.account_setup.accept_terms_link')) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "t-link",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleTermsConditions()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.points_record.notes_toggle')) + "\n          "), _c('span', {
    staticClass: "c-points-record__notes__actions__link__icongroup"
  }, [(!_vm.showTermsConditions) ? _c('i', {
    staticClass: "fa fa-chevron-down is-collapsed"
  }) : _vm._e(), _vm._v(" "), (_vm.showTermsConditions) ? _c('i', {
    staticClass: "fa fa-chevron-up is-expanded"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTermsConditions),
      expression: "showTermsConditions"
    }],
    staticClass: "c-card__body",
    domProps: {
      "innerHTML": _vm._s(_vm.formatRewardDetails(_vm.rewardDetails.terms_and_conditions))
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showOrderModal) ? _c('order-modal', {
    on: {
      "close": function($event) {
        return _vm.closeOrderModal()
      },
      "confirm": _vm.confirmOrder
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderConfirmationModal) ? _c('order-confirmation', {
    attrs: {
      "orderConfirmationMessage": _vm.orderConfirmationMessage
    },
    on: {
      "close": function($event) {
        return _vm.closeOrderConfirmationModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderErrorModal) ? _c('order-error', {
    attrs: {
      "orderErrorMessage": _vm.orderErrorMessage
    },
    on: {
      "close": function($event) {
        return _vm.closeOrderErrorModal()
      }
    }
  }) : (_vm.rewardDetails === null) ? _c('loading-icon') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-card--claim-forms__body"
  }, [_c('transition', {
    attrs: {
      "name": "fade-and-slide"
    }
  }, [(_vm.submittedForm !== null) ? _c('div', {
    ref: "toast",
    staticClass: "c-toast t-toast-success"
  }, [_c('p', {
    staticClass: "c-toast__text"
  }, [_vm._v("\n          " + _vm._s((_vm.forms[_vm.submittedForm] && _vm.forms[_vm.submittedForm].submitMessage) ||
    _vm.$t('web.form_list.success_message')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card--claim-forms__form-list qa-form-list"
  }, _vm._l((_vm.forms), function(form, formIndex) {
    return _c('div', {
      staticClass: "c-card--claim-forms__form-list__button qa-select-form-button",
      on: {
        "click": function($event) {
          return _vm.openForm(formIndex)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(form.name))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-arrow-right t-headline"
    })])
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "c-card--orders__single__order-number"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_number', {
    order_number: _vm.order.short_order_id
  })))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--orders__single__item"
  }, [_c('router-link', {
    staticClass: "t-link",
    attrs: {
      "to": {
        name: 'Single Reward',
        params: {
          id: _vm.order.reward_id
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.order.reward_name) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__single__datagroup"
  }, [_c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.date')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.points')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v("\n        " + _vm._s(_vm.order.order_total) + "\n      ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.quantity')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.item_quantity))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.updated')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.updated))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__single__datagroup"
  }, [_c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_status')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.statusColor(_vm.order.order_status)
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), (!_vm.order.email_status) ? _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.shipping_status')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.statusColor(_vm.order.shipping_status)
  }, [_vm._v(_vm._s(_vm.order.shipping_status))])])]) : _vm._e(), _vm._v(" "), (!_vm.order.email_status) ? _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v("\n        " + _vm._s(_vm.order.carrier_tracking) + "\n        "), (!_vm.order.carrier_tracking) ? _c('span', {
    staticClass: "c-card--orders__single__data__value__empty"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking_unavailable')))]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2147483647",
      "step": "1"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2147483647",
      "step": "1",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.formattedNumber(_vm.value)) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-login"
  }, [_c('app-navigation'), _vm._v(" "), _c('main', {
    staticClass: "o-login__main"
  }, [_c('div', {
    staticClass: "o-login__main__logo c-login-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.platformImages.login_logo,
      "srcset": _vm.platformImages.login_logo + ', ' +
        _vm.platformImages.login_logo_2x + ' 2x',
      "alt": _vm.$t('web.login.alt_text_login_logo')
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--login js-login-card"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.login.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [(_vm.error_message) ? _c('div', {
    staticClass: "c-validation t-toast-danger is-not-valid"
  }, [_vm._v("\n              " + _vm._s(_vm.error_message) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.email_label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.username),
      expression: "request.username"
    }],
    class: {
      'is-not-valid': _vm.errors.username
    },
    attrs: {
      "id": "username",
      "type": "email",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.username) ? _c('div', {
    staticClass: "c-validation t-alert-danger is-not-valid",
    attrs: {
      "id": "username-error",
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.errors.username[0]))]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.password_label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password),
      expression: "request.password"
    }],
    class: {
      'is-not-valid': _vm.errors.password
    },
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.password) ? _c('div', {
    staticClass: "c-validation t-alert-danger is-not-valid",
    attrs: {
      "id": "password-error",
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.errors.password[0]))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer c-card--login__footer"
  }, [_c('button', {
    staticClass: "c-button c-button--full-width t-button-primary js-submit-login",
    attrs: {
      "disabled": _vm.loggingIn
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.login.submit_button')) + "\n          ")]), _vm._v(" "), (_vm.websiteConfig.enrollment_enabled) ? _c('router-link', {
    staticClass: "c-card__footer__text-link u-float-left t-link",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.signup_link_text')))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "c-card__footer__text-link u-float-right t-link",
    attrs: {
      "to": {
        name: 'ForgotPassword'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.forgot_password_link_text')))])], 1)])])]), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('div', {
    staticClass: "c-login-hero-image"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.platformImages.login_background_desktop + ', ' +
        _vm.platformImages.login_background_desktop_2x + ' 2x',
      "media": "(min-width: 960px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.platformImages.login_background_tablet + ', ' +
        _vm.platformImages.login_background_tablet_2x + ' 2x',
      "media": "(min-width: 580px) and (min-height: 580px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.platformImages.login_background_mobile + ', ' +
        _vm.platformImages.login_background_mobile_2x + ' 2x',
      "media": "(max-width: 580px)"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.platformImages.login_background_tablet_wide,
      "srcset": _vm.platformImages.login_background_tablet_wide + ', ' +
        _vm.platformImages.login_background_tablet_wide_2x + ' 2x',
      "alt": _vm.$t('web.login.alt_text_background_image')
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rewards.items !== null) ? _c('div', {
    staticClass: "o-rewards__cardgroup"
  }, [_vm._l((_vm.rewards.items), function(reward) {
    return _c('section', {
      staticClass: "c-card c-card--reward qa-card"
    }, [_c('router-link', {
      staticClass: "c-card--reward__link",
      attrs: {
        "to": _vm.getRouterLink(reward)
      }
    }, [_c('div', {
      staticClass: "c-card--reward__thumbnail"
    }, [(_vm.getImgUrl(reward)) ? _c('img', {
      staticClass: "c-card--reward__thumbnail__img",
      attrs: {
        "src": _vm.getImgUrl(reward)
      }
    }) : _c('img', {
      staticClass: "c-card--reward__thumbnail__placeholder",
      attrs: {
        "src": "/img/thm350.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-card--reward__info"
    }, [_c('h2', {
      staticClass: "c-card--reward__info__name t-link"
    }, [_vm._v("\n          " + _vm._s(reward.name) + "\n        ")]), _vm._v(" "), (reward.supplier_items) ? _c('div', {
      staticClass: "c-card--reward__info__cost"
    }, [_c('i', {
      staticClass: "fa fa-star t-points-icon"
    }), _vm._v(" "), (_vm.rewardHasRange(reward)) ? _c('span', [_vm._v("From")]) : _vm._e(), _vm._v(" "), _c('vue-numeric', {
      attrs: {
        "separator": ",",
        "read-only": true,
        "value": _vm.getRewardPrice(reward)
      }
    })], 1) : _vm._e()])])], 1)
  }), _vm._v(" "), (_vm.rewards.items !== null && Object.keys(_vm.rewards.items).length === 0) ? _c('section', {
    staticClass: "c-no-results qa-no-results"
  }, [_c('p', {
    staticClass: "c-no-results__p t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_list.no_rewards')))])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('div', {
    staticClass: "c-card c-card--quizzes"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [(_vm.quizzesUntaken.length) ? [_c('ol', {
    staticClass: "c-card--quizzes__untaken-list"
  }, _vm._l((_vm.quizzesUntaken), function(quiz, i) {
    return _c('li', [_c('div', {
      staticClass: "c-card--quizzes__untaken-list__single qa-open-modal-button",
      on: {
        "click": function($event) {
          return _vm.showModal(quiz.code)
        }
      }
    }, [_vm._v("\n            " + _vm._s(quiz.name) + "\n            "), _c('i', {
      staticClass: "fa fa-arrow-right c-card--quizzes__untaken-list__single__icon\n              t-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0)] : _vm._e(), _vm._v(" "), (!_vm.quizzesUntaken.length) ? [_c('div', {
    staticClass: "c-card--quizzes__untaken-empty"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up c-card--quizzes__untaken-empty__icon t-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "c-card--quizzes__untaken-empty__text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_quizzes.no_quizzes_available')) + "\n        ")])])] : _vm._e(), _vm._v(" "), (_vm.quizzesTaken.length) ? [_c('h3', {
    staticClass: "c-card--quizzes__taken-header qa-heading-taken"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.card_quizzes.completed_quizzes')) + "\n      ")]), _vm._v(" "), _c('ol', {
    staticClass: "c-card--quizzes__taken-list"
  }, _vm._l((_vm.quizzesTaken), function(quiz, i) {
    return _c('li', [_c('button', {
      staticClass: "c-card--quizzes__taken-list__single qa-open-modal-button-disabled",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("\n            " + _vm._s(quiz.name) + "\n          ")])])
  }), 0)] : _vm._e()], 2), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "modal"
    }
  }, _vm._l((_vm.quizzes), function(quiz) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.modalIsVisible(quiz.code)),
        expression: "modalIsVisible(quiz.code)"
      }],
      key: quiz.code,
      staticClass: "c-modal c-modal--quiz"
    }, [_c('section', {
      staticClass: "c-modal__box c-modal--quiz__box"
    }, [_c('div', {
      staticClass: "c-modal__box__header t-modal-header"
    }, [_c('h2', {
      staticClass: "c-modal__box__header__title t-modal-header__text"
    }, [_vm._v("\n            " + _vm._s(quiz.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-modal__box__header__close"
    }, [_c('button', {
      staticClass: "c-modal__box__header__close__button\n                        t-modal-header__close\n                        qa-close-modal-button",
      on: {
        "click": _vm.hideModal
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])])]), _vm._v(" "), _c('div', {
      ref: quiz.code + '-quiz',
      refInFor: true,
      staticClass: "c-modal--quiz__wrapper__quiz"
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-modal__overlay"
    })])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-currency-field"
  }, [_vm._m(0), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "min": "0.00",
      "max": "99999999.99",
      "step": "0.01",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "min": "0.00",
      "max": "99999999.99",
      "step": "0.01",
      "placeholder": "0.00",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n      " + _vm._s(_vm.formatUSD) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-currency-field__currency-icon"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  })])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-account-setup"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.signup.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-account-setup__main"
  }, [(_vm.successMessage === '') ? _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.signup.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('div', {
    staticClass: "c-card__paragraph s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.signup.text)
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "primary_email"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.email_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.primary_email),
      expression: "request.primary_email"
    }],
    class: {
      'is-not-valid': _vm.errors.primary_email
    },
    attrs: {
      "id": "primary_email",
      "type": "text",
      "placeholder": "",
      "name": "primary_email"
    },
    domProps: {
      "value": (_vm.request.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "primary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.primary_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.first_name_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.first_name),
      expression: "request.first_name"
    }],
    class: {
      'is-not-valid': _vm.errors.first_name
    },
    attrs: {
      "id": "first_name",
      "type": "text",
      "placeholder": "",
      "name": "first_name"
    },
    domProps: {
      "value": (_vm.request.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.last_name_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.last_name),
      expression: "request.last_name"
    }],
    class: {
      'is-not-valid': _vm.errors.last_name
    },
    attrs: {
      "id": "last_name",
      "type": "text",
      "placeholder": "",
      "name": "last_name"
    },
    domProps: {
      "value": (_vm.request.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), (_vm.showLocales) ? _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "locale"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.locale_label')) + "*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.locale),
      expression: "request.locale"
    }],
    class: {
      'is-not-valid': _vm.errors.last_name
    },
    attrs: {
      "id": "locale",
      "text": "Select locale",
      "name": "locale"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.request, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      domProps: {
        "value": locale.locale
      }
    }, [_vm._v(" " + _vm._s(locale.name) + " ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.signup.fields), function(field) {
    return _c('fieldset', {
      staticClass: "o-fieldset c-card--submit-claim__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "className": "c-card__subtitle-h3"
      },
      model: {
        value: (_vm.request[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.request, field.name, $$v)
        },
        expression: "request[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', [_c('div', {
        staticClass: "c-validation t-alert-danger"
      }, [_vm._v(_vm._s(error))])])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('button', {
    staticClass: "c-button c-button--full-width t-button t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n           " + _vm._s(_vm.$t('web.signup.signup_button_text')) + "\n          ")])])])]) : _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.signup.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body u-margin-bottom-15 u-margin-top-15"
  }, [_c('div', {
    staticClass: "c-card__paragraph s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.successMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  })])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-saved-for-later"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.saved_rewards.nav_space'),
      "backButton": "true"
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-saved-for-later__main"
  }, [_c('search-bar'), _vm._v(" "), _c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left__title"
  }, [_c('i', {
    staticClass: "fa fa-heart t-icon-primary-color"
  }), _vm._v("\n          " + _vm._s(_vm.$t('web.saved_rewards.page_header')) + "\n        ")])])]), _vm._v(" "), _vm._l((_vm.savedRewards), function(item) {
    return _c('section', {
      staticClass: "c-card c-card--saved-reward qa-saved-item"
    }, [_c('div', {
      staticClass: "c-card--saved-reward__details"
    }, [(item.available) ? _c('router-link', {
      staticClass: "c-card--saved-reward__details__img",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [(item.image && item.image['350x350']) ? _c('img', {
      attrs: {
        "src": item.image['350x350']
      }
    }) : _c('img', {
      attrs: {
        "src": "/img/thm350.png"
      }
    })]) : _vm._e(), _vm._v(" "), (!item.available) ? _c('span', {
      staticClass: "c-card--saved-reward__details__img\n                   c-card--saved-reward__details__img--no-hover",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [(item.image && item.image['350x350']) ? _c('img', {
      attrs: {
        "src": item.image['350x350']
      }
    }) : _c('img', {
      attrs: {
        "src": "/img/thm350.png"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "c-card--saved-reward__details__info"
    }, [(item.available) ? _c('router-link', {
      staticClass: "c-card--saved-reward__details__info__title\n                     t-link\n                     qa-saved-item-title",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (!item.available) ? _c('span', {
      staticClass: "c-card--saved-reward__details__info__title\n                     qa-saved-item-title",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (item.available) ? _c('div', {
      staticClass: "c-card--saved-reward__details__info__points"
    }, [_c('i', {
      staticClass: "fa fa-star t-points-icon"
    }), _vm._v(" "), _c('vue-numeric', {
      attrs: {
        "separator": ",",
        "read-only": true
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!item.available) ? _c('div', {
      staticClass: "c-card--saved-reward__details__info__removed"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.saved_rewards.item_unavailabe')) + "\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "c-card--saved-reward__buttons"
    }, [_c('button', {
      staticClass: "c-card--saved-reward__buttons__button\n                        c-button\n                        t-button-plain\n                        qa-remove-saved-item",
      attrs: {
        "disabled": _vm.deleteProcessing
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('web.saved_rewards.remove_item')) + "\n        ")]), _vm._v(" "), (item.available) ? _c('router-link', {
      staticClass: "c-card--saved-reward__buttons__button c-button t-button-plain",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('web.saved_rewards.go_to_item')) + "\n        ")]) : _vm._e()], 1)])
  })], 2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-available"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('web.reward_unavailable.unavailable')))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Rewards'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.reward_unavailable.rewards_list_link')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--reward-order t-modal"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--reward-order__box"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__points-cost"
  }, [_c('h2', {
    staticClass: "c-modal--reward-order__points-cost__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.modal_title')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__points-cost__data"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" "), _c('vue-numeric', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceOutOfRange),
      expression: "!priceOutOfRange"
    }],
    staticClass: "c-modal--reward-order__points-cost__data__number",
    attrs: {
      "separator": ",",
      "read-only": true,
      "value": _vm.totalPrice
    }
  }), _vm._v(" "), (_vm.priceOutOfRange) ? _c('span', [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.invalid_amount')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasRange) ? _c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2 reward_name"
  }, [_vm._v(_vm._s(_vm.rewardDetails.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__points-cost quantity_container"
  }, [(_vm.hasRange) ? _c('div', [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__h2 quantity_label"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(_vm._s(_vm.rewardDetails['supplier_items'][0]['currency']) + " " + _vm._s(_vm.$t('web.catalog_order_modal.amount')))]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "c-modal--reward-order__points-cost__data__number",
    attrs: {
      "separator": ",",
      "currency": _vm.rewardDetails['supplier_items'][0]['currency']
    },
    model: {
      value: (_vm.dollarPriceInserted),
      callback: function($$v) {
        _vm.dollarPriceInserted = $$v
      },
      expression: "dollarPriceInserted"
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'c-validation t-alert-danger': _vm.priceOutOfRange
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.default_dollar_amount_message', {
    min_price: _vm.minDefDollarPrice,
    max_price: _vm.maxDefDollarPrice
  })) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.hasRange) ? _c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2 reward_name"
  }, [_vm._v(_vm._s(_vm.rewardDetails.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "quantity_select_container"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__h2 quantity_label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.quantity')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantity),
      expression: "quantity"
    }],
    staticClass: "c-modal--reward-order__points-cost__data quantity_select",
    attrs: {
      "name": "quantity",
      "tabindex": "5"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quantity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((25), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__math"
  }, [_c('dl', {
    staticClass: "c-modal--reward-order__math__dl"
  }, [_c('dd', {
    staticClass: "c-modal--reward-order__math__dl__number"
  }, [_c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true
    },
    model: {
      value: (_vm.participant.points_balance),
      callback: function($$v) {
        _vm.$set(_vm.participant, "points_balance", $$v)
      },
      expression: "participant.points_balance"
    }
  })], 1), _vm._v(" "), _c('dt', {
    staticClass: "c-modal--reward-order__math__dl__description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.current_points')) + "\n          ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--reward-order__math__dl"
  }, [_c('dd', {
    staticClass: "c-modal--reward-order__math__dl__number"
  }, [_c('strong', [_vm._v("\n              –\n              "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true,
      "value": _vm.totalPrice
    }
  })], 1)]), _vm._v(" "), _c('dt', {
    staticClass: "c-modal--reward-order__math__dl__description t-headline"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.reward_cost')) + "\n          ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--reward-order__math__dl"
  }, [_c('dd', {
    staticClass: "c-modal--reward-order__math__dl__number"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true
    },
    model: {
      value: (this.pointsBalance),
      callback: function($$v) {
        _vm.$set(this, "pointsBalance", $$v)
      },
      expression: "this.pointsBalance"
    }
  })], 1), _vm._v(" "), _c('dt', {
    staticClass: "c-modal--reward-order__math__dl__description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.points_left')) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__note"
  }, [_c('i18n', {
    staticClass: "u-small-paragraph u-center-text u-no-margins",
    attrs: {
      "path": "web.catalog_order_modal.address_confirmation",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "profile_link",
      fn: function() {
        return [_c('router-link', {
          staticClass: "t-link",
          attrs: {
            "to": {
              name: 'Settings'
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.address_confirmation_link')))])]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.showGiftCardMessage) ? _c('p', {
    staticClass: "u-small-paragraph u-center-text u-no-margins"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("**"), _c('u', [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.important')))])]), _vm._v(": \n            " + _vm._s(_vm.$t('web.catalog_order_modal.gift_card_cancellation_message')) + "\n          ")])]) : _vm._e()], 1), _vm._v(" "), (!_vm.editingAddress) ? _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__shipping-info__buttons\n                    c-modal--reward-order__shipping-info__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button",
    on: {
      "click": function($event) {
        _vm.editingAddress = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.edit_button')))])]), _vm._v(" "), _c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_info')))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_first_name')))]), _vm._v(" "), (_vm.participant.shipping_first_name) ? _c('p', {
    staticClass: "u-paragraph"
  }, [_vm._v(_vm._s(_vm.participant.shipping_first_name))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_last_name')))]), _vm._v(" "), (_vm.participant.shipping_last_name) ? _c('p', {
    staticClass: "u-paragraph"
  }, [_vm._v(_vm._s(_vm.participant.shipping_last_name))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_address')))]), _vm._v(" "), (!_vm.addressEmpty) ? _c('address', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n            " + _vm._s(_vm.participant.shipping_address1)), _c('br'), _vm._v("\n            " + _vm._s(_vm.participant.shipping_address2)), _c('br'), _vm._v("\n            " + _vm._s(_vm.participant.shipping_city) + ", " + _vm._s(_vm.participant.shipping_state) + " " + _vm._s(_vm.participant.shipping_zip_code)), _c('br'), _vm._v("\n            " + _vm._s(_vm.getDropdownLabel(_vm.participant.shipping_country, _vm.metadata.shipping_country.options)) + "\n          ")]) : _c('address', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.not_entered')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_email')))]), _vm._v(" "), (_vm.participant.shipping_email) ? _c('p', {
    staticClass: "u-paragraph u-force-wrap"
  }, [_vm._v(_vm._s(_vm.participant.shipping_email))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_phone')))]), _vm._v(" "), (_vm.participant.shipping_phone) ? _c('p', {
    staticClass: "u-paragraph"
  }, [_vm._v(_vm._s(_vm.participant.shipping_phone))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])])]) : _vm._e(), _vm._v(" "), (_vm.editingAddress) ? _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_info')))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_first_name')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_first_name),
      expression: "participant.shipping_first_name"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_last_name')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_last_name),
      expression: "participant.shipping_last_name"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_last_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info-address__city-state-zip"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_address1"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_address1')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address1),
      expression: "participant.shipping_address1"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_address1",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.shipping_address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address1), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_address2"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_address2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address2),
      expression: "participant.shipping_address2"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_address2",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.shipping_address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address2), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_city"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_city')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_city),
      expression: "participant.shipping_city"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_city",
      "tabindex": "4"
    },
    domProps: {
      "value": (_vm.participant.shipping_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_city", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_city), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_state"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_state')) + "*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_state),
      expression: "participant.shipping_state"
    }],
    attrs: {
      "name": "shipping_state",
      "tabindex": "5"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_state.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_state), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_zip_code"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_zip')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_zip_code),
      expression: "participant.shipping_zip_code"
    }],
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "shipping_zip_code",
      "tabindex": "6"
    },
    domProps: {
      "value": (_vm.participant.shipping_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_zip_code), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_country"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_country')) + "*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_country),
      expression: "participant.shipping_country"
    }],
    attrs: {
      "name": "shipping_country",
      "tabindex": "7"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_country.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_country), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_email"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_email')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_email),
      expression: "participant.shipping_email"
    }],
    attrs: {
      "type": "email",
      "name": "shipping_email",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.participant.shipping_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_phone"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_phone')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_phone),
      expression: "participant.shipping_phone"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_phone",
      "tabindex": "9"
    },
    domProps: {
      "value": (_vm.participant.shipping_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__buttons\n                    c-modal--reward-order__shipping-info__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button",
    attrs: {
      "tabindex": "10"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.cancel_button')))]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary",
    attrs: {
      "tabindex": "11"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.save_button')))])])]) : _vm._e()]), _vm._v(" "), (_vm.shippingIncomplete) ? _c('div', [_c('div', {
    staticClass: "c-form-validation t-alert-warning"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_modal.incomplete_shipping_warning')) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__actions"
  }, [_c('button', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-plain",
    attrs: {
      "disabled": _vm.confirming
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.catalog_order_modal.cancel_button')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-primary",
    attrs: {
      "disabled": _vm.confirming || _vm.shippingIncomplete || _vm.editingAddress || _vm.notEnoughPoints || _vm.priceOutOfRange
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.catalog_order_modal.redeem_button')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-rewards"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.rewards_dashboard.nav_space'),
      "hideAuxNavOnDesktop": true,
      "backButton": _vm.showBackButton
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-rewards__main"
  }, [_c('search-bar'), _vm._v(" "), (_vm.categoriesLoading) ? _c('loading-icon') : _c('category-list')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-rewards"
  }, [_c('app-navigation', {
    attrs: {
      "current-space": _vm.$t('web.rewards_results.nav_space'),
      "back-button": true
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-rewards__main"
  }, [_c('search-bar'), _vm._v(" "), _c('rewards-navigation'), _vm._v(" "), (_vm.rewardsLoading) ? _c('loading-icon') : _c('rewards-list'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rewardsLoading),
      expression: "!rewardsLoading"
    }],
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.goToPage
    }
  })], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card c-card--leaderboard"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline qa-leaderboard-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.participantPosition !== null) ? _c('div', {
    staticClass: "c-card--leaderboard__summary",
    class: _vm.rankDigits
  }, [_c('span', {
    staticClass: "c-card--leaderboard__summary__rank u-no-wrap t-rank qa-leaderboard-my-rank"
  }, [_c('i', {
    staticClass: "fa fa-trophy c-card--leaderboard__summary__rank__icon t-ranked-trophy"
  }), _vm._v(_vm._s(_vm.formatNumber(_vm.participantPosition + 1)) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "c-card--leaderboard__summary__rank-of u-no-wrap"
  }, [_vm._v("\n        of " + _vm._s(_vm.formatNumber(_vm.card.recordsTotal)) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.card.description !== null) ? _c('div', {
    staticClass: "c-card--leaderboard__description qa-leaderboard-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.card.description))])]) : _vm._e(), _vm._v(" "), (_vm.dataNotAvailable) ? _c('h2', {
    staticClass: "c-card--leaderboard__missing-data qa-description-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.card_leaderboard.data_not_available')) + "\n    ")]) : _c('table', {
    staticClass: "c-card--leaderboard__table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.card.headers), function(field) {
    return _c('th', [_vm._v("\n            " + _vm._s(field) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.leaderboards), function(record) {
    return _c('tr', [(record === '...') ? _c('td', {
      staticClass: "c-card--leaderboard__collapsed-row",
      attrs: {
        "colspan": _vm.columnsLength
      }
    }, [_vm._v("…")]) : _vm._e(), _vm._v(" "), (record !== '...') ? _c('td', {
      staticClass: "c-card--leaderboard__rank t-leaderboard-rank",
      class: _vm.myPosition(record, 1) ? 'qa-leaderboard-my-row-rank' : ''
    }, [_vm._v(_vm._s(_vm.formatNumber((record + 1))))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reportData[_vm.card.report_id][record]), function(field, index) {
      return (record !== '...' && typeof field.id === 'undefined') ? _c('td', {
        staticClass: "c-card--leaderboard__table__row",
        class: _vm.myPosition(record, index) ? 'qa-leaderboard-my-row-name' : ''
      }, [_vm._v("\n            " + _vm._s(_vm.formatFieldValue(field, index)) + "\n            "), (_vm.myPosition(record, index)) ? _c('span', {
        staticClass: "fa fa-check-circle\n                             c-card--leaderboard__table__icon__row__me\n                             t-leaderboard-rank\n                             qa-leaderboard-my-row-icon",
        attrs: {
          "aria-hidden": "false"
        }
      }, [_c('i', {
        staticClass: "u-hide"
      }, [_vm._v(_vm._s(_vm.$t('web.card_leaderboard.hidden_you_indicator')))])]) : _vm._e()]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer u-center-content"
  }, [_c('button', {
    staticClass: "c-button-expand-card qa-leaderboard-open-modal",
    on: {
      "click": function($event) {
        return _vm.openLeaderboardModal()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.card_leaderboard.button_open_full_list')) + "\n         "), _c('i', {
    staticClass: "fa fa-plus-square"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "c-footer",
    class: _vm.footerClass
  }, [_c('div', {
    staticClass: "c-footer__container"
  }, [_vm._l((_vm.footer), function(item) {
    return (typeof _vm.footer !== 'undefined' && _vm.footer.length) ? [(item.linkType == 'external') ? _c('a', {
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), (item.linkType == 'internal') ? _c('router-link', {
      attrs: {
        "target": item.target,
        "to": {
          name: 'Page_' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()] : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('h1', [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(!_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n      Login\n    ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("\n      Dashboard\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'o-date qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "date",
      "placeholder": "MM/DD/YYYY",
      "pattern": "[0-9]{2}/[0-9]{2}/[0-9]{4}",
      "name": _vm.field.name
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'o-date qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "date",
      "placeholder": "MM/DD/YYYY",
      "pattern": "[0-9]{2}/[0-9]{2}/[0-9]{4}",
      "readonly": "readonly",
      "disabled": "disabled",
      "name": _vm.field.name
    },
    domProps: {
      "value": _vm.fieldValue
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading && !_vm.card.title) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card c-card--report"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body u-position-relative"
  }, [(!_vm.dataAvailable) ? _c('p', {
    staticClass: "u-small-paragraph"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('web.card_report.data_not_available')) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.dataAvailable && _vm.card.download_enabled && !_vm.downloading) ? _c('button', {
    staticClass: "c-button c-button--dataTables-custom-download-button t-button-secondary",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("\n    " + _vm._s(_vm.card.download_button_text) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.downloading) ? _c('button', {
    staticClass: "c-button c-button--dataTables-custom-download-button download-button-loading t-button-secondary"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-1x t-loading-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.$t(_vm.loadingMessage)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAvailable),
      expression: "dataAvailable"
    }]
  }, [_c('table', {
    ref: "dtable",
    staticStyle: {
      "min-width": "100%"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-card"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_category_list.header_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-category-list"
  }, [_vm._l((_vm.$store.getters.categories), function(category, i) {
    return [(category.code) ? _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: 'Rewards Results',
          query: {
            category: category.code
          }
        }
      }
    }, [_c('category-list-tile', {
      attrs: {
        "category": category
      }
    })], 1) : _vm._e(), _vm._v(" "), (category.page_id) ? _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: 'Page_' + category.page_id
        }
      }
    }, [_c('category-list-tile', {
      attrs: {
        "category": category
      }
    })], 1) : _vm._e(), _vm._v(" "), (category.reward_id) ? _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: category.reward_id
          }
        }
      }
    }, [_c('category-list-tile', {
      attrs: {
        "category": category
      }
    })], 1) : _vm._e(), _vm._v(" "), (!category.code && !category.page_id && !category.reward_id) ? _c('category-list-tile', {
      key: i,
      staticClass: "is-not-linked",
      attrs: {
        "category": category
      }
    }) : _vm._e()]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--rewards-filter"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--rewards-filter__box"
  }, [_c('div', {
    staticClass: "c-modal__box__header t-modal-header"
  }, [_c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.modal_title')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__header__close"
  }, [_c('button', {
    staticClass: "c-modal__box__header__close__button t-modal-header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('rewards-filters', {
    ref: "rewardsFilters"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__actions c-modal--rewards-filter__box__actions"
  }, [_c('div', {
    staticClass: "c-modal--rewards-filter__box__actions__left"
  }, [_c('button', {
    staticClass: "c-modal__box__actions__button t-button-info",
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.clear_button')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--rewards-filter__box__actions__right"
  }, [_c('button', {
    staticClass: "c-modal__box__actions__button t-button-plain",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.cancel_button')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "c-modal__box__actions__button\n                    t-button-primary\n                    qa-apply-filters-button",
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.apply_button')) + "\n        ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-program"
  }, [_c('app-navigation', {
    attrs: {
      "hideAuxNavOnDesktop": true,
      "currentSpace": _vm.$tc('web.program.nav_space', _vm.programs.length)
    }
  }), _vm._v(" "), (!_vm.access_denied) ? _c('main', {
    staticClass: "o-program__main"
  }, _vm._l((_vm.programs), function(program) {
    return _c('router-link', {
      key: program.id,
      staticClass: "c-card c-card--program qa-program-card",
      class: ('t-program-card-' + program.id),
      attrs: {
        "to": {
          name: 'Program',
          params: {
            id: program.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "c-card--program__visual"
    }, [_c('img', {
      attrs: {
        "src": _vm.programImages[program.id].program_thm,
        "alt": _vm.$t('web.programs.alt_text_logo'),
        "srcset": _vm.programImages[program.id].program_thm + ' 160w, ' +
          _vm.programImages[program.id].program_thm_350 + ' 350w, ' +
          _vm.programImages[program.id].program_thm_700 + ' 700w'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-card--program__info t-program-id__info"
    }, [_c('h2', {
      staticClass: "c-card--program__info__title t-program-id__info__title"
    }, [_vm._v(_vm._s(program.name))]), _vm._v(" "), _c('p', {
      staticClass: "c-card--program__info__desc t-program-id__info__desc"
    }, [_vm._v(_vm._s(program.description))])])])
  }), 1) : _c('main', {
    staticClass: "o-program__main"
  }, [_c('h1', {
    staticClass: "c-card--program-header__info__title t-program__info__title"
  }, [_vm._v(_vm._s(_vm.$t('web.program_dashboard.no_access')))])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    class: {
      'c-card qa-multicard': _vm.hasMultipleCards
    }
  }, [(_vm.hasMultipleCards) ? _c('div', {
    staticClass: "c-card__multicard-header"
  }, [_c('menu', {
    staticClass: "c-card__multicard-header__menu qa-multicard-dropdown"
  }, [_c('menuitem', {
    staticClass: "c-card__multicard-header__menu__default t-headline qa-multicard-menu-button",
    class: _vm.showDropdown == true ? 'is-open' : '',
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.card.title) + ": " + _vm._s(_vm.currentCard.title))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-sort-down"
  })]), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "c-card__multicard-header__menu__itemgroup"
  }, _vm._l((_vm.card.card_layout), function(card, index) {
    return (typeof _vm.cards[card.id] !== 'undefined') ? _c('menuitem', {
      staticClass: "c-card__multicard-header__menu__menuitem qa-multicard-menuitem",
      class: _vm.showDropdown == true ? 'is-open' : '',
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.cards[card.id].title))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentCardIndex),
        expression: "index === currentCardIndex"
      }],
      staticClass: "fa fa-check t-headline"
    })]) : _vm._e()
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), (typeof _vm.currentCard !== 'undefined' && typeof _vm.currentCard.id !== 'undefined') ? _c('card-' + _vm.currentCard.type, {
    key: _vm.currentCard.id,
    tag: "component",
    staticClass: "qa-multicard-current",
    attrs: {
      "card": _vm.currentCard,
      "loaded": !_vm.loading
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-percent-field"
  }, [(!_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0)])] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n      " + _vm._s(_vm.formattedNumber(_vm.value)) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-percent-field__percent-icon"
  }, [_c('i', {
    staticClass: "fa fa-percent"
  })])
}]}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-reward-single"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.rewards_single.nav_space'),
      "backButton": "true"
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-reward-single__main"
  }, [_c('search-bar'), _vm._v(" "), _c('catalog-reward-detail')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-checkbox"
  }, [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('input', {
    ref: "input",
    class: 'o-checkbox__input qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "checkbox",
      "disabled": _vm.field.readonly,
      "readonly": _vm.field.readonly
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.update($event.target)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "o-checkbox__label"
  }, [_vm._v(_vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')))])] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('input', {
    ref: "input",
    class: 'o-checkbox__input qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "checkbox",
      "disabled": _vm.field.readonly,
      "readonly": _vm.field.readonly,
      "disabled": ""
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.value
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "o-checkbox__label"
  }, [_vm._v(_vm._s(_vm.field.label))])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card c-card--tier"
  }, [_c('div', {
    staticClass: "c-card--tier__left c-card--tier__summary"
  }, [(_vm.card.level && _vm.card.level.image) ? _c('img', {
    staticClass: "c-card--tier__summary__img qa-tier-image",
    attrs: {
      "src": _vm.card.level.image.url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-card--tier__summary__text"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card--tier__summary__text__title t-tier-title qa-tier-title"
  }, [_vm._v("\n          " + _vm._s(_vm.card.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "c-card--tier__summary__text__sub qa-tier-level",
    style: (_vm.levelColor)
  }, [_vm._v("\n          " + _vm._s(_vm.card.level ? _vm.card.level.name : '') + "\n        ")])])]), _vm._v(" "), (_vm.card.level) ? _c('div', {
    staticClass: "c-card--tier__right"
  }, [(_vm.card.level.is_top_tier) ? _c('div', {
    staticClass: "c-card--tier__top-tier-details"
  }, [_c('div', {
    staticClass: "c-card---tier__top-tier-details__text"
  }, [_c('div', {
    staticClass: "c-card---tier__top-tier-details__text__message qa-tier-message",
    domProps: {
      "innerHTML": _vm._s(_vm.card.level.message)
    }
  }), _vm._v(" "), (_vm.card.level.link) ? _c('a', {
    staticClass: "c-card---tier__top-tier-details__link u-no-wrap qa-tier-link js-handle-link",
    attrs: {
      "href": _vm.card.level.link.url
    }
  }, [_vm._v("\n            " + _vm._s(_vm.card.level.link.text) + "\n            »\n          ")]) : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "c-card--tier__progress-wrapper"
  }, [(_vm.progressValues) ? _c('h4', {
    staticClass: "c-card--tier__progress-wrapper__left\n                      c-card--tier__progress-value \n                      t-tier-progress-text\n                      qa-tier-progress",
    style: (_vm.levelColor)
  }, [_vm._v("\n            " + _vm._s(_vm.progressValues) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-card--tier__progress-bar"
  }, [_c('div', {
    staticClass: "c-card--tier__progress-bar__progress t-tier-progress-bar",
    style: (_vm.progressBarStyle)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-card---tier__details__text"
  }, [_c('span', {
    staticClass: "c-card---tier__details__text__message qa-tier-message",
    domProps: {
      "innerHTML": _vm._s(_vm.card.level.message)
    }
  }), _vm._v(" "), (_vm.card.level.link) ? _c('a', {
    staticClass: "c-card---tier__details__text__link u-no-wrap qa-tier-link js-handle-link",
    attrs: {
      "href": _vm.card.level.link.url
    }
  }, [_vm._v("\n            " + _vm._s(_vm.card.level.link.text) + "\n            »\n          ")]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loaded) ? _c('loading-icon', {
    staticClass: "c-card c-card--claims-list"
  }) : _c('section', {
    staticClass: "c-card c-card--claims-list"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('i', {
    staticClass: "c-card__header__icon fa fa-inbox t-headline"
  })]), _vm._v(" "), (_vm.approverClaims.length == 0) ? [_c('div', {
    staticClass: "c-card__body t-text-color"
  }, [_c('div', {
    staticClass: "c-card--claims-list__empty"
  }, [_c('i', {
    staticClass: "c-card--claims-list__empty__icon fa fa-thumbs-up"
  }), _vm._v(" "), _c('p', {
    staticClass: "c-card--claims-list__empty__text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_approver.no_claims_to_approve')) + "\n        ")])])])] : _vm._e(), _vm._v(" "), (_vm.approverClaims.length > 0) ? [_c('div', {
    staticClass: "c-card__body c-card--claims-list__body"
  }, [_c('transition', {
    attrs: {
      "name": "fade-and-slide"
    }
  }, [(_vm.claimModalMessage !== null && _vm.claimModalType == 'approver') ? _c('div', {
    ref: "claimToast",
    staticClass: "c-toast t-toast-success"
  }, [_c('p', {
    staticClass: "c-toast__text"
  }, [_vm._v(_vm._s(_vm.claimModalMessage))])]) : _vm._e()]), _vm._v(" "), _c('section', [(_vm.pendingForThisPage.length > 0) ? _c('h2', {
    staticClass: "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_approver.pending_claims')) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pendingForThisPage), function(claim) {
    return _c('div', {
      key: claim.id,
      staticClass: "c-card--claims-list__claim",
      on: {
        "click": function($event) {
          return _vm.showClaim(claim.id)
        }
      }
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info"
    }, [_c('h3', {
      staticClass: "c-card--claims-list__claim__info__pax"
    }, [_vm._v(_vm._s(claim.participant_name))]), _vm._v(" "), _c('div', {
      staticClass: "c-card--claims-list__claim__info__details"
    }, [_c('span', {
      staticClass: "c-card--claims-list__claim__info__details__date"
    }, [_vm._v(_vm._s(claim.created_at))]), _vm._v(" "), _c('span', {
      staticClass: "c-card--claims-list__claim__info__details__form"
    }, [_vm._v(_vm._s(claim.form_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "c-approvals__claim__status"
    }, [_c('button', {
      staticClass: "c-status",
      class: _vm.claimStatusClass(claim)
    }, [_vm._v("\n              " + _vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[claim.status])) + "\n            ")])])])
  })], 2), _vm._v(" "), _c('section', [((_vm.notPendingForThisPage.length > 0) && (_vm.pendingForThisPage.length > 0)) ? _c('h2', {
    staticClass: "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_approver.other_claims')) + "\n        ")]) : _c('div', {
    staticClass: "u-margin-top-15"
  }), _vm._v(" "), _vm._l((_vm.notPendingForThisPage), function(claim) {
    return _c('div', {
      key: claim.id,
      staticClass: "c-card--claims-list__claim",
      on: {
        "click": function($event) {
          return _vm.showClaim(claim.id)
        }
      }
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info"
    }, [_c('h3', {
      staticClass: "c-card--claims-list__claim__info__pax"
    }, [_vm._v(_vm._s(claim.participant_name))]), _vm._v(" "), _c('div', {
      staticClass: "c-card--claims-list__claim__info__details"
    }, [_c('span', {
      staticClass: "c-card--claims-list__claim__info__details__date"
    }, [_vm._v(_vm._s(claim.created_at))]), _vm._v(" "), _c('span', {
      staticClass: "c-card--claims-list__claim__info__details__form"
    }, [_vm._v(_vm._s(claim.form_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "c-approvals__claim__status"
    }, [_c('button', {
      staticClass: "c-status",
      class: _vm.claimStatusClass(claim)
    }, [_vm._v("\n              " + _vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[claim.status])) + "\n            ")])])])
  })], 2)], 1)] : _vm._e(), _vm._v(" "), _c('paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.setPage
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('select', {
    class: 'o-select qa-' + _vm.field.name + '__input',
    attrs: {
      "disabled": _vm.field.readonly,
      "readonly": _vm.field.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.update($event.target.value)
      }
    }
  }, [(!_vm.field.hasNoEmptyOption) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.field.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value,
        "selected": item.value == _vm.value ? 'selected' : ''
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.displayValue) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card c-card--target"
  }) : _c('section', {
    staticClass: "c-card c-card--target t-target"
  }, [_c('div', {
    staticClass: "c-card--target__infographic"
  }, [_c('div', {
    staticClass: "c-card--target__infographic__chart"
  }, [_c('svg', {
    staticClass: "c-card--target__infographic__chart__svg",
    attrs: {
      "viewBox": "-1 -1 2 2"
    }
  }, [_c('circle', {
    staticClass: "c-card--target__infographic__chart__spectrum t-target__spectrum",
    attrs: {
      "cx": "0",
      "cy": "0",
      "r": ".8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "c-card--target__infographic__chart__progress t-target__progress",
    class: _vm.animateGauge,
    attrs: {
      "cx": "0",
      "cy": "0",
      "r": ".8"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--target__infographic__percentage"
  }, [_c('p', {
    staticClass: "c-card--target__infographic__percentage__number t-target__percentage"
  }, [_vm._v(_vm._s(_vm.percentage + '%'))])])]), _vm._v(" "), (_vm.targetAmount !== 0) ? _c('div', {
    staticClass: "c-card--target__details"
  }, [_c('h2', {
    staticClass: "c-card--target__details__title t-headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', {
    staticClass: "c-card--target__details__progress"
  }, [_c('div', {
    staticClass: "c-card--target__details__progress__numerator t-target__numerator",
    class: {
      'c-card--target__details__progress__numerator--currency': _vm.isCurrency
    }
  }, [(_vm.isCurrency) ? _c('span', [_vm._v("$")]) : _vm._e(), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "precision": 0,
      "read-only": true,
      "value": _vm.progressAmount
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-card--target__details__progress__denominator t-target__denominator"
  }, [_c('i', [_vm._v("of")]), _vm._v(" "), (_vm.isCurrency) ? _c('span', [_vm._v("$")]) : _vm._e(), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "precision": 0,
      "read-only": true,
      "value": _vm.targetAmount
    }
  })], 1)])]) : _c('div', {
    staticClass: "c-card--target__details"
  }, [_c('h2', {
    staticClass: "c-card--target__details__title t-headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', {
    staticClass: "c-card--target__details__progress"
  }, [_c('span', {
    staticClass: "c-card--target__details__progress__not-set t-target__numerator"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.card_target.target_not_set')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.template === 'edit' || typeof _vm.template === 'undefined') && !_vm.field.readonly) ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _c('vue-dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-component",
    class: 'qa-' + _vm.field.name + '-field',
    attrs: {
      "id": 'js-dropzone-' + _vm.field.name,
      "options": _vm.dropzoneOptions,
      "destroyDropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved,
      "vdropzone-mounted": _vm.addExistingFiles
    }
  })] : _vm._e(), _vm._v(" "), (_vm.template === 'detail' || _vm.field.readonly) ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.value), function(file) {
    return _c('div', {
      staticClass: "c-uploaded-file"
    }, [_c('span', {
      staticClass: "c-uploaded-file__title"
    }, [_vm._v("\n          " + _vm._s(file.filename) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "c-uploaded-file__buttons u-remove-on-mobile u-remove-on-tablet"
    }, [_c('button', {
      staticClass: "c-uploaded-file__buttons__button t-link",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.showFile(file, true)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.field_file_upload.download_button_desktop')) + "\n          ")]), _vm._v(" "), _c('button', {
      staticClass: "c-uploaded-file__buttons__button t-link",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.showFile(file, false)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.field_file_upload.open_button_desktop')) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "c-uploaded-file__buttons u-remove-on-desktop"
    }, [_c('button', {
      staticClass: "c-uploaded-file__buttons__button t-link",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.showFile(file, true)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.field_file_upload.open_button_mobile')) + "\n          ")])])])
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-category-list__single qa-category"
  }, [_c('div', {
    staticClass: "c-category-list__single__thumb"
  }, [_c('img', {
    staticClass: "o-media c-category-list__single__thumb__img",
    attrs: {
      "src": _vm.thumb
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "c-category-list__single__title t-category-headline"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('img', {
    staticClass: "c-category-list__single__spacer",
    attrs: {
      "src": "/img/thm350.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-rewards-filters"
  }, [_c('fieldset', {
    staticClass: "o-fieldset c-rewards-filters__FIXME-GREGGI-WAN-OCHABI__YOURE-MY-ONLY-HOPE"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.sort_by_label')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.sort),
      expression: "filters.sort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "sort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortOptions), function(option, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset c-rewards-filters__points-range"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.price_range')))]), _vm._v(" "), _c('div', {
    staticClass: "c-rewards-filters__points-range__input-layout"
  }, [_c('span', {
    staticClass: "c-rewards-filters__points-range__input-layout__sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.filter_from_points')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.price_min),
      expression: "filters.price_min"
    }],
    staticClass: "c-rewards-filters__points-range__input-layout__input\n                       qa-rewards-filters-low-price",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('web.catalog_rewards_filters.min_points_placeholder')
    },
    domProps: {
      "value": (_vm.filters.price_min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "price_min", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-rewards-filters__points-range__input-layout__sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.filter_to_points')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.price_max),
      expression: "filters.price_max"
    }],
    staticClass: "c-rewards-filters__points-range__input-layout__input\n                       qa-rewards-filters-high-price",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('web.catalog_rewards_filters.max_points_placeholder')
    },
    domProps: {
      "value": (_vm.filters.price_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "price_max", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.categoriesLoading) ? _c('loading-icon') : _c('div', {
    staticClass: "c-rewards-filters__category-switcher"
  }, [(!_vm.showCategorySwitcher) ? _c('div', {
    staticClass: "c-rewards-filters__category-switcher__default-view"
  }, [_c('label', {
    staticClass: "c-rewards-filters__category-switcher__default-view__label u-label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_rewards_filters.category_label')) + "\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "c-rewards-filters__category-switcher__default-view__title"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedCategoryName) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-rewards-filters__category-switcher__default-view__button\n                  u-button-as-link\n                  t-link\n                  qa-change-category-button",
    on: {
      "click": function($event) {
        return _vm.toggleCategorySwitcher()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_rewards_filters.change_category_link')) + "\n      ")])]) : _c('div', {
    staticClass: "c-rewards-filters__category-switcher__change-category"
  }, [_c('div', {
    staticClass: "c-rewards-filters__category-switcher__change-category__header"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.change_category_link')))]), _vm._v(" "), _c('button', {
    staticClass: "u-button-as-link t-link",
    on: {
      "click": _vm.toggleCategorySwitcher
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filters.cancel_button')) + "\n        ")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "o-radio\n                   o-radio--area-selector\n                   o-radio--no-transitions\n                   c-rewards-filters__category-switcher__change-category__radio-item\n                   qa-category-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.category),
      expression: "filters.category"
    }],
    staticClass: "o-radio__input",
    attrs: {
      "value": "",
      "type": "radio",
      "name": "filterCategory"
    },
    domProps: {
      "checked": _vm._q(_vm.filters.category, "")
    },
    on: {
      "click": _vm.selectCategory,
      "change": function($event) {
        return _vm.$set(_vm.filters, "category", "")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "o-radio__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.no_category')))])]), _vm._v(" "), _vm._l((_vm.$store.getters.categories), function(category) {
    return _c('li', {
      staticClass: "o-radio\n                   o-radio--area-selector\n                   o-radio--no-transitions\n                   c-rewards-filters__category-switcher__change-category__radio-item\n                   qa-category-option"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filters.category),
        expression: "filters.category"
      }],
      staticClass: "o-radio__input",
      attrs: {
        "type": "radio",
        "name": "filterCategory"
      },
      domProps: {
        "value": category.code,
        "checked": _vm._q(_vm.filters.category, category.code)
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(category)
        },
        "change": function($event) {
          return _vm.$set(_vm.filters, "category", category.code)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "o-radio__label"
    }, [_vm._v(_vm._s(_vm.getCategoryName(category)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRewardFilters),
      expression: "showRewardFilters"
    }],
    staticClass: "c-rewards-filters__filter-checkboxes"
  }, [(_vm.filtersLoading) ? _c('loading-icon') : _vm._l((_vm.$store.getters.rewardFilters), function(filter) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (filter.options.length),
        expression: "filter.options.length"
      }]
    }, [_c('label', {
      staticClass: "c-rewards-filters__filter-checkboxes__section-label u-label"
    }, [_vm._v("\n        " + _vm._s(_vm.getFilterName(filter)) + "\n      ")]), _vm._v(" "), _c('ul', _vm._l((filter.options), function(option) {
      return _c('li', {
        staticClass: "o-checkbox\n                   o-checkbox--area-selector\n                   c-rewards-filters__filter-checkboxes__checkbox-item\n                   qa-filter-option"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.filters[_vm.getFiltersKeyFor(filter)]),
          expression: "filters[getFiltersKeyFor(filter)]"
        }],
        staticClass: "o-checkbox__input",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": _vm.getOptionValueFor(option),
          "checked": Array.isArray(_vm.filters[_vm.getFiltersKeyFor(filter)]) ? _vm._i(_vm.filters[_vm.getFiltersKeyFor(filter)], _vm.getOptionValueFor(option)) > -1 : (_vm.filters[_vm.getFiltersKeyFor(filter)])
        },
        on: {
          "change": function($event) {
            var $$a = _vm.filters[_vm.getFiltersKeyFor(filter)],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = _vm.getOptionValueFor(option),
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.filters, _vm.getFiltersKeyFor(filter), $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.filters, _vm.getFiltersKeyFor(filter), $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.filters, _vm.getFiltersKeyFor(filter), $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "o-checkbox__label"
      }, [_vm._v(_vm._s(_vm.getOptionNameFor(option)))])])
    }), 0)])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-4x t-loading-icon"
  })])
}]}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.formattedNumber(_vm.value)) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-navigation"
  }, [_c('div', {
    staticClass: "c-navigation__aux-nav t-navigation-aux",
    class: {
      'is-hidden-on-desktop': _vm.hideAuxNavOnDesktop
    }
  }, [_c('div', {
    staticClass: "c-navigation__aux-nav__inner"
  }, [(_vm.backButton) ? _c('button', {
    staticClass: "c-navigation__aux-nav__button t-navigation-aux__button",
    on: {
      "click": function($event) {
        return _vm.historyBack()
      }
    }
  }, [_c('span', {
    staticClass: "c-navigation__aux-nav__button__icon fa fa-2x fa-chevron-left"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "c-navigation__aux-nav__name"
  }, [_vm._v(_vm._s(_vm.spaceName))])])]), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "c-navigation__main-nav t-navigation qa-main-nav",
    on: {
      "click": function($event) {
        return _vm.togglePointsLedger(false)
      }
    }
  }, [_c('div', {
    staticClass: "c-navigation__main-nav__inner"
  }, [_vm._l((_vm.websiteConfig.left_nav_menu), function(item, index) {
    return [(item.linkType == 'external') ? _c('a', {
      key: index,
      staticClass: "c-navigation__main-nav__link t-navigation__item qa-nav-link",
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_c('i', {
      class: 'c-navigation__main-nav__link__icon ' + item.icon + ' fa-2x'
    }), _vm._v(" "), _c('span', {
      staticClass: "c-navigation__main-nav__link__text"
    }, [_vm._v(_vm._s(item.text))])]) : (_vm.isVisible(item)) ? _c('router-link', {
      key: index,
      staticClass: "c-navigation__main-nav__link t-navigation__item qa-nav-link",
      attrs: {
        "active-class": "t-navigation__item--active",
        "target": item.target,
        "to": _vm.getRouteTo(item)
      }
    }, [_c('i', {
      class: 'c-navigation__main-nav__link__icon ' + item.icon + ' fa-2x'
    }), _vm._v(" "), _c('span', {
      staticClass: "c-navigation__main-nav__link__text"
    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('router-link', {
    staticClass: "c-navigation__logo",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.platformImages.navigation_logo_110,
      "alt": _vm.$t('web.app_navigation.alt_text_logo'),
      "srcset": _vm.platformImages.navigation_logo_110 + ' 110w, ' + _vm.platformImages.navigation_logo_160 + ' 160w, ' +
        _vm.platformImages.navigation_logo_220 + ' 220w, ' + _vm.platformImages.navigation_logo_320 + ' 320w'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "c-navigation__points-indicator"
  }, [(_vm.isLoggedIn) ? _c('a', {
    staticClass: "c-navigation__points-indicator__link t-points-indicator js-points-ledger-trigger",
    on: {
      "click": function($event) {
        return _vm.togglePointsLedger(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star t-points-indicator__icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "t-points-indicator__text"
  }, [_vm._v(_vm._s(typeof _vm.participant !== 'undefined' ? _vm.formatNumber(_vm.participant.points_balance) : ''))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('points-ledger') : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('div', {
    staticClass: "c-navigation__public t-navigation"
  }, [_c('div', {
    staticClass: "c-navigation__public__inner"
  }, [_c('h1', [_c('router-link', {
    staticClass: "c-navigation__public__platform-name t-navigation-aux__text",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v(_vm._s(_vm.websiteConfig.name))])], 1), _vm._v(" "), (_vm.websiteConfig.enrollment_enabled) ? _c('router-link', {
    staticClass: "c-navigation__public__link t-navigation-aux__text",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.app_navigation.signup_link')) + "\n      ")]) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-forgot-password"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.forgot_password.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-forgot-password__main"
  }, [(!_vm.email_sent) ? _c('section', {
    staticClass: "c-card"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.email_label')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card__p"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.email_hint')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.primary_email),
      expression: "request.primary_email"
    }],
    class: {
      'is-not-valid': _vm.errors.primary_email
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('web.forgot_password.email_placeholder'),
      "required": ""
    },
    domProps: {
      "value": (_vm.request.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "primary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.primary_email) ? _c('div', {
    staticClass: "c-validation t-alert-danger",
    attrs: {
      "for": "primary_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errors.primary_email[0]) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('router-link', {
    staticClass: "c-card__footer__text-link u-tiny-note u-float-left t-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.forgot_password.back_to_login')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button u-float-right t-button-primary",
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.forgot_password.send_button')) + "\n          ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.email_sent) ? _c('section', {
    staticClass: "c-card"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('h2', {
    staticClass: "u-h4"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.success_message')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card__p"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.forgot_password.success_message_details')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('i18n', {
    staticClass: "u-tiny-note",
    attrs: {
      "path": "web.forgot_password.success_goto_login",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "login_link",
      fn: function() {
        return [_c('router-link', {
          staticClass: "c-card__footer__text-link u-back-page t-link",
          attrs: {
            "to": {
              name: 'Login'
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$t('web.forgot_password.success_goto_login_link')) + "\n            ")])]
      },
      proxy: true
    }], null, false, 2874701027)
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card c-card--claim-forms"
  }) : _c('div', {
    staticClass: "c-card c-card--claim-forms"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('i', {
    staticClass: "c-card__header__icon fa fa-inbox t-headline"
  })]), _vm._v(" "), (_vm.card.description) ? _c('div', {
    staticClass: "c-card--claim-forms__description"
  }, [_c('p', [_vm._v(_vm._s(_vm.card.description))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.openedForm === null) ? _c('form-list', {
    attrs: {
      "title": _vm.card.title,
      "forms": _vm.formDetails,
      "submitted-form": _vm.submittedForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openedForm !== null) ? _c('form-detail', {
    attrs: {
      "forms": _vm.formDetails,
      "form-index": _vm.openedForm
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-points-record",
    class: {
      'is-expanded': _vm.showNotes
    }
  }, [_c('div', {
    staticClass: "c-points-record__overview"
  }, [_c('div', {
    staticClass: "c-points-record__overview__numbers"
  }, [_c('h5', {
    staticClass: "c-points-record__overview__numbers__date u-number-font"
  }, [_vm._v("\n        " + _vm._s(_vm.pointsRecord.created_at) + "\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "c-points-record__overview__numbers__points u-number-font"
  }, [(_vm.pointsRecord.points > 0) ? _c('span', {
    staticClass: "t-positive"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (_vm.pointsRecord.points < 0) ? _c('span', {
    staticClass: "t-negative"
  }, [_vm._v("-")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.formatNumber(Math.abs(_vm.pointsRecord.points))) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-points-record__overview__headline"
  }, [_c('h4', {
    staticClass: "c-points-record__overview__headline__program"
  }, [(_vm.pointsRecord.source === 'redemption') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$t('web.points_record.order_number', {
    order_number: _vm.pointsRecord.order_number
  })) + "\n        ")]) : (_vm.pointsRecord.source === 'refund') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$t('web.points_record.refund_label')) + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.pointsRecord.program_name) + "\n        ")])]), _vm._v(" "), _c('h5', {
    staticClass: "c-points-record__overview__headline__rule"
  }, [_vm._v("\n        " + _vm._s(!_vm.pointsRecord.order_number ? _vm.pointsRecord.description : '') + "\n      ")]), _vm._v(" "), (_vm.pointsRecord.source === 'refund') ? _c('div', {
    staticClass: "c-points-record__overview__maths"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_record.refund_details', {
    order_number: _vm.pointsRecord.order_number,
    order_notes: _vm.pointsRecord.order_notes
  })) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-points-record__notes"
  }, [(_vm.pointsRecord.notes && _vm.showNotes) ? _c('div', {
    staticClass: "c-points-record__notes__text"
  }, [_c('h5', {
    staticClass: "c-points-record__notes__text__headline"
  }, [_vm._v(_vm._s(_vm.$t('web.points_record.notes_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-small-paragraph"
  }, [_vm._v(_vm._s(_vm.pointsRecord.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-points-record__notes__actions"
  }, [(_vm.pointsRecord.notes) ? _c('button', {
    staticClass: "c-points-record__notes__actions__link t-button-borderless",
    on: {
      "click": _vm.toggleNotes
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_record.notes_toggle')) + "\n        "), _c('span', {
    staticClass: "c-points-record__notes__actions__link__icongroup"
  }, [(!_vm.showNotes) ? _c('i', {
    staticClass: "fa fa-chevron-down is-collapsed"
  }) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('i', {
    staticClass: "fa fa-chevron-up is-expanded"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.pointsRecord.order_number) ? _c('a', {
    staticClass: "c-points-record__notes__actions__link t-button-borderless",
    on: {
      "click": function($event) {
        return _vm.goToPage('MyOrders')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_record.orders_link')) + "\n        "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-account-setup"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.account_setup.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-account-setup__main"
  }, [(_vm.setupSuccess) ? _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.account_setup.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('div', {
    staticClass: "u-paragraph s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.setup.text)
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "primary_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.primary_email_label')) + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.primary_email),
      expression: "request.primary_email"
    }],
    attrs: {
      "id": "primary_email",
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.request.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "primary_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [(_vm.showLocales) ? _c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "locale"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.locale_label')) + "*\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showLocales) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.locale),
      expression: "request.locale"
    }],
    class: {
      'is-not-valid': _vm.errors.last_name
    },
    attrs: {
      "id": "locale",
      "text": "Select locale",
      "name": "locale"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.request, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      key: locale.locale,
      domProps: {
        "value": locale.locale
      }
    }, [_vm._v("\n                " + _vm._s(locale.name) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.new_password_label')) + " *\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "u-tiny-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('web.account_setup.new_password_minimum_12_characters')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.account_setup.new_password_minimum_1_number')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_symbol')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.account_setup.new_password_minimum_1_uppercase')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password),
      expression: "request.password"
    }],
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.confirm_new_password_label')) + " *\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password_confirmation),
      expression: "request.password_confirmation"
    }],
    attrs: {
      "id": "password_confirmation",
      "type": "password",
      "placeholder": "",
      "name": "password_confirmation",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.password_confirmation), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _vm._l((_vm.setup.fields), function(field) {
    return [_c('fieldset', {
      key: field.name,
      staticClass: "o-fieldset c-card--submit-claim__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      staticClass: "u-label",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "name": field.name
      },
      model: {
        value: (_vm.request[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.request, field.name, $$v)
        },
        expression: "request[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', {
        key: error
      }, [_c('div', {
        staticClass: "c-validation t-alert-danger"
      }, [_vm._v(_vm._s(error))])])
    })], 2)]
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('div', {
    staticClass: "o-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.terms_and_conditions),
      expression: "request.terms_and_conditions"
    }],
    class: 'o-checkbox__input',
    attrs: {
      "id": "terms_and_conditions",
      "type": "checkbox",
      "name": "terms_and_conditions",
      "required": ""
    },
    domProps: {
      "checked": _vm.request.terms_and_conditions ? 'checked' : '',
      "checked": Array.isArray(_vm.request.terms_and_conditions) ? _vm._i(_vm.request.terms_and_conditions, null) > -1 : (_vm.request.terms_and_conditions)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.request.terms_and_conditions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.request, "terms_and_conditions", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.request, "terms_and_conditions", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.request, "terms_and_conditions", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i18n', {
    staticClass: "o-checkbox__label",
    attrs: {
      "path": "web.account_setup.accept_terms",
      "tag": "label"
    },
    scopedSlots: _vm._u([{
      key: "terms_link",
      fn: function() {
        return [_c('a', {
          staticClass: "t-link",
          attrs: {
            "href": _vm.setup.terms_link,
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              return _vm.openLink($event)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.$t('web.account_setup.accept_terms_link')) + "\n                    ")])]
      },
      proxy: true
    }], null, false, 3641884939)
  }), _vm._v(" "), _vm._l((_vm.errors.terms_and_conditions), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger u-round-corners"
    }, [_vm._v(_vm._s(error))])])
  })], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('button', {
    staticClass: "c-button c-button--full-width t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.account_setup.signup_button')) + "\n          ")])])])]) : _vm._e(), _vm._v(" "), (!_vm.setupSuccess) ? _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('div', {
    staticClass: "c-card__inner"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.account_setup.error_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('p', {
    staticClass: "c-card__paragraph"
  }, [_vm._v(_vm._s(_vm.setupSuccessMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [(_vm.codeResponse === 'user.setup') ? _c('router-link', {
    staticClass: "c-card__footer__text-link u-tiny-note u-float-left t-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.account_setup.error_login_link')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.codeResponse === 'user.token') ? _c('button', {
    staticClass: "c-button c-button--full-width t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.resend($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.account_setup.resend_setup_email_button')) + "\n          ")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "maxlength": _vm.maxlength,
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "maxlength": _vm.maxlength,
      "type": "text",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-points-ledger js-points-ledger is-hidden"
  }, [_c('div', {
    staticClass: "c-points-ledger__inner"
  }, [_c('div', {
    staticClass: "c-points-ledger__header t-modal-header"
  }, [_c('h2', {
    staticClass: "c-points-ledger__header__title t-modal-header__text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_ledger.modal_title')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__header__close"
  }, [_c('button', {
    staticClass: "c-points-ledger__header__close__button t-modal-header__close",
    on: {
      "click": function($event) {
        return _vm.togglePointsLedger(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__summary"
  }, [_c('div', {
    staticClass: "c-points-ledger__summary__balance"
  }, [_c('h3', {
    staticClass: "c-points-ledger__summary__balance__headline"
  }, [_vm._v(_vm._s(_vm.$t('web.points_ledger.points_balance_label')))]), _vm._v(" "), _c('p', {
    staticClass: "c-points-ledger__summary__balance__headline__number u-number-font"
  }, [_vm._v("\n          " + _vm._s(typeof _vm.participant !== 'undefined' ? _vm.formatNumber(_vm.participant.points_balance) : '') + "\n        ")])]), _vm._v(" "), (typeof _vm.participant !== 'undefined' ? _vm.participant.catalog_is_enabled : false) ? _c('div', {
    staticClass: "c-points-ledger__summary__redeem"
  }, [_c('button', {
    staticClass: "c-points-ledger__redeem-button",
    on: {
      "click": function($event) {
        return _vm.goToPage('Rewards')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.points_ledger.redeem_button')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__body"
  }, [_vm._l((_vm.points.data), function(pointsRecord) {
    return _c('div', {
      key: pointsRecord.id
    }, [_c('point-record', {
      attrs: {
        "points-record": pointsRecord
      }
    })], 1)
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.points.total > 0),
      expression: "points.total > 0"
    }],
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.paginatePoints
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--reward-order t-modal is-visible"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--reward-order__box"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('h1', {
    staticClass: "c-modal--reward-order__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_confirmation.sucess_message')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__confirmation-message u-paragraph u-center-text"
  }, [_vm._v(_vm._s(_vm.orderConfirmationMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__actions"
  }, [_c('button', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-plain",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_confirmation.back_button')) + "\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-primary",
    attrs: {
      "to": {
        name: 'MyOrders'
      },
      "tag": "button"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_confirmation.my_orders_link')) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orders.orders !== null && Object.keys(_vm.orders.orders).length > 0) ? _c('div', [_vm._l((_vm.orders.orders), function(order, i) {
    return _c('section', {
      key: i,
      staticClass: "c-card--orders__single"
    }, [(order.source == 'Catalog') ? _c('cat-order-card', {
      attrs: {
        "order": order
      }
    }) : _c('ro-order-card', {
      attrs: {
        "order": order
      }
    })], 1)
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "pagination": _vm.getPagination,
      "pagingCallback": _vm.fetchOrderCallback
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--claim-details"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--claim-details__box"
  }, [_c('div', {
    staticClass: "c-modal__box__header t-modal-header"
  }, [(_vm.type === 'approver') ? _c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.approver_header')))]) : _vm._e(), _vm._v(" "), (_vm.type === 'submitter') ? _c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.submitter_header')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__header__close"
  }, [_c('button', {
    staticClass: "c-modal__box__header__close__button t-modal-header__close",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__content"
  }, [(_vm.type === 'approver') ? _c('div', {
    staticClass: "c-modal--claim-details__headline"
  }, [_c('h1', {
    staticClass: "c-modal--claim-details__headline__claim-number"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_number', {
    claim_number: _vm.claim.record_number
  })))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__headline__claim-status"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.claimStatusClass(_vm.claim)
  }, [_vm._v(_vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[_vm.claim.status])))])])]) : _c('div', {
    staticClass: "c-modal--claim-details__headline c-modal--claim-details__headline--submitter"
  }, [_c('h1', {
    staticClass: "c-modal--claim-details__headline__claim-number"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_number', {
    claim_number: _vm.claim.record_number
  })))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__headline__claim-status"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.claimStatusClass(_vm.claim)
  }, [_vm._v(_vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[_vm.claim.status])))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__overview",
    class: [{
      'c-modal--claim-details__overview--submitter': _vm.type === 'submitter'
    }]
  }, [_c('dl', {
    staticClass: "c-modal--claim-details__overview__dl"
  }, [_c('dt', {
    staticClass: "c-modal--claim-details__overview__dl__dt"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_submitted')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-modal--claim-details__overview__dl__dd"
  }, [_vm._v(_vm._s(_vm.claim.created_at))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--claim-details__overview__dl"
  }, [_c('dt', {
    staticClass: "c-modal--claim-details__overview__dl__dt"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_form_name')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-modal--claim-details__overview__dl__dd"
  }, [_vm._v(_vm._s(_vm.claim.form_name))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--claim-details__overview__dl"
  }, [_c('dt', {
    staticClass: "c-modal--claim-details__overview__dl__dt"
  }, [_vm._v("\n            " + _vm._s(_vm.type === 'approver' ? _vm.$t('web.claim_details_modal.claim_submitter') : _vm.$t('web.claim_details_modal.claim_approver')) + "\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "c-modal--claim-details__overview__dl__dd"
  }, [_c('span', [_vm._v(_vm._s(_vm.type === 'approver' ? _vm.claim.participant_name : _vm.claim.approver_name))]), _vm._v(" "), (_vm.type === 'submitter') ? _c('button', {
    staticClass: "c-modal--claim-details__overview--submitter__toggle-notes",
    on: {
      "click": function($event) {
        return _vm.toggleNotes()
      }
    }
  }, [_vm._v(_vm._s(_vm.notesMessage) + "\n            ")]) : _vm._e()])])]), _vm._v(" "), ((_vm.type === 'submitter')) ? _c('div', {
    staticClass: "c-modal--claim-details__submitter-view-notes",
    class: [{
      'is-visible': _vm.showNotes
    }, {
      'is-hidden': !_vm.showNotes
    }]
  }, [(_vm.claim.approver_notes) ? _c('div', {
    staticClass: "c-modal--claim-details__submitter-view-notes__bubble",
    domProps: {
      "innerHTML": _vm._s(_vm.formatNotes)
    }
  }) : _c('div', {
    staticClass: "c-modal--claim-details__submitter-view-notes__bubble"
  }, [_c('p', {
    staticClass: "c-modal--claim-details__notes-paragraph u-italic"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.no_approver_notes')))])])]) : _vm._e(), _vm._v(" "), (_vm.claim.field_defs) ? _c('div', {
    ref: "formDef",
    staticClass: "c-modal--claim-details__details"
  }, _vm._l((_vm.claim.field_defs), function(field, index) {
    return _c('fieldset', {
      key: index,
      staticClass: "o-fieldset c-modal--claim-details__details__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "template": _vm.type === 'submitter' && _vm.claim.status === _vm.CLAIM_STATUS.UPDATE_NEEDED ? 'edit' : 'detail',
        "labelClass": "c-modal--claim-details__details__fieldset__label"
      },
      model: {
        value: (_vm.claim.field_values[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.claim.field_values, field.name, $$v)
        },
        expression: "claim.field_values[field.name]"
      }
    }), _vm._v(" "), (_vm.errors[field.name]) ? _c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v("\n                  " + _vm._s(_vm.errors[field.name]) + "\n             ")]) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type === 'approver') ? _c('div', {
    staticClass: "c-modal--claim-details__approver-view-notes"
  }, [_c('h2', {
    staticClass: "c-modal--claim-details__approver-view-notes__header"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_notes_label')))]), _vm._v(" "), (_vm.claim.status === _vm.CLAIM_STATUS.PENDING) ? _c('p', {
    staticClass: "c-modal--claim-details__approver-view-notes__desc"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.claim_notes_hint')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.claim.status === _vm.CLAIM_STATUS.PENDING) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claim.approver_notes),
      expression: "claim.approver_notes"
    }],
    staticClass: "o-textarea c-modal--claim-details__approver-view-notes__textarea",
    domProps: {
      "value": (_vm.claim.approver_notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.claim, "approver_notes", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.claim.approver_notes && _vm.claim.status !== _vm.CLAIM_STATUS.PENDING)) ? _c('div', {
    staticClass: "c-modal--claim-details__approver-view-notes__text",
    domProps: {
      "innerHTML": _vm._s(_vm.formatNotes)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.type === 'approver' && _vm.claim.status === _vm.CLAIM_STATUS.PENDING) ? _c('div', {
    staticClass: "c-modal__box__actions"
  }, [_c('button', {
    staticClass: "c-modal__box__actions__button t-button-info",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.approverUpdate(_vm.CLAIM_STATUS.DECLINED)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.decline_claim_button')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-modal__box__actions__button t-button-danger",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.approverUpdate(_vm.CLAIM_STATUS.UPDATE_NEEDED)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.update_needed_button')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-modal__box__actions__button t-button-success",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.approverUpdate(_vm.CLAIM_STATUS.APPROVED)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.approve_claim_button')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'submitter' && _vm.claim.status === _vm.CLAIM_STATUS.UPDATE_NEEDED) ? _c('div', {
    staticClass: "c-modal__box__actions c-modal--claim-details__box__actions"
  }, [_c('div', {
    staticClass: "c-modal--claim-details__box__actions__right"
  }, [_c('button', {
    ref: "cancelButton",
    staticClass: "c-modal__box__actions__button t-button-plain",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.cancel_submission_button')) + "\n        ")]), _vm._v(" "), _c('button', {
    ref: "submitButton",
    staticClass: "c-modal__box__actions__button c-modal--claim-details__submitter-submit-button t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.submit_updates_button')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__box__actions__left"
  }, [_c('button', {
    ref: "withdrawButton",
    staticClass: "c-modal__box__actions__button t-button-danger",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.withdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.withdraw_claim_button')) + "\n        ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-page"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.currentSpace
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-page__main"
  }, [_vm._l((_vm.page.layout), function(card) {
    return [(typeof _vm.cards[card.id] !== 'undefined') ? _c('card-' + _vm.cards[card.id].type, {
      key: card.id,
      tag: "component",
      attrs: {
        "card": _vm.cards[card.id]
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[261]);


// WEBPACK FOOTER //
// js/app.44b0e0451894b4f5f095.js